import Ln from "p-memoize";
import { filters as jf, helpers as Jf, render as Qf, getConfig as bf } from "squirrelly";
import $f from "cross-fetch";
function gu({ canvas: s, scenes: A, currentTime: w }) {
  if (A && s) {
    const y = A.scenes.filter(({ start: m, duration: G }) => w >= m && w <= m + G);
    if (y.length <= 0)
      return;
    const d = s.getContext("2d");
    if (d) {
      const m = A.transitionDuration, G = Math.max(...A.scenes.map(({ start: X, duration: L }) => X + L));
      d.globalCompositeOperation = "lighter", d.clearRect(0, 0, s.width, s.height), y.forEach(({ start: X, duration: L, draw: J, transitionCanvas: q }) => {
        if (d.globalAlpha = 1, q.width = q.height = 0, q.width = s.width, q.height = s.height, q.getContext("2d")) {
          const k0 = X + L, $ = X === 0, M0 = k0 === G;
          J({
            currentTime: w,
            canvas: q
          }), !$ && w >= X && w <= X + m ? d.globalAlpha = Math.max(0, Math.min(1, (w - X) / m)) : !M0 && w >= k0 - m && w <= k0 && (d.globalAlpha = Math.max(0, Math.min(1, (k0 - w) / m))), d.drawImage(q, 0, 0, s.width, s.height);
        }
      });
    }
  }
}
function Kf(s) {
  if (typeof s == "string") {
    const [A, w] = s.split(":");
    return Math.min(parseFloat(A), parseFloat(w));
  }
  return s;
}
function qf(s) {
  if (typeof s == "string") {
    const [A, w] = s.split(":"), y = parseFloat(A), d = parseFloat(w);
    return y / d;
  }
  return s;
}
function es({ resolution: s, aspectRatio: A }) {
  const w = Kf(s), y = qf(A), d = y >= 1, m = Math.min(
    d ? w * y : w / y,
    w
  ), G = Math.max(
    d ? w * y : w / y,
    w
  );
  return {
    resolution: w,
    aspectRatio: y,
    height: d ? m : G,
    width: d ? G : m
  };
}
function ts({ format: s, resolution: A, aspectRatio: w, sourceWidth: y, sourceHeight: d }) {
  const { width: m, height: G } = es({ resolution: A, aspectRatio: w }), X = y / d, L = w > X;
  let J = 1;
  if (s === "letterbox" || s === "letterbox-video")
    J = L ? G / d : m / y;
  else if (s === "squarebox") {
    const M0 = Math.min(G, m);
    J = y >= d ? M0 / d : M0 / y;
  } else
    s === "crop" && (J = L ? m / y : G / d);
  const q = m / J, u0 = G / J, k0 = (y - q) / 2, $ = (d - u0) / 2;
  return {
    sx: k0,
    sy: $,
    sWidth: q,
    sHeight: u0,
    scale: J
  };
}
function mt({ source: s, sx: A, sy: w, sw: y, sh: d, dx: m, dy: G, dw: X, dh: L }) {
  const J = (s == null ? void 0 : s.naturalWidth) ?? (s == null ? void 0 : s.videoWidth) ?? (s == null ? void 0 : s.width), q = (s == null ? void 0 : s.naturalHeight) ?? (s == null ? void 0 : s.videoHeight) ?? (s == null ? void 0 : s.height);
  A = A ?? 0, w = w ?? 0, y = y ?? J, d = d ?? q, y < 0 && (A += y, y = Math.abs(y)), d < 0 && (w += d, d = Math.abs(d)), X < 0 && (m += X, X = Math.abs(X)), L < 0 && (G += L, L = Math.abs(L));
  const u0 = Math.max(A, 0), k0 = Math.min(A + y, J), $ = Math.max(w, 0), M0 = Math.min(w + d, q), o0 = X / y, q0 = L / d;
  return [
    s,
    u0,
    $,
    k0 - u0,
    M0 - $,
    A < 0 ? m - A * o0 : m,
    w < 0 ? G - w * q0 : G,
    (k0 - u0) * o0,
    (M0 - $) * q0
  ];
}
function Zn({
  context: s,
  source: A,
  crop: w,
  format: y = "letterbox",
  posX: d,
  posY: m,
  drawAreaWidth: G,
  drawAreaHeight: X,
  sourceWidth: L,
  sourceHeight: J,
  cropCanvas: q,
  letterboxCanvas: u0
}) {
  const { x: k0, y: $, width: M0, height: o0 } = w ?? {}, q0 = L * (k0 ?? 0), j2 = J * ($ ?? 0), _0 = L * Math.min(1 - (k0 ?? 0), M0 ?? 1), Y0 = J * Math.min(1 - ($ ?? 0), o0 ?? 1), R2 = q.getContext("2d");
  if (R2) {
    q.width = _0, q.height = Y0;
    const n0 = mt({
      source: A,
      sx: q0,
      sy: j2,
      sw: _0,
      sh: Y0,
      dx: 0,
      dy: 0,
      dw: _0,
      dh: Y0
    });
    R2.drawImage(...n0);
  }
  const f2 = _0 / Y0, { sx: N0, sy: h0, sWidth: R0, sHeight: S0, scale: I0 } = ts({
    resolution: Math.min(G, X),
    aspectRatio: G / X,
    format: y,
    sourceWidth: _0,
    sourceHeight: Y0
  }), C0 = q && typeof s.filter < "u";
  if (y === "letterbox" || y === "squarebox" || y === "letterbox-video" && !C0) {
    if (N0 < 0) {
      const n0 = Math.abs(N0) * I0;
      s.fillStyle = "black", s.beginPath(), s.rect(d, m, n0, X), s.rect(d + G - n0, m, n0, X), s.fill(), s.closePath();
    }
    if (h0 < 0) {
      const n0 = Math.abs(h0) * I0;
      s.fillStyle = "black", s.beginPath(), s.rect(d, m, G, n0), s.rect(d, m + X - n0, G, n0), s.fill(), s.closePath();
    }
  }
  if (y === "letterbox-video" && C0) {
    const n0 = u0.getContext("2d");
    if (n0) {
      u0.width = _0, u0.height = Y0, s.save(), s.globalCompositeOperation = "destination-out", s.fillRect(d, m, G, X);
      const k2 = mt({
        source: q,
        sx: N0,
        sy: h0,
        sw: R0,
        sh: S0,
        dx: d,
        dy: m,
        dw: G,
        dh: X
      });
      s.globalCompositeOperation = "source-over", s.drawImage(...k2), n0.save();
      const x0 = 1.2, D0 = -(_0 * x0 - _0) / 2, g2 = -(Y0 * x0 - Y0) / 2, a2 = Math.min(_0 / 20, Y0 / 20);
      if (n0.filter = `blur(${a2}px) brightness(20%)`, n0.translate(D0, g2), n0.scale(x0, x0), n0.drawImage(q, 0, 0, _0, Y0), n0.restore(), s.globalCompositeOperation = "destination-over", N0 < 0) {
        const h2 = G / f2, J0 = X / h2, V2 = mt({
          source: u0,
          sy: (1 - J0) * Y0 / 2,
          sh: J0 * Y0,
          dx: d,
          dy: m,
          dw: G,
          dh: X
        });
        s.drawImage(...V2);
      }
      if (h0 < 0) {
        const h2 = X * f2, J0 = G / h2, V2 = mt({
          source: u0,
          sx: (1 - J0) * _0 / 2,
          sw: J0 * _0,
          dx: d,
          dy: m,
          dw: G,
          dh: X
        });
        s.drawImage(...V2);
      }
      s.restore();
    }
  } else {
    const n0 = mt({
      source: q,
      sx: N0,
      sy: h0,
      sw: R0,
      sh: S0,
      dx: d,
      dy: m,
      dw: G,
      dh: X
    });
    s.drawImage(...n0);
  }
  const o2 = N0 * -1 * I0, A0 = h0 * -1 * I0, w0 = G - o2 * 2, p0 = X - A0 * 2;
  return {
    dx: o2,
    dy: A0,
    dw: w0,
    dh: p0
  };
}
const rs = (s, A, w, y) => {
  if (w === "length" || w === "prototype" || w === "arguments" || w === "caller")
    return;
  const d = Object.getOwnPropertyDescriptor(s, w), m = Object.getOwnPropertyDescriptor(A, w);
  !is(d, m) && y || Object.defineProperty(s, w, m);
}, is = function(s, A) {
  return s === void 0 || s.configurable || s.writable === A.writable && s.enumerable === A.enumerable && s.configurable === A.configurable && (s.writable || s.value === A.value);
}, ns = (s, A) => {
  const w = Object.getPrototypeOf(A);
  w !== Object.getPrototypeOf(s) && Object.setPrototypeOf(s, w);
}, os = (s, A) => `/* Wrapped ${s}*/
${A}`, fs = Object.getOwnPropertyDescriptor(Function.prototype, "toString"), ss = Object.getOwnPropertyDescriptor(Function.prototype.toString, "name"), us = (s, A, w) => {
  const y = w === "" ? "" : `with ${w.trim()}() `, d = os.bind(null, y, A.toString());
  Object.defineProperty(d, "name", ss), Object.defineProperty(s, "toString", { ...fs, value: d });
};
function as(s, A, { ignoreNonConfigurable: w = !1 } = {}) {
  const { name: y } = s;
  for (const d of Reflect.ownKeys(A))
    rs(s, A, d, w);
  return ns(s, A), us(s, A, y), s;
}
const ls = /* @__PURE__ */ new WeakMap(), Gn = /* @__PURE__ */ new WeakMap();
function qr(s, { cacheKey: A, cache: w = /* @__PURE__ */ new Map(), maxAge: y } = {}) {
  if (y === 0)
    return s;
  if (typeof y == "number") {
    if (y > 2147483647)
      throw new TypeError("The `maxAge` option cannot exceed 2147483647.");
    if (y < 0)
      throw new TypeError("The `maxAge` option should not be a negative number.");
  }
  const d = function(...m) {
    var J;
    const G = A ? A(m) : m[0], X = w.get(G);
    if (X)
      return X.data;
    const L = s.apply(this, m);
    if (w.set(G, {
      data: L,
      maxAge: y ? Date.now() + y : Number.POSITIVE_INFINITY
    }), typeof y == "number" && y !== Number.POSITIVE_INFINITY) {
      const q = setTimeout(() => {
        w.delete(G);
      }, y);
      (J = q.unref) == null || J.call(q);
      const u0 = Gn.get(s) ?? /* @__PURE__ */ new Set();
      u0.add(q), Gn.set(s, u0);
    }
    return L;
  };
  return as(d, s, {
    ignoreNonConfigurable: !0
  }), ls.set(d, w), d;
}
function In({ context: s, word: A, maxW: w = 1 / 0 }) {
  const y = [], d = s.measureText(A);
  if (d.width < w)
    return [{ text: A, metrics: d }];
  for (let m = 0; m < A.length; m++) {
    const G = y[y.length - 1], X = ((G == null ? void 0 : G.text) ?? "") + A[m], L = s.measureText(X);
    L.width < w ? y[G ? y.length - 1 : 0] = {
      text: X,
      metrics: L
    } : y.push({ text: A[m], metrics: s.measureText(A[m]) });
  }
  return y;
}
const Tn = qr(
  ({ font: s, scale: A, context: w, maxW: y, maxH: d, text: m, minSize: G, maxSize: X }) => {
    var J, q;
    let L = 0;
    if (X) {
      L = (G ?? 0) * A;
      let k0 = 0;
      for (; X * A > L + 1; ) {
        L += 1;
        const $ = fr({ context: w, font: s, fontSize: L, text: m, maxW: y });
        if (k0 = $.reduce((M0, o0) => (o0.metrics.width > M0 && (M0 = o0.metrics.width), M0), 0), k0 > y || $.length * L > d) {
          L -= 1;
          break;
        }
      }
    } else
      L = parseFloat(((q = (J = s.match(or)) == null ? void 0 : J.groups) == null ? void 0 : q.value) ?? "0") * A;
    return L;
  },
  {
    cacheKey: ([{ font: s, text: A, minSize: w, maxSize: y, scale: d, maxW: m, maxH: G }]) => `${s}_${A}_${w}_${y}_${d}_${m}_${G}`
  }
);
function cs(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
var P0 = {}, ei = {}, g0 = {};
Object.defineProperty(g0, "__esModule", {
  value: !0
});
g0.default = g0.Wrap = g0.Unit = g0.PrintOptions = g0.PositionType = g0.Overflow = g0.NodeType = g0.MeasureMode = g0.LogLevel = g0.Justify = g0.Gutter = g0.FlexDirection = g0.ExperimentalFeature = g0.Errata = g0.Edge = g0.Display = g0.Direction = g0.Dimension = g0.Align = void 0;
let de = /* @__PURE__ */ function(s) {
  return s[s.Auto = 0] = "Auto", s[s.FlexStart = 1] = "FlexStart", s[s.Center = 2] = "Center", s[s.FlexEnd = 3] = "FlexEnd", s[s.Stretch = 4] = "Stretch", s[s.Baseline = 5] = "Baseline", s[s.SpaceBetween = 6] = "SpaceBetween", s[s.SpaceAround = 7] = "SpaceAround", s;
}({});
g0.Align = de;
let Yr = /* @__PURE__ */ function(s) {
  return s[s.Width = 0] = "Width", s[s.Height = 1] = "Height", s;
}({});
g0.Dimension = Yr;
let Qt = /* @__PURE__ */ function(s) {
  return s[s.Inherit = 0] = "Inherit", s[s.LTR = 1] = "LTR", s[s.RTL = 2] = "RTL", s;
}({});
g0.Direction = Qt;
let Dr = /* @__PURE__ */ function(s) {
  return s[s.Flex = 0] = "Flex", s[s.None = 1] = "None", s;
}({});
g0.Display = Dr;
let le = /* @__PURE__ */ function(s) {
  return s[s.Left = 0] = "Left", s[s.Top = 1] = "Top", s[s.Right = 2] = "Right", s[s.Bottom = 3] = "Bottom", s[s.Start = 4] = "Start", s[s.End = 5] = "End", s[s.Horizontal = 6] = "Horizontal", s[s.Vertical = 7] = "Vertical", s[s.All = 8] = "All", s;
}({});
g0.Edge = le;
let vt = /* @__PURE__ */ function(s) {
  return s[s.None = 0] = "None", s[s.StretchFlexBasis = 1] = "StretchFlexBasis", s[s.All = 2147483647] = "All", s[s.Classic = 2147483646] = "Classic", s;
}({});
g0.Errata = vt;
let bt = /* @__PURE__ */ function(s) {
  return s[s.WebFlexBasis = 0] = "WebFlexBasis", s[s.AbsolutePercentageAgainstPaddingEdge = 1] = "AbsolutePercentageAgainstPaddingEdge", s[s.FixJNILocalRefOverflows = 2] = "FixJNILocalRefOverflows", s;
}({});
g0.ExperimentalFeature = bt;
let gt = /* @__PURE__ */ function(s) {
  return s[s.Column = 0] = "Column", s[s.ColumnReverse = 1] = "ColumnReverse", s[s.Row = 2] = "Row", s[s.RowReverse = 3] = "RowReverse", s;
}({});
g0.FlexDirection = gt;
let $t = /* @__PURE__ */ function(s) {
  return s[s.Column = 0] = "Column", s[s.Row = 1] = "Row", s[s.All = 2] = "All", s;
}({});
g0.Gutter = $t;
let ze = /* @__PURE__ */ function(s) {
  return s[s.FlexStart = 0] = "FlexStart", s[s.Center = 1] = "Center", s[s.FlexEnd = 2] = "FlexEnd", s[s.SpaceBetween = 3] = "SpaceBetween", s[s.SpaceAround = 4] = "SpaceAround", s[s.SpaceEvenly = 5] = "SpaceEvenly", s;
}({});
g0.Justify = ze;
let Ue = /* @__PURE__ */ function(s) {
  return s[s.Error = 0] = "Error", s[s.Warn = 1] = "Warn", s[s.Info = 2] = "Info", s[s.Debug = 3] = "Debug", s[s.Verbose = 4] = "Verbose", s[s.Fatal = 5] = "Fatal", s;
}({});
g0.LogLevel = Ue;
let Kt = /* @__PURE__ */ function(s) {
  return s[s.Undefined = 0] = "Undefined", s[s.Exactly = 1] = "Exactly", s[s.AtMost = 2] = "AtMost", s;
}({});
g0.MeasureMode = Kt;
let jr = /* @__PURE__ */ function(s) {
  return s[s.Default = 0] = "Default", s[s.Text = 1] = "Text", s;
}({});
g0.NodeType = jr;
let qt = /* @__PURE__ */ function(s) {
  return s[s.Visible = 0] = "Visible", s[s.Hidden = 1] = "Hidden", s[s.Scroll = 2] = "Scroll", s;
}({});
g0.Overflow = qt;
let er = /* @__PURE__ */ function(s) {
  return s[s.Static = 0] = "Static", s[s.Relative = 1] = "Relative", s[s.Absolute = 2] = "Absolute", s;
}({});
g0.PositionType = er;
let tr = /* @__PURE__ */ function(s) {
  return s[s.Layout = 1] = "Layout", s[s.Style = 2] = "Style", s[s.Children = 4] = "Children", s;
}({});
g0.PrintOptions = tr;
let yt = /* @__PURE__ */ function(s) {
  return s[s.Undefined = 0] = "Undefined", s[s.Point = 1] = "Point", s[s.Percent = 2] = "Percent", s[s.Auto = 3] = "Auto", s;
}({});
g0.Unit = yt;
let rr = /* @__PURE__ */ function(s) {
  return s[s.NoWrap = 0] = "NoWrap", s[s.Wrap = 1] = "Wrap", s[s.WrapReverse = 2] = "WrapReverse", s;
}({});
g0.Wrap = rr;
const ks = {
  ALIGN_AUTO: de.Auto,
  ALIGN_FLEX_START: de.FlexStart,
  ALIGN_CENTER: de.Center,
  ALIGN_FLEX_END: de.FlexEnd,
  ALIGN_STRETCH: de.Stretch,
  ALIGN_BASELINE: de.Baseline,
  ALIGN_SPACE_BETWEEN: de.SpaceBetween,
  ALIGN_SPACE_AROUND: de.SpaceAround,
  DIMENSION_WIDTH: Yr.Width,
  DIMENSION_HEIGHT: Yr.Height,
  DIRECTION_INHERIT: Qt.Inherit,
  DIRECTION_LTR: Qt.LTR,
  DIRECTION_RTL: Qt.RTL,
  DISPLAY_FLEX: Dr.Flex,
  DISPLAY_NONE: Dr.None,
  EDGE_LEFT: le.Left,
  EDGE_TOP: le.Top,
  EDGE_RIGHT: le.Right,
  EDGE_BOTTOM: le.Bottom,
  EDGE_START: le.Start,
  EDGE_END: le.End,
  EDGE_HORIZONTAL: le.Horizontal,
  EDGE_VERTICAL: le.Vertical,
  EDGE_ALL: le.All,
  ERRATA_NONE: vt.None,
  ERRATA_STRETCH_FLEX_BASIS: vt.StretchFlexBasis,
  ERRATA_ALL: vt.All,
  ERRATA_CLASSIC: vt.Classic,
  EXPERIMENTAL_FEATURE_WEB_FLEX_BASIS: bt.WebFlexBasis,
  EXPERIMENTAL_FEATURE_ABSOLUTE_PERCENTAGE_AGAINST_PADDING_EDGE: bt.AbsolutePercentageAgainstPaddingEdge,
  EXPERIMENTAL_FEATURE_FIX_JNILOCAL_REF_OVERFLOWS: bt.FixJNILocalRefOverflows,
  FLEX_DIRECTION_COLUMN: gt.Column,
  FLEX_DIRECTION_COLUMN_REVERSE: gt.ColumnReverse,
  FLEX_DIRECTION_ROW: gt.Row,
  FLEX_DIRECTION_ROW_REVERSE: gt.RowReverse,
  GUTTER_COLUMN: $t.Column,
  GUTTER_ROW: $t.Row,
  GUTTER_ALL: $t.All,
  JUSTIFY_FLEX_START: ze.FlexStart,
  JUSTIFY_CENTER: ze.Center,
  JUSTIFY_FLEX_END: ze.FlexEnd,
  JUSTIFY_SPACE_BETWEEN: ze.SpaceBetween,
  JUSTIFY_SPACE_AROUND: ze.SpaceAround,
  JUSTIFY_SPACE_EVENLY: ze.SpaceEvenly,
  LOG_LEVEL_ERROR: Ue.Error,
  LOG_LEVEL_WARN: Ue.Warn,
  LOG_LEVEL_INFO: Ue.Info,
  LOG_LEVEL_DEBUG: Ue.Debug,
  LOG_LEVEL_VERBOSE: Ue.Verbose,
  LOG_LEVEL_FATAL: Ue.Fatal,
  MEASURE_MODE_UNDEFINED: Kt.Undefined,
  MEASURE_MODE_EXACTLY: Kt.Exactly,
  MEASURE_MODE_AT_MOST: Kt.AtMost,
  NODE_TYPE_DEFAULT: jr.Default,
  NODE_TYPE_TEXT: jr.Text,
  OVERFLOW_VISIBLE: qt.Visible,
  OVERFLOW_HIDDEN: qt.Hidden,
  OVERFLOW_SCROLL: qt.Scroll,
  POSITION_TYPE_STATIC: er.Static,
  POSITION_TYPE_RELATIVE: er.Relative,
  POSITION_TYPE_ABSOLUTE: er.Absolute,
  PRINT_OPTIONS_LAYOUT: tr.Layout,
  PRINT_OPTIONS_STYLE: tr.Style,
  PRINT_OPTIONS_CHILDREN: tr.Children,
  UNIT_UNDEFINED: yt.Undefined,
  UNIT_POINT: yt.Point,
  UNIT_PERCENT: yt.Percent,
  UNIT_AUTO: yt.Auto,
  WRAP_NO_WRAP: rr.NoWrap,
  WRAP_WRAP: rr.Wrap,
  WRAP_WRAP_REVERSE: rr.WrapReverse
};
var hs = ks;
g0.default = hs;
Object.defineProperty(ei, "__esModule", {
  value: !0
});
ei.default = ps;
var Be = As(g0);
function Xn(s) {
  if (typeof WeakMap != "function")
    return null;
  var A = /* @__PURE__ */ new WeakMap(), w = /* @__PURE__ */ new WeakMap();
  return (Xn = function(y) {
    return y ? w : A;
  })(s);
}
function As(s, A) {
  if (!A && s && s.__esModule)
    return s;
  if (s === null || typeof s != "object" && typeof s != "function")
    return { default: s };
  var w = Xn(A);
  if (w && w.has(s))
    return w.get(s);
  var y = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var m in s)
    if (m !== "default" && Object.prototype.hasOwnProperty.call(s, m)) {
      var G = d ? Object.getOwnPropertyDescriptor(s, m) : null;
      G && (G.get || G.set) ? Object.defineProperty(y, m, G) : y[m] = s[m];
    }
  return y.default = s, w && w.set(s, y), y;
}
function ps(s) {
  function A(d, m, G) {
    const X = d[m];
    d[m] = function() {
      for (var L = arguments.length, J = new Array(L), q = 0; q < L; q++)
        J[q] = arguments[q];
      return G.call(this, X, ...J);
    };
  }
  for (const d of ["setPosition", "setMargin", "setFlexBasis", "setWidth", "setHeight", "setMinWidth", "setMinHeight", "setMaxWidth", "setMaxHeight", "setPadding"]) {
    const m = {
      [Be.Unit.Point]: s.Node.prototype[d],
      [Be.Unit.Percent]: s.Node.prototype[`${d}Percent`],
      [Be.Unit.Auto]: s.Node.prototype[`${d}Auto`]
    };
    A(s.Node.prototype, d, function(G) {
      for (var X = arguments.length, L = new Array(X > 1 ? X - 1 : 0), J = 1; J < X; J++)
        L[J - 1] = arguments[J];
      const q = L.pop();
      let u0, k0;
      if (q === "auto")
        u0 = Be.Unit.Auto, k0 = void 0;
      else if (typeof q == "object")
        u0 = q.unit, k0 = q.valueOf();
      else if (u0 = typeof q == "string" && q.endsWith("%") ? Be.Unit.Percent : Be.Unit.Point, k0 = parseFloat(q), !Number.isNaN(q) && Number.isNaN(k0))
        throw new Error(`Invalid value ${q} for ${d}`);
      if (!m[u0])
        throw new Error(`Failed to execute "${d}": Unsupported unit '${q}'`);
      return k0 !== void 0 ? m[u0].call(this, ...L, k0) : m[u0].call(this, ...L);
    });
  }
  function w(d) {
    return s.MeasureCallback.implement({
      measure: function() {
        const {
          width: m,
          height: G
        } = d(...arguments);
        return {
          width: m ?? NaN,
          height: G ?? NaN
        };
      }
    });
  }
  A(s.Node.prototype, "setMeasureFunc", function(d, m) {
    return m ? d.call(this, w(m)) : this.unsetMeasureFunc();
  });
  function y(d) {
    return s.DirtiedCallback.implement({
      dirtied: d
    });
  }
  return A(s.Node.prototype, "setDirtiedFunc", function(d, m) {
    d.call(this, y(m));
  }), A(s.Config.prototype, "free", function() {
    s.Config.destroy(this);
  }), A(s.Node, "create", (d, m) => m ? s.Node.createWithConfig(m) : s.Node.createDefault()), A(s.Node.prototype, "free", function() {
    s.Node.destroy(this);
  }), A(s.Node.prototype, "freeRecursive", function() {
    for (let d = 0, m = this.getChildCount(); d < m; ++d)
      this.getChild(0).freeRecursive();
    this.free();
  }), A(s.Node.prototype, "calculateLayout", function(d) {
    let m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN, G = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : NaN, X = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Be.Direction.LTR;
    return d.call(this, m, G, X);
  }), {
    Config: s.Config,
    Node: s.Node,
    ...Be.default
  };
}
var Hn = { exports: {} };
(function(s, A) {
  var w = (() => {
    var y = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
    return function(d) {
      d = d || {};
      var m;
      m || (m = typeof d < "u" ? d : {});
      var G, X;
      m.ready = new Promise(function(c, k) {
        G = c, X = k;
      });
      var L = Object.assign({}, m), J = "";
      typeof document < "u" && document.currentScript && (J = document.currentScript.src), y && (J = y), J.indexOf("blob:") !== 0 ? J = J.substr(0, J.replace(/[?#].*/, "").lastIndexOf("/") + 1) : J = "";
      var q = m.print || console.log.bind(console), u0 = m.printErr || console.warn.bind(console);
      Object.assign(m, L), L = null;
      var k0;
      m.wasmBinary && (k0 = m.wasmBinary), m.noExitRuntime;
      function $() {
        this.buffer = new ArrayBuffer(p0 / 65536 * 65536);
      }
      function M0() {
      }
      function o0(c) {
        this.exports = // EMSCRIPTEN_START_ASM
        function(g) {
          function W(p2) {
            return p2.set = function(y0, U2) {
              this[y0] = U2;
            }, p2.get = function(y0) {
              return this[y0];
            }, p2;
          }
          for (var O, M = new Uint8Array(123), Y = 25; Y >= 0; --Y)
            M[48 + Y] = 52 + Y, M[65 + Y] = Y, M[97 + Y] = 26 + Y;
          M[43] = 62, M[47] = 63;
          function V(p2, y0, U2) {
            for (var G2, P, te = 0, r = y0, z = U2.length, $e = y0 + (z * 3 >> 2) - (U2[z - 2] == "=") - (U2[z - 1] == "="); te < z; te += 4)
              G2 = M[U2.charCodeAt(te + 1)], P = M[U2.charCodeAt(te + 2)], p2[r++] = M[U2.charCodeAt(te)] << 2 | G2 >> 4, r < $e && (p2[r++] = G2 << 4 | P >> 2), r < $e && (p2[r++] = P << 6 | M[U2.charCodeAt(te + 3)]);
          }
          function K(p2) {
            V(O, 1024, "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"), V(O, 4338, "wH8DAAAAAADAfwAAAABpaQB2AHZp"), V(O, 4368, "exsAAHkbAAC5GwAAsxsAALkbAACzGwAAaWlpZmlmaQCsGwAAfBsAAHZpaQB9GwAAwBsAAGlpaQ=="), V(O, 4432, "xwAAAMgAAADJ"), V(O, 4452, "xwAAAMoAAADLAAAArBs="), V(O, 4480, "exsAALkbAACzGwAAuRsAALMbAADAGwAAuxsAAMAbAABpaWlpAAAAAKwbAACRGwAArBsAAJMbAACUGwAAwBs="), V(O, 4552, "zAAAAM0AAADO"), V(O, 4572, "zAAAAM8AAADLAAAAlxsAAKwbAACXGw=="), V(O, 4608, "rBsAAJcbAACzGwAArRsAAHZpaWlpAAAArBsAAJcbAAC5GwAAdmlpZgAAAACsGwAAlxsAAK0bAAB2aWlpAAAAAKwbAACXGwAAsxsAAK0bAACYGwAAsxsAAK0bAACYGwAAsxsAAJgbAABpAGRpaQB2aWlkAACcGwAAnBsAAJcbAACsGwAAnBsAAKwbAACcGwAAmxsAAKwbAACcGwAAsxsAAKwbAACcGwAAsxsAALobAAB2aWlpZAAAAKwbAACcGwAAuhsAALMbAACdGwAAmhsAAJ0bAACzGwAAmhsAAJ0bAAC6GwAAnRsAALobAACdGwAAsxsAAGRpaWkAAAAAuRsAAJwbAACzGwAAZmlpaQAAAACsGwAAnBsAAJwbAAC0GwAArBsAAJwbAACcGwAAtBsAAJ0bAACcGwAAnBsAAJwbAACcGwAAtBsAAK0bAACcGwAArBsAAJwbAACtGwAArBsAAJwbAAB5GwAArBsAAJwbAACRGwAArRsAAJ0bAAAAAAAArBsAAJwbAAC6GwAAuhsAALMbAAB2aWlkZGkAAJkbAACdGw=="), V(O, 5040, "GQAKABkZGQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAAZABEKGRkZAwoHAAEACQsYAAAJBgsAAAsABhkAAAAZGRk="), V(O, 5121, "DgAAAAAAAAAAGQAKDRkZGQANAAACAAkOAAAACQAOAAAO"), V(O, 5179, "DA=="), V(O, 5191, "EwAAAAATAAAAAAkMAAAAAAAMAAAM"), V(O, 5237, "EA=="), V(O, 5249, "DwAAAAQPAAAAAAkQAAAAAAAQAAAQ"), V(O, 5295, "Eg=="), V(O, 5307, "EQAAAAARAAAAAAkSAAAAAAASAAASAAAaAAAAGhoa"), V(O, 5362, "GgAAABoaGgAAAAAAAAk="), V(O, 5411, "FA=="), V(O, 5423, "FwAAAAAXAAAAAAkUAAAAAAAUAAAU"), V(O, 5469, "Fg=="), V(O, 5481, "FQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVG"), V(O, 5556, "1Q=="), V(O, 5596, "//////////8="), V(O, 5664, "8B8BAAAAAAAF"), V(O, 5684, "0A=="), V(O, 5708, "0QAAANIAAADUGw=="), V(O, 5732, "Ag=="), V(O, 5748, "//////////8="), V(O, 5816, "BQ=="), V(O, 5828, "0w=="), V(O, 5852, "0QAAANQAAADoGwAAAAQ="), V(O, 5876, "AQ=="), V(O, 5892, "/////wo="), V(O, 5960, "1g==");
          }
          var b = new ArrayBuffer(16), i0 = new Int32Array(b), a0 = new Float32Array(b), T0 = new Float64Array(b);
          function O0(p2) {
            return i0[p2];
          }
          function j(p2, y0) {
            i0[p2] = y0;
          }
          function y2() {
            return T0[0];
          }
          function N2(p2) {
            T0[0] = p2;
          }
          function V0() {
            throw new Error("abort");
          }
          function A2(p2) {
            a0[2] = p2;
          }
          function f0() {
            return a0[2];
          }
          function Ft(p2) {
            var y0 = p2.a, U2 = y0.a, G2 = U2.buffer;
            U2.grow = Df;
            var P = new Int8Array(G2), te = new Int16Array(G2), r = new Int32Array(G2), z = new Uint8Array(G2), $e = new Uint16Array(G2), wi = new Uint32Array(G2), h = new Float32Array(G2), b0 = new Float64Array(G2), $0 = Math.imul, o = Math.fround, e2 = Math.abs, J2 = Math.clz32, L1 = Math.min, X1 = Math.max, l0 = NaN, vi = 1 / 0, D = y0.b, d2 = y0.c, pe = y0.d, me = y0.e, We = y0.f, Ke = y0.g, ut = y0.h, Pt = y0.i, yr = y0.j, dr = y0.k, Rr = y0.l, gi = y0.m, yi = y0.n, di = y0.o, Ri = y0.p, Ei = y0.q, H1 = y0.r, z1 = y0.s, U1 = y0.t, Y1 = y0.u, D1 = y0.v, j1 = y0.w, J1 = y0.x, Q1 = y0.y, b1 = y0.z, $1 = y0.A, K1 = y0.B, q1 = y0.C, e4 = y0.D, U = 73712, I2 = 0;
            function Ni(e, t, i, n, f, u, a, l, p, E, I, F, Z, T) {
              var v = 0, R = o(0), N = 0, S = o(0), x = 0, C = o(0), _ = 0, H = o(0), Q = 0, t0 = 0, r0 = o(0), s0 = 0, c0 = 0, v0 = o(0), G0 = o(0), L0 = o(0), z0 = o(0), U0 = 0, K0 = o(0), r2 = o(0), s2 = 0, u2 = 0, v2 = o(0), W2 = 0, O2 = 0, S2 = 0, C2 = 0, L2 = o(0), X2 = 0, K2 = 0, q2 = 0, fe = 0, se = o(0), ue = 0, ae = 0, we = 0, ve = 0, ge = o(0), Ge = 0, Ie = 0, Te = 0, xe = o(0), Ce = 0, Ve = o(0), ct = 0, kt = o(0), ht = o(0), At = o(0), pt = 0, Yt = o(0), Pr = 0, _r = o(0), Mr = o(0), Lr = o(0), Xr = o(0), Hr = 0, dn = 0, Rn = 0, En = 0, Nn = 0, Wn = 0, On = 0, Sn = 0, i2 = 0, n2 = o(0), nt = o(0);
              v = U - 384 | 0, U = v;
              e: {
                i: {
                  r: {
                    if (!(f && t != t)) {
                      if (!(u && i != i)) {
                        if (N = (p ? 0 : 4) + I | 0, r[N >> 2] = r[N >> 2] + 1, N = r[e + 24 >> 2] & 3, Pr = (n | 0) <= 1 ? 1 : n, C2 = N || Pr, P[e + 300 | 0] = z[e + 300 | 0] & 252 | C2 & 3, N = e + 252 | 0, n = ((C2 | 0) != 1) << 3, Ge = (C2 | 0) == 2 ? 3 : 2, C = E0(e, Ge, a), h[N + n >> 2] = C, x = N, N = ((C2 | 0) == 1) << 3, G0 = B0(e, Ge, a), h[x + N >> 2] = G0, H = E0(e, 0, a), h[e + 256 >> 2] = H, z0 = B0(e, 0, a), h[e + 264 >> 2] = z0, x = e + 268 | 0, i2 = x + n | 0, n2 = Z0(e, Ge), h[i2 >> 2] = n2, i2 = N + x | 0, n2 = F0(e, Ge), h[i2 >> 2] = n2, R = Z0(e, 0), h[e + 272 >> 2] = R, K0 = F0(e, 0), h[e + 280 >> 2] = K0, x = n, n = e + 284 | 0, i2 = x + n | 0, n2 = X0(e, Ge, a), h[i2 >> 2] = n2, i2 = n + N | 0, n2 = H0(e, Ge, a), h[i2 >> 2] = n2, S = X0(e, 0, a), h[e + 288 >> 2] = S, r0 = H0(e, 0, a), h[e + 296 >> 2] = r0, C = o(C + G0), G0 = o(H + z0), n = r[e + 8 >> 2], n) {
                          H = o(o(o(h[e + 284 >> 2] + h[e + 292 >> 2]) + h[e + 268 >> 2]) + h[e + 276 >> 2]), i = o(u ? i - G0 : l0), R = o(o(S + r0) + R), S = o(f ? t - C : l0), t = S;
                          t: {
                            if (t != t)
                              break t;
                            if (t = o(S - H), t != t) {
                              t = o(0);
                              break t;
                            }
                            t = d0(t, o(0));
                          }
                          C = o(R + K0), R = i;
                          t: {
                            if (i != i)
                              break t;
                            if (R = o(i - C), R != R) {
                              R = o(0);
                              break t;
                            }
                            R = d0(R, o(0));
                          }
                          if (!((f | 0) != 1 | (u | 0) != 1)) {
                            t = t2(e, 2, S, a), n = t != t, R = o(o(X0(e, 2, a) + Z0(e, 2)) + o(H0(e, 2, a) + F0(e, 2)));
                            t: {
                              if (!(n | R != R)) {
                                t = d0(t, R);
                                break t;
                              }
                              t = n ? R : t;
                            }
                            h[e + 516 >> 2] = t, t = t2(e, 0, i, l), n = t != t, i = o(o(X0(e, 0, a) + Z0(e, 0)) + o(H0(e, 0, a) + F0(e, 0)));
                            t: {
                              if (!(n | i != i)) {
                                t = d0(t, i);
                                break t;
                              }
                              t = n ? i : t;
                            }
                            h[e + 520 >> 2] = t;
                            break e;
                          }
                          t: {
                            if (z[e + 4 | 0] & 16) {
                              e0[n | 0](v + 24 | 0, e, t, f, R, u, 0);
                              break t;
                            }
                            e0[n | 0](v + 24 | 0, e, t, f, R, u);
                          }
                          r[I + 20 >> 2] = r[I + 20 >> 2] + 1, n = (T << 2) + I | 0, r[n + 24 >> 2] = r[n + 24 >> 2] + 1, t = o(H + h[v + 24 >> 2]), t = t2(e, 2, f ? (f | 0) == 2 ? t : S : t, a), n = t != t, R = o(o(X0(e, 2, a) + Z0(e, 2)) + o(H0(e, 2, a) + F0(e, 2)));
                          t: {
                            if (!(n | R != R)) {
                              t = d0(t, R);
                              break t;
                            }
                            t = n ? R : t;
                          }
                          h[e + 516 >> 2] = t, t = o(C + h[v + 28 >> 2]), t = t2(e, 0, u ? (u | 0) == 2 ? t : i : t, l), n = t != t, i = o(o(X0(e, 0, a) + Z0(e, 0)) + o(H0(e, 0, a) + F0(e, 0)));
                          t: {
                            if (!(n | i != i)) {
                              t = d0(t, i);
                              break t;
                            }
                            t = n ? i : t;
                          }
                          h[e + 520 >> 2] = t;
                          break e;
                        }
                        if (n = r[e + 556 >> 2], T = r[e + 560 >> 2], (n | 0) == (T | 0)) {
                          G0 = o(i - G0), t = t2(e, 2, f & -3 ? o(t - C) : o(o(o(h[e + 284 >> 2] + h[e + 292 >> 2]) + h[e + 268 >> 2]) + h[e + 276 >> 2]), a), n = t != t, i = o(o(X0(e, 2, a) + Z0(e, 2)) + o(H0(e, 2, a) + F0(e, 2)));
                          t: {
                            if (!(n | i != i)) {
                              t = d0(t, i);
                              break t;
                            }
                            t = n ? i : t;
                          }
                          h[e + 516 >> 2] = t, t = t2(e, 0, u & -3 ? G0 : o(o(o(S + r0) + R) + K0), l), n = t != t, i = o(o(X0(e, 0, a) + Z0(e, 0)) + o(H0(e, 0, a) + F0(e, 0)));
                          t: {
                            if (!(n | i != i)) {
                              t = d0(t, i);
                              break t;
                            }
                            t = n ? i : t;
                          }
                          h[e + 520 >> 2] = t;
                          break e;
                        }
                        t: {
                          if (p || (R = o(t - C), S = o(i - G0), !(!(!(R <= o(0)) | (f | 0) != 2) & R == R | !(!(S <= o(0)) | (u | 0) != 2) & S == S) & ((f | 0) != 1 | (u | 0) != 1)))
                            break t;
                          t = t2(e, 2, R != R || (f | 0) == 2 && R < o(0) ? o(0) : R, a), n = t != t, i = o(o(X0(e, 2, a) + Z0(e, 2)) + o(H0(e, 2, a) + F0(e, 2)));
                          n: {
                            if (!(n | i != i)) {
                              t = d0(t, i);
                              break n;
                            }
                            t = n ? i : t;
                          }
                          h[e + 516 >> 2] = t, t = t2(e, 0, S != S || (u | 0) == 2 && S < o(0) ? o(0) : S, l), n = t != t, i = o(o(X0(e, 0, a) + Z0(e, 0)) + o(H0(e, 0, a) + F0(e, 0)));
                          n: {
                            if (!(n | i != i)) {
                              t = d0(t, i);
                              break n;
                            }
                            t = n ? i : t;
                          }
                          h[e + 520 >> 2] = t;
                          break e;
                        }
                        for (s2 = T - n | 0, fe = s2 >> 2; N = r[n >> 2], r[N + 552 >> 2] != (e | 0) && (x = r[e + 568 >> 2], N = _i(r[x >> 2], z[x + 8 | 0], N, e, Q, 0), r[n >> 2] = N, r[N + 552 >> 2] = e), Q = Q + 1 | 0, n = n + 4 | 0, (T | 0) != (n | 0); )
                          ;
                        P[e + 300 | 0] = z[e + 300 | 0] & 251, Q = 3, W2 = r[e + 24 >> 2], n = W2 >>> 2 & 3;
                        t: {
                          n: {
                            o: {
                              if ((C2 | 0) == 2) {
                                T = 0;
                                f:
                                  switch (n - 2 | 0) {
                                    case 0:
                                      break t;
                                    case 1:
                                      break f;
                                    default:
                                      break o;
                                  }
                                Q = 2;
                                break t;
                              }
                              if (Q = 2, T = 0, n >>> 0 > 1)
                                break n;
                            }
                            T = Q;
                          }
                          Q = n;
                        }
                        _r = o(t - C), se = o(o(X0(e, Q, a) + Z0(e, Q)) + o(H0(e, Q, a) + F0(e, Q))), K0 = o(X0(e, T, a) + Z0(e, T)), L2 = o(K0 + o(H0(e, T, a) + F0(e, T))), X2 = Q >>> 0 > 1, H = Gi(e, 0, _r, X2 ? se : L2, a), Mr = o(i - G0), r2 = Gi(e, 1, Mr, X2 ? L2 : se, l), z0 = X2 ? r2 : H, G0 = X2 ? H : r2, ue = r[e + 560 >> 2], N = r[e + 556 >> 2], O2 = X2 ? f : u;
                        t: {
                          if ((O2 | 0) != 1)
                            break t;
                          if ((N | 0) == (ue | 0))
                            break r;
                          for (n = N; ; ) {
                            x = r[n >> 2];
                            n: {
                              if (!Ji(x))
                                break n;
                              if (c0 = 0, _)
                                break t;
                              o: {
                                f: {
                                  if (!r[x + 552 >> 2]) {
                                    R = o(0);
                                    break f;
                                  }
                                  if (i = h[x + 32 >> 2], i != i && (R = o(0), i = h[x + 28 >> 2], !(i > o(0))))
                                    break f;
                                  if (R = i, i != i)
                                    break o;
                                }
                                if (o(e2(R)) < o(9999999747378752e-20))
                                  break t;
                              }
                              if (t = rt(x), t != t) {
                                _ = x;
                                break n;
                              }
                              if (_ = x, o(e2(t)) < o(9999999747378752e-20))
                                break t;
                            }
                            if (c0 = _, n = n + 4 | 0, (ue | 0) == (n | 0))
                              break;
                          }
                        }
                        if ((N | 0) == (ue | 0))
                          break r;
                        for (ct = (C2 | 0) <= 1 ? 1 : C2, Ie = H != H, ae = Ie | (f | 0) != 1, we = r2 == r2, Te = H == H, R = o(0); ; ) {
                          s0 = r[N >> 2], Zi(s0), x = r[s0 + 24 >> 2];
                          t: {
                            if (x & 4194304) {
                              if (xi(s0, 0), n = z[s0 + 4 | 0], x = n | 1, P[s0 + 4 | 0] = x, !(n & 4))
                                break t;
                              P[s0 + 4 | 0] = x & 251;
                              break t;
                            }
                            if (p && (n = x & 3, Mi(s0, n || ct, G0, z0, H), x = r[s0 + 24 >> 2]), (x & 196608) == 131072)
                              break t;
                            n: {
                              if ((s0 | 0) == (c0 | 0)) {
                                r[c0 + 308 >> 2] = 0, r[c0 + 304 >> 2] = Z, i = o(0);
                                break n;
                              }
                              ve = r[e + 24 >> 2], n = ve >>> 2 & 3;
                              o: {
                                f: {
                                  if ((C2 | 0) != 2)
                                    break f;
                                  _ = 3;
                                  s:
                                    switch (n - 2 | 0) {
                                      case 0:
                                        break o;
                                      case 1:
                                        break s;
                                      default:
                                        break f;
                                    }
                                  _ = 2;
                                  break o;
                                }
                                _ = n;
                              }
                              K2 = _ >>> 0 > 1, C = K2 ? H : r2, i = o(0), t = h[s0 + 40 >> 2];
                              o: {
                                f: {
                                  t0 = r[s0 + 40 >> 2];
                                  s: {
                                    if ((t0 | 0) == 2139156720)
                                      break s;
                                    if ((t0 | 0) == 2140081935)
                                      break f;
                                    n = 4336;
                                    u: {
                                      if ((t0 | 0) != 2141891242) {
                                        if (t == t)
                                          break u;
                                        n = 4344;
                                      }
                                      i = h[n >> 2];
                                      a: {
                                        l:
                                          switch (t0 = r[n + 4 >> 2], t0 | 0) {
                                            case 0:
                                            case 3:
                                              break l;
                                            default:
                                              break a;
                                          }
                                        if (t = o(l0), !(h[s0 + 28 >> 2] > o(0)))
                                          break o;
                                        t0 = P[r[s0 + 568 >> 2] + 8 | 0] & 1, n = t0 ? 2143289344 : 0, t0 = t0 ? 3 : 1, i = (j(2, n), f0());
                                      }
                                      switch (t = o(l0), t0 - 1 | 0) {
                                        case 0:
                                          break f;
                                        case 1:
                                          break s;
                                        default:
                                          break o;
                                      }
                                    }
                                    if (i = (j(2, (t0 & -1073741825) + 536870912 | 0), f0()), !(t0 & 1073741824))
                                      break f;
                                  }
                                  t = o(o(C * i) * o(0.009999999776482582));
                                  break o;
                                }
                                t = i;
                              }
                              i = h[s0 + 572 >> 2], t0 = 0;
                              o: {
                                f:
                                  switch (U0 = r[s0 + 576 >> 2], U0 | 0) {
                                    case 0:
                                    case 3:
                                      break o;
                                    default:
                                      break f;
                                  }
                                if (S = h[s0 + 572 >> 2], !((U0 | 0) != 1 | S != S)) {
                                  if (i < o(0))
                                    break o;
                                  t0 = 1;
                                  break o;
                                }
                                if (t0 = 1, (U0 | 0) != 2 | S != S || (t0 = 0, i < o(0)))
                                  break o;
                                t0 = Te;
                              }
                              S = h[s0 + 580 >> 2], n = 0;
                              o: {
                                f:
                                  switch (u2 = r[s0 + 584 >> 2], u2 | 0) {
                                    case 0:
                                    case 3:
                                      break o;
                                    default:
                                      break f;
                                  }
                                if (r0 = h[s0 + 580 >> 2], !((u2 | 0) != 1 | r0 != r0)) {
                                  if (S < o(0))
                                    break o;
                                  n = 1;
                                  break o;
                                }
                                if (n = 1, (u2 | 0) != 2 | r0 != r0 || (n = 0, S < o(0)))
                                  break o;
                                n = we;
                              }
                              o: {
                                f: {
                                  if (!(t != t | C != C)) {
                                    if (i = h[s0 + 308 >> 2], (!(P[r[s0 + 568 >> 2] + 12 | 0] & 1) | r[s0 + 304 >> 2] == (Z | 0)) & i == i)
                                      break o;
                                    if (i = o(o(X0(s0, _, H) + Z0(s0, _)) + o(H0(s0, _, H) + F0(s0, _))), !(i <= t) & t < i)
                                      break f;
                                    i = t;
                                    break f;
                                  }
                                  if (t0 & K2) {
                                    S = o(o(X0(s0, 2, H) + Z0(s0, 2)) + o(H0(s0, 2, H) + F0(s0, 2))), t = o(l0);
                                    s:
                                      switch (U0 - 1 | 0) {
                                        case 1:
                                          i = o(o(H * i) * o(0.009999999776482582));
                                        case 0:
                                          if (t = i, S <= t)
                                            break f;
                                          break;
                                        default:
                                          break s;
                                      }
                                    if (!(t == t | S == S)) {
                                      i = t;
                                      break f;
                                    }
                                    if (t < S) {
                                      i = S;
                                      break f;
                                    }
                                    i = t != t ? S : t;
                                    break f;
                                  }
                                  if (!(K2 | n ^ 1)) {
                                    t = o(o(X0(s0, 0, H) + Z0(s0, 0)) + o(H0(s0, 0, H) + F0(s0, 0))), i = o(l0);
                                    s:
                                      switch (u2 - 1 | 0) {
                                        case 1:
                                          S = o(o(r2 * S) * o(0.009999999776482582));
                                        case 0:
                                          if (i = S, t <= i)
                                            break f;
                                          break;
                                        default:
                                          break s;
                                      }
                                    if (i != i & t != t)
                                      break f;
                                    if (t > i) {
                                      i = t;
                                      break f;
                                    }
                                    i = i != i ? t : i;
                                    break f;
                                  }
                                  if (r[v + 360 >> 2] = 2143289344, r[v + 24 >> 2] = 2143289344, S2 = 0, r[v + 356 >> 2] = 0, r[v + 352 >> 2] = 0, r0 = o(E0(s0, 2, H) + B0(s0, 2, H)), v0 = E0(s0, 0, H), L0 = B0(s0, 0, H), C = o(l0), q2 = 0, t = o(l0), t0) {
                                    s: {
                                      u:
                                        switch (U0 - 1 | 0) {
                                          case 0:
                                            t = i;
                                            break s;
                                          case 1:
                                            break u;
                                          default:
                                            break s;
                                        }
                                      t = o(o(H * i) * o(0.009999999776482582));
                                    }
                                    r[v + 356 >> 2] = 1, t = o(r0 + t), h[v + 24 >> 2] = t, q2 = 1;
                                  }
                                  if (v0 = o(v0 + L0), n) {
                                    i = o(l0);
                                    s: {
                                      u:
                                        switch (u2 - 1 | 0) {
                                          case 0:
                                            i = S;
                                            break s;
                                          case 1:
                                            break u;
                                          default:
                                            break s;
                                        }
                                      i = o(o(r2 * S) * o(0.009999999776482582));
                                    }
                                    r[v + 352 >> 2] = 1, C = o(v0 + i), h[v + 360 >> 2] = C, S2 = 1;
                                  }
                                  U0 = (ve & 3145728) == 2097152, u2 = _ >>> 0 < 2;
                                  s: {
                                    u: {
                                      a: {
                                        if (!(U0 & u2)) {
                                          if (U0 | Ie)
                                            break u;
                                          if (t != t)
                                            break a;
                                          break u;
                                        }
                                        if (Ie | t == t)
                                          break s;
                                      }
                                      q2 = 2, r[v + 356 >> 2] = 2, h[v + 24 >> 2] = H, t = H;
                                    }
                                    u: {
                                      if (!U0 || u2) {
                                        if (U0 | r2 != r2)
                                          break s;
                                        if (C != C)
                                          break u;
                                        break s;
                                      }
                                      if (C == C | r2 != r2)
                                        break s;
                                    }
                                    S2 = 2, r[v + 352 >> 2] = 2, h[v + 360 >> 2] = r2, C = r2;
                                  }
                                  i = h[s0 + 224 >> 2], U0 = i != i;
                                  s: {
                                    if (U0)
                                      break s;
                                    u: {
                                      if (!(K2 | (q2 | 0) != 1)) {
                                        r[v + 352 >> 2] = 1, h[v + 360 >> 2] = v0 + o(o(t - r0) / i);
                                        break u;
                                      }
                                      if (u2 | (S2 | 0) != 1)
                                        break s;
                                      r[v + 356 >> 2] = 1, h[v + 24 >> 2] = o(o(C - v0) * i) + r0;
                                    }
                                    S2 = 1, q2 = 1;
                                  }
                                  x = x >>> 13 & 7, x = x || ve >>> 10 & 7;
                                  s: {
                                    if ((x | 0) == 5 | (q2 | 0) == 1 | (K2 | (t0 | ae)) | (x | 0) != 4 || (r[v + 356 >> 2] = 1, h[v + 24 >> 2] = H, U0))
                                      break s;
                                    S2 = 1, r[v + 352 >> 2] = 1, h[v + 360 >> 2] = o(H - r0) / i;
                                  }
                                  s: {
                                    if (u2 | (u | 0) != 1 | r2 != r2 | n | (x | 0) != 4 | (S2 | 0) == 1 || (r[v + 352 >> 2] = 1, h[v + 360 >> 2] = r2, U0))
                                      break s;
                                    r[v + 356 >> 2] = 1, h[v + 24 >> 2] = o(r2 - v0) * i;
                                  }
                                  if (qe(s0, 2, H, H, v + 356 | 0, v + 24 | 0), qe(s0, 0, r2, H, v + 352 | 0, v + 360 | 0), Me(s0, h[v + 24 >> 2], h[v + 360 >> 2], C2, r[v + 356 >> 2], r[v + 352 >> 2], H, r2, 0, 5, E, I, F, Z), t = h[(s0 + (r[(_ << 2) + 4320 >> 2] << 2) | 0) + 516 >> 2], n = t != t, i = o(o(X0(s0, _, H) + Z0(s0, _)) + o(H0(s0, _, H) + F0(s0, _))), !(n | i != i)) {
                                    i = d0(t, i);
                                    break f;
                                  }
                                  i = n ? i : t;
                                }
                                h[s0 + 308 >> 2] = i;
                              }
                              r[s0 + 304 >> 2] = Z;
                            }
                            R = o(R + o(i + o(E0(s0, Q, H) + B0(s0, Q, H))));
                          }
                          if (N = N + 4 | 0, (ue | 0) == (N | 0))
                            break;
                        }
                        break i;
                      }
                      r[v >> 2] = 3072, Y2(e, v), M2(), V0();
                    }
                    r[v + 16 >> 2] = 3154, Y2(e, v + 16 | 0), M2(), V0();
                  }
                  R = o(0);
                }
                t = o(R + o(0)), kt = X2 ? l : a, xe = X2 ? a : l, s2 >>> 0 >= 5 && (t = o(o(_t(e, Q, z0) * o(fe - 1 >>> 0)) + t)), n = t > G0, ue = W2 & 786432, we = (O2 | 0) == 2 && ue && n ? 1 : O2, s0 = X2 ? u : f, K2 = (s0 | 0) == 1, dn = K2 & (p ^ 1), X2 = Q >>> 0 < 2, Rn = s0 & -3, Ie = e + 208 | 0, u = T << 2, u2 = u + 4288 | 0, En = K2 & !ue, Nn = (s0 | 0) != 1 | p, N = Q << 2, q2 = N + 4288 | 0, Te = N + 4320 | 0, ve = z0 == z0, Wn = ve << 1, U0 = u + 4320 | 0, On = !O2 | !n, ct = v + 52 | 0, Lr = _t(e, T, z0), x = 0, n = 0, S2 = 0;
                i: {
                  for (; ; ) {
                    O2 = n, x2(v + 24 | 0, 0, 44), n = r[e + 560 >> 2], u = r[e + 556 >> 2];
                    r: {
                      if ((n | 0) == (u | 0))
                        break r;
                      if (n = n - u | 0, (n | 0) < 0)
                        break i;
                      if (N = lt(v + 360 | 0, n >> 2, 0, ct), n = r[v + 44 >> 2], u = r[v + 48 >> 2] - n | 0, u = Oe(r[v + 364 >> 2] - u | 0, n, u), n = r[v + 44 >> 2], r[v + 364 >> 2] = n, r[v + 44 >> 2] = u, _ = r[v + 368 >> 2], t0 = r[v + 372 >> 2], u = r[v + 48 >> 2], r[v + 368 >> 2] = u, c0 = r[v + 52 >> 2], r[v + 48 >> 2] = _, r[v + 52 >> 2] = t0, r[v + 372 >> 2] = c0, r[N >> 2] = n, (n | 0) != (u | 0) && (r[v + 368 >> 2] = u + ((n - u | 0) + 3 & -4)), !n)
                        break r;
                      m2(n);
                    }
                    c0 = r[e + 24 >> 2], n = c0 >>> 2 & 3;
                    r: {
                      t: {
                        if (u = c0 & 3, ((u || Pr) | 0) != 2)
                          break t;
                        _ = 3;
                        n:
                          switch (n - 2 | 0) {
                            case 0:
                              break r;
                            case 1:
                              break n;
                            default:
                              break t;
                          }
                        _ = 2;
                        break r;
                      }
                      _ = n;
                    }
                    R = _t(e, _, H), N = x, t0 = r[e + 560 >> 2], u = r[e + 556 >> 2];
                    r: {
                      if (N >>> 0 >= t0 - u >> 2 >>> 0)
                        break r;
                      for (c0 = c0 & 786432, i = o(0); ; ) {
                        if (t0 - u >> 2 >>> 0 <= N >>> 0)
                          break i;
                        if (n = r[(N << 2) + u >> 2], s2 = r[n + 24 >> 2], !(s2 & 4194304 | (s2 & 196608) == 131072)) {
                          if (r[n + 548 >> 2] = O2, t = E0(n, _, H), S = B0(n, _, H), u = r[v + 24 >> 2], C = (N | 0) == (x | 0) ? o(0) : R, t = o(t + S), S = h[n + 308 >> 2], r0 = t2(n, _, S, xe), !(!u || !(o(C + o(t + o(i + r0))) > G0) | !c0))
                            break r;
                          if (r[v + 24 >> 2] = u + 1, C = o(C + o(t + r0)), h[v + 28 >> 2] = C + h[v + 28 >> 2], Ji(n)) {
                            t: {
                              if (!r[n + 552 >> 2]) {
                                t = o(0);
                                break t;
                              }
                              if (t = h[n + 32 >> 2], t == t)
                                break t;
                              t = h[n + 28 >> 2], t = t > o(0) ? t : o(0);
                            }
                            h[v + 32 >> 2] = t + h[v + 32 >> 2], i2 = v, n2 = o(h[v + 36 >> 2] - o(rt(n) * S)), h[i2 + 36 >> 2] = n2;
                          }
                          u = r[v + 48 >> 2];
                          t: {
                            if ((u | 0) != r[v + 52 >> 2]) {
                              r[u >> 2] = n, r[v + 48 >> 2] = u + 4;
                              break t;
                            }
                            if (u = u - r[v + 44 >> 2] | 0, s2 = u >> 2, t0 = s2 + 1 | 0, t0 >>> 0 >= 1073741824)
                              break i;
                            if (W2 = u >> 1, t0 = lt(v + 360 | 0, u >>> 0 >= 2147483644 ? 1073741823 : t0 >>> 0 < W2 >>> 0 ? W2 : t0, s2, ct), r[r[v + 368 >> 2] >> 2] = n, r[v + 368 >> 2] = r[v + 368 >> 2] + 4, n = r[v + 44 >> 2], u = r[v + 48 >> 2] - n | 0, u = Oe(r[v + 364 >> 2] - u | 0, n, u), n = r[v + 44 >> 2], r[v + 364 >> 2] = n, r[v + 44 >> 2] = u, s2 = r[v + 368 >> 2], W2 = r[v + 372 >> 2], u = r[v + 48 >> 2], r[v + 368 >> 2] = u, ae = r[v + 52 >> 2], r[v + 48 >> 2] = s2, r[v + 52 >> 2] = W2, r[v + 372 >> 2] = ae, r[t0 >> 2] = n, (n | 0) != (u | 0) && (r[v + 368 >> 2] = u + ((n - u | 0) + 3 & -4)), !n)
                              break t;
                            m2(n);
                          }
                          u = r[e + 556 >> 2], t0 = r[e + 560 >> 2], i = o(i + C);
                        }
                        if (N = N + 1 | 0, !(N >>> 0 < t0 - u >> 2 >>> 0))
                          break;
                      }
                    }
                    L0 = h[v + 32 >> 2], !(L0 > o(0)) | !(L0 < o(1)) || (r[v + 32 >> 2] = 1065353216, L0 = o(1)), v2 = h[v + 36 >> 2], !(v2 > o(0)) | !(v2 < o(1)) || (r[v + 36 >> 2] = 1065353216, v2 = o(1)), r[v + 40 >> 2] = N, r0 = h[v + 28 >> 2], _ = r[v + 24 >> 2], S2 && m2(S2), S = h[v + 56 >> 2], s2 = r[v + 48 >> 2], S2 = r[v + 44 >> 2];
                    r: {
                      t: {
                        n: {
                          o: {
                            if ((we | 0) == 1)
                              break o;
                            i = o(0), t = h[Ie >> 2];
                            f: {
                              s: {
                                n = r[Ie >> 2];
                                u: {
                                  if ((n | 0) == 2139156720)
                                    break u;
                                  if ((n | 0) == 2140081935)
                                    break s;
                                  u = 4336;
                                  a: {
                                    if ((n | 0) != 2141891242) {
                                      if (t == t)
                                        break a;
                                      u = 4344;
                                    }
                                    switch (i = h[u >> 2], t = o(l0), r[u + 4 >> 2] - 1 | 0) {
                                      case 0:
                                        break s;
                                      case 1:
                                        break u;
                                      default:
                                        break f;
                                    }
                                  }
                                  if (i = (j(2, (n & -1073741825) + 536870912 | 0), f0()), !(n & 1073741824))
                                    break s;
                                }
                                t = o(o(i * a) * o(0.009999999776482582));
                                break f;
                              }
                              t = i;
                            }
                            i = o(0), R = h[e + 216 >> 2];
                            f: {
                              s: {
                                n = r[e + 216 >> 2];
                                u: {
                                  if ((n | 0) == 2139156720)
                                    break u;
                                  if ((n | 0) == 2140081935)
                                    break s;
                                  u = 4336;
                                  a: {
                                    if ((n | 0) != 2141891242) {
                                      if (R == R)
                                        break a;
                                      u = 4344;
                                    }
                                    switch (i = h[u >> 2], R = o(l0), r[u + 4 >> 2] - 1 | 0) {
                                      case 0:
                                        break s;
                                      case 1:
                                        break u;
                                      default:
                                        break f;
                                    }
                                  }
                                  if (i = (j(2, (n & -1073741825) + 536870912 | 0), f0()), !(n & 1073741824))
                                    break s;
                                }
                                R = o(o(i * a) * o(0.009999999776482582));
                                break f;
                              }
                              R = i;
                            }
                            i = o(0), C = h[e + 212 >> 2];
                            f: {
                              s: {
                                n = r[e + 212 >> 2];
                                u: {
                                  if ((n | 0) == 2139156720)
                                    break u;
                                  if ((n | 0) == 2140081935)
                                    break s;
                                  u = 4336;
                                  a: {
                                    if ((n | 0) != 2141891242) {
                                      if (C == C)
                                        break a;
                                      u = 4344;
                                    }
                                    switch (i = h[u >> 2], C = o(l0), r[u + 4 >> 2] - 1 | 0) {
                                      case 0:
                                        break s;
                                      case 1:
                                        break u;
                                      default:
                                        break f;
                                    }
                                  }
                                  if (i = (j(2, (n & -1073741825) + 536870912 | 0), f0()), !(n & 1073741824))
                                    break s;
                                }
                                C = o(o(i * l) * o(0.009999999776482582));
                                break f;
                              }
                              C = i;
                            }
                            i = o(0), v0 = h[e + 220 >> 2];
                            f: {
                              s: {
                                n = r[e + 220 >> 2];
                                u: {
                                  if ((n | 0) == 2139156720)
                                    break u;
                                  if ((n | 0) == 2140081935)
                                    break s;
                                  u = 4336;
                                  a: {
                                    if ((n | 0) != 2141891242) {
                                      if (v0 == v0)
                                        break a;
                                      u = 4344;
                                    }
                                    switch (i = h[u >> 2], v0 = o(l0), r[u + 4 >> 2] - 1 | 0) {
                                      case 0:
                                        break s;
                                      case 1:
                                        break u;
                                      default:
                                        break f;
                                    }
                                  }
                                  if (i = (j(2, (n & -1073741825) + 536870912 | 0), f0()), !(n & 1073741824))
                                    break s;
                                }
                                v0 = o(o(i * l) * o(0.009999999776482582));
                                break f;
                              }
                              v0 = i;
                            }
                            if (n = Q >>> 0 > 1, i = o((n ? t : C) - se), i == i & i > r0 || (i = o((n ? R : v0) - se), i == i & i < r0))
                              break n;
                            if (P[r[e + 568 >> 2] + 16 | 0] & 1)
                              break o;
                            if (i = r0, !r[e + 552 >> 2] | L0 == o(0))
                              break t;
                            t = h[e + 32 >> 2];
                            f: {
                              s: {
                                if (t == t) {
                                  i = t;
                                  break s;
                                }
                                if (i = h[e + 28 >> 2], !(i > o(0)))
                                  break f;
                              }
                              if (i != i) {
                                i = G0;
                                break t;
                              }
                              t = h[e + 32 >> 2];
                            }
                            if (t != t && (i = r0, t = h[e + 28 >> 2], !(t > o(0))) || (i = G0, t != o(0)))
                              break t;
                            i = r0;
                            break t;
                          }
                          i = G0;
                        }
                        if (i != i)
                          break t;
                        S = o(i - r0);
                        break r;
                      }
                      if (!(r0 < o(0)))
                        break r;
                      S = o(-r0);
                    }
                    if (G0 = i, !dn) {
                      r: {
                        if ((s2 | 0) == (S2 | 0)) {
                          C = o(0);
                          break r;
                        }
                        for (v0 = o(0), u = S2; ; ) {
                          n = r[u >> 2], r0 = h[n + 308 >> 2], i = t2(n, Q, r0, xe);
                          t: {
                            if (S < o(0)) {
                              if (t = o(i * o(-rt(n))), !(t > o(0) | t < o(0)))
                                break t;
                              R = o(o(o(S / v2) * t) + i), t = t2(n, Q, R, G0), t0 = t != t, C = o(o(X0(n, Q, H) + Z0(n, Q)) + o(H0(n, Q, H) + F0(n, Q)));
                              n: {
                                if (!(t0 | C != C)) {
                                  t = d0(t, C);
                                  break n;
                                }
                                t = t0 ? C : t;
                              }
                              if (R != R | t != t | t == R)
                                break t;
                              v0 = o(v0 + o(t - i)), v2 = o(o(rt(n) * r0) + v2);
                              break t;
                            }
                            if (!(S > o(0)) | !r[n + 552 >> 2] || (R = h[n + 32 >> 2], R != R && (R = h[n + 28 >> 2], !(R > o(0)))) || !(R < o(0) | R > o(0)))
                              break t;
                            C = o(o(o(S / L0) * R) + i), t = t2(n, Q, C, G0), t0 = t != t, r0 = o(o(X0(n, Q, H) + Z0(n, Q)) + o(H0(n, Q, H) + F0(n, Q)));
                            n: {
                              if (!(t0 | r0 != r0)) {
                                t = d0(t, r0);
                                break n;
                              }
                              t = t0 ? r0 : t;
                            }
                            if (C != C | t != t | t == C)
                              break t;
                            L0 = o(L0 - R), v0 = o(v0 + o(t - i));
                          }
                          if (u = u + 4 | 0, (s2 | 0) == (u | 0))
                            break;
                        }
                        for (v0 = o(S - v0), ht = o(v0 / v2), At = o(v0 / L0), pt = K2 & (On | !(z[e + 26 | 0] & 12)), ae = !pt, W2 = r[U0 >> 2], C = o(0), t0 = S2; ; ) {
                          n = r[t0 >> 2], r0 = t2(n, Q, h[n + 308 >> 2], xe);
                          t: {
                            n: {
                              if (v0 < o(0)) {
                                if (R = r0, t = o(R * o(-rt(n))), t == o(0))
                                  break t;
                                t = v2 == o(0) ? o(r0 + t) : o(o(ht * t) + r0);
                                break n;
                              }
                              if (R = r0, !(v0 > o(0)) | !r[n + 552 >> 2] || (t = h[n + 32 >> 2], t != t && (t = h[n + 28 >> 2], !(t > o(0)))) || !(t < o(0) | t > o(0)))
                                break t;
                              t = o(o(At * t) + r0);
                            }
                            if (t = t2(n, Q, t, G0), u = t != t, i = o(o(X0(n, Q, H) + Z0(n, Q)) + o(H0(n, Q, H) + F0(n, Q))), !(u | i != i)) {
                              R = d0(t, i);
                              break t;
                            }
                            R = u ? i : t;
                          }
                          t = E0(n, Q, H), i = B0(n, Q, H), L0 = E0(n, T, H), Yt = B0(n, T, H), i = o(t + i), Xr = o(R + i), h[v + 352 >> 2] = Xr, r[v + 344 >> 2] = 1, L0 = o(L0 + Yt), t = h[n + 224 >> 2];
                          t: {
                            if (t == t) {
                              r[v + 348 >> 2] = 1, i = o(Xr - i), h[v + 356 >> 2] = L0 + o(X2 ? i * t : i / t);
                              break t;
                            }
                            n: {
                              if (Ce = z0 != z0, Ce)
                                break n;
                              c0 = (W2 << 3) + n | 0, t = h[c0 + 572 >> 2];
                              o: {
                                f: {
                                  s: {
                                    u:
                                      switch (u = r[c0 + 576 >> 2], u | 0) {
                                        case 0:
                                        case 3:
                                          break s;
                                        default:
                                          break u;
                                      }
                                    if (i = h[c0 + 572 >> 2], (u | 0) != 1 | i != i)
                                      break f;
                                    if (!(ae | !(t < o(0))))
                                      break o;
                                    break n;
                                  }
                                  if (!pt)
                                    break n;
                                  break o;
                                }
                                if (ae | (!(t < o(0)) | ((u | 0) != 2 | i != i)))
                                  break n;
                              }
                              if (u = r[n + 24 >> 2] >>> 13 & 7, u || (u = r[e + 24 >> 2] >>> 10 & 7), (u | 0) != 4 || (Xe(v + 24 | 0, n, T), r[v + 28 >> 2] == 3) || (Le(v + 360 | 0, n, T), r[v + 364 >> 2] == 3))
                                break n;
                              r[v + 348 >> 2] = 1, h[v + 356 >> 2] = z0;
                              break t;
                            }
                            c0 = (W2 << 3) + n | 0, i = h[c0 + 572 >> 2];
                            n: {
                              o: {
                                f: {
                                  s: {
                                    u:
                                      switch (u = r[c0 + 576 >> 2], u | 0) {
                                        case 0:
                                        case 3:
                                          break s;
                                        default:
                                          break u;
                                      }
                                    if (t = h[c0 + 572 >> 2], !((u | 0) != 1 | t != t)) {
                                      if (t = i, t < o(0))
                                        break s;
                                      break n;
                                    }
                                    if ((u | 0) != 2 | t != t)
                                      break f;
                                    if (Ce)
                                      break s;
                                    if (!(i < o(0)))
                                      break o;
                                  }
                                  r[v + 348 >> 2] = Wn, h[v + 356 >> 2] = z0;
                                  break t;
                                }
                                t = o(l0);
                                f:
                                  switch (u - 1 | 0) {
                                    case 1:
                                      break o;
                                    case 0:
                                      break f;
                                    default:
                                      break n;
                                  }
                                t = i;
                                break n;
                              }
                              t = o(o(z0 * i) * o(0.009999999776482582));
                            }
                            t = o(L0 + t), h[v + 356 >> 2] = t, r[v + 348 >> 2] = (K2 | (u | 0) != 2) & t == t;
                          }
                          qe(n, Q, G0, H, v + 344 | 0, v + 352 | 0), qe(n, T, z0, H, v + 348 | 0, v + 356 | 0), c0 = (W2 << 3) + n | 0, t = h[c0 + 572 >> 2];
                          t: {
                            n: {
                              o: {
                                f:
                                  switch (u = r[c0 + 576 >> 2], u | 0) {
                                    case 0:
                                    case 3:
                                      break o;
                                    default:
                                      break f;
                                  }
                                if (i = h[c0 + 572 >> 2], !((u | 0) != 1 | i != i)) {
                                  if (t < o(0))
                                    break o;
                                  break n;
                                }
                                if ((u | 0) != 2 | i != i)
                                  break n;
                                if (t < o(0))
                                  break o;
                                if (c0 = 0, ve)
                                  break t;
                              }
                              if (c0 = 0, u = r[n + 24 >> 2] >>> 13 & 7, u || (u = r[e + 24 >> 2] >>> 10 & 7), (u | 0) != 4 || (Xe(v + 24 | 0, n, T), r[v + 28 >> 2] == 3))
                                break t;
                              Le(v + 360 | 0, n, T), c0 = r[v + 364 >> 2] != 3;
                              break t;
                            }
                            c0 = 0;
                          }
                          t = h[v + 352 >> 2], i = h[v + 356 >> 2], u = Q >>> 0 > 1, L0 = u ? t : i, t = u ? i : t, Ce = r[v + 344 >> 2], Hr = r[v + 348 >> 2], Sn = u ? Ce : Hr, Ce = u ? Hr : Ce, u = (c0 ^ 1) & p, Me(n, L0, t, z[e + 300 | 0] & 3, Sn, Ce, H, r2, u, u ? 4 : 7, E, I, F, Z), C = o(C + o(R - r0)), u = z[e + 300 | 0];
                          t: {
                            n: {
                              if (u & 4) {
                                c0 = u & 251;
                                break n;
                              }
                              if (c0 = u & 251, u = 0, !(z[n + 300 | 0] & 4))
                                break t;
                            }
                            u = 4;
                          }
                          if (P[e + 300 | 0] = u | c0, t0 = t0 + 4 | 0, (s2 | 0) == (t0 | 0))
                            break;
                        }
                      }
                      S = o(S - C);
                    }
                    n = z[e + 300 | 0], P[e + 300 | 0] = n & 251 | (S < o(0) ? 4 : n & 4), v0 = o(X0(e, Q, a) + Z0(e, Q)), ht = o(H0(e, Q, a) + F0(e, Q)), r0 = _t(e, Q, a);
                    r: {
                      if (!(!(S > o(0)) | (we | 0) != 2)) {
                        C = o(0), i = o(0);
                        t: {
                          n: {
                            n = Ie + (r[Te >> 2] << 2) | 0, t = h[n >> 2], n = r[n >> 2], u = (n | 0) == 2139156720;
                            o: {
                              if (!u) {
                                if (t0 = (n | 0) == 2140081935, t0)
                                  break n;
                                if (c0 = (n | 0) == 2141891242, c0 | t != t)
                                  break r;
                                if (t0)
                                  break n;
                                if (c0)
                                  break r;
                                if (i = (j(2, (n & -1073741825) + 536870912 | 0), f0()), !(n & 1073741824))
                                  break o;
                              }
                              i = o(o(xe * i) * o(0.009999999776482582));
                            }
                            if (i != i)
                              break r;
                            i = o(0);
                            o: {
                              if (u)
                                break o;
                              if ((n | 0) == 2140081935)
                                break n;
                              u = 4336;
                              f: {
                                if ((n | 0) != 2141891242) {
                                  if (t == t)
                                    break f;
                                  u = 4344;
                                }
                                switch (i = h[u >> 2], R = o(l0), r[u + 4 >> 2] - 1 | 0) {
                                  case 0:
                                    break n;
                                  case 1:
                                    break o;
                                  default:
                                    break t;
                                }
                              }
                              if (i = (j(2, (n & -1073741825) + 536870912 | 0), f0()), !(n & 1073741824))
                                break n;
                            }
                            R = o(o(xe * i) * o(0.009999999776482582));
                            break t;
                          }
                          R = i;
                        }
                        if (t = o(o(o(R - v0) - ht) - o(G0 - S)), t != t)
                          break r;
                        C = d0(t, o(0));
                        break r;
                      }
                      C = S;
                    }
                    c0 = N >>> 0 <= x >>> 0;
                    r: {
                      if (!c0) {
                        for (s2 = r[e + 556 >> 2], n = r[e + 560 >> 2] - s2 >> 2, W2 = n >>> 0 < x >>> 0 ? x : n, t0 = 0, n = x; ; ) {
                          if ((n | 0) == (W2 | 0))
                            break i;
                          if (u = r[s2 + (n << 2) >> 2], (r[u + 24 >> 2] & 196608) != 131072 && (ae = v + 24 | 0, Xe(ae, u, Q), pt = r[v + 28 >> 2], Le(ae, u, Q), t0 = (((pt | 0) == 3) + t0 | 0) + (r[v + 28 >> 2] == 3) | 0), n = n + 1 | 0, (N | 0) == (n | 0))
                            break;
                        }
                        if (L0 = o(0), i = r0, t0)
                          break r;
                      }
                      L0 = o(0), t0 = 0, i = r0;
                      t:
                        switch ((r[e + 24 >> 2] >>> 4 & 7) - 1 | 0) {
                          case 0:
                            L0 = o(C * o(0.5));
                            break r;
                          case 1:
                            L0 = C;
                            break r;
                          case 2:
                            if (_ >>> 0 < 2)
                              break r;
                            i = o(r0 + o((n2 = o(0), nt = d0(C, o(0)), i2 = C != C, (i2 ? n2 : nt) / o(_ - 1 >>> 0))));
                            break r;
                          case 4:
                            L0 = o(C / o(_ + 1 >>> 0)), i = o(r0 + L0);
                            break r;
                          case 3:
                            break t;
                          default:
                            break r;
                        }
                      L0 = o(o(C * o(0.5)) / o(_ >>> 0)), i = o(o(L0 + L0) + r0);
                    }
                    if (t = o(v0 + L0), S = o(0), s2 = Xi(e), c0)
                      i = o(0);
                    else {
                      for (W2 = N - 1 | 0, At = o(C / o(t0 | 0)), v0 = o(0), R = o(0), n = x; ; ) {
                        if (u = r[e + 556 >> 2], r[e + 560 >> 2] - u >> 2 >>> 0 <= n >>> 0)
                          break i;
                        u = r[u + (n << 2) >> 2], _ = u + 228 | 0, T2(v + 24 | 0, _, 320), i = o(i - ((n | 0) == (W2 | 0) ? r0 : o(0))), t0 = r[u + 24 >> 2];
                        r: {
                          if (t0 & 4194304)
                            break r;
                          t: {
                            if ((t0 & 196608) == 131072) {
                              if (!D2(u, Q))
                                break t;
                              if (!p)
                                break r;
                              C = Se(u, Q, G0), v2 = Z0(e, Q), Yt = E0(u, Q, H), h[_ + (r[q2 >> 2] << 2) >> 2] = Yt + o(C + v2);
                              break r;
                            }
                            if (Xe(v + 360 | 0, u, Q), t = o(t + (r[v + 364 >> 2] == 3 ? At : o(-0))), p && (t0 = _, _ = r[q2 >> 2] << 2, h[t0 + _ >> 2] = t + h[_ + (v + 24 | 0) >> 2]), Le(v + 360 | 0, u, Q), t = o(t + (r[v + 364 >> 2] == 3 ? At : o(-0))), !Nn) {
                              t = o(t + o(o(i + o(E0(u, Q, H) + B0(u, Q, H))) + h[v + 104 >> 2])), S = z0;
                              break r;
                            }
                            if (_ = u + 516 | 0, t = o(t + o(i + o(h[_ + (r[Te >> 2] << 2) >> 2] + o(E0(u, Q, H) + B0(u, Q, H))))), s2) {
                              C = Mt(u), v2 = E0(u, 0, H), C = o(C + v2), v2 = o(o(h[u + 520 >> 2] + o(E0(u, 0, H) + B0(u, 0, H))) - C), u = v0 != v0;
                              n: {
                                if (!(u | C != C)) {
                                  v0 = d0(v0, C);
                                  break n;
                                }
                                v0 = u ? C : v0;
                              }
                              if (u = R != R, !(u | v2 != v2)) {
                                R = d0(R, v2);
                                break r;
                              }
                              R = u ? v2 : R;
                              break r;
                            }
                            if (C = o(h[_ + (r[U0 >> 2] << 2) >> 2] + o(E0(u, T, H) + B0(u, T, H))), u = S != S, !(C != C | u)) {
                              S = d0(S, C);
                              break r;
                            }
                            S = u ? C : S;
                            break r;
                          }
                          if (!p)
                            break r;
                          u = r[q2 >> 2] << 2, C = h[u + (v + 24 | 0) >> 2], i2 = u + _ | 0, n2 = o(L0 + o(C + Z0(e, Q))), h[i2 >> 2] = n2;
                        }
                        if (n = n + 1 | 0, (N | 0) == (n | 0))
                          break;
                      }
                      i = o(R + v0);
                    }
                    if (S = s2 ? i : S, C = z0, !Rn) {
                      i = t2(e, T, o(L2 + S), kt), n = i != i, R = o(o(X0(e, T, a) + Z0(e, T)) + o(H0(e, T, a) + F0(e, T)));
                      r: {
                        if (!(n | R != R)) {
                          i = d0(i, R);
                          break r;
                        }
                        i = n ? R : i;
                      }
                      C = o(i - L2);
                    }
                    i = t2(e, T, o(L2 + (En ? z0 : S)), kt), n = i != i, R = o(o(X0(e, T, a) + Z0(e, T)) + o(H0(e, T, a) + F0(e, T)));
                    r: {
                      if (!(n | R != R)) {
                        i = d0(i, R);
                        break r;
                      }
                      i = n ? R : i;
                    }
                    if (R = o(i - L2), !(c0 | !p))
                      for (; ; ) {
                        if (n = r[e + 556 >> 2], r[e + 560 >> 2] - n >> 2 >>> 0 <= x >>> 0)
                          break i;
                        _ = r[n + (x << 2) >> 2], n = r[_ + 24 >> 2];
                        r: {
                          if (n & 4194304)
                            break r;
                          if ((n & 196608) == 131072) {
                            t: {
                              if (!D2(_, T)) {
                                u = r[u2 >> 2];
                                break t;
                              }
                              if (i = Se(_, T, z0), S = Z0(e, T), r0 = E0(_, T, H), u = r[u2 >> 2], i = o(r0 + o(i + S)), h[(_ + (u << 2) | 0) + 228 >> 2] = i, i == i)
                                break r;
                            }
                            i2 = _ + (u << 2) | 0, n2 = o(Z0(e, T) + E0(_, T, H)), h[i2 + 228 >> 2] = n2;
                            break r;
                          }
                          u = n >>> 13 & 7, u || (u = r[e + 24 >> 2] >>> 10 & 7);
                          t: {
                            n: {
                              if ((u | 0) == 5) {
                                u = r[e + 24 >> 2] & 8 ? 5 : 1;
                                break n;
                              }
                              if ((u | 0) != 4 || (Xe(v + 24 | 0, _, T), u = 4, r[v + 28 >> 2] == 3) || (Le(v + 360 | 0, _, T), r[v + 364 >> 2] == 3))
                                break n;
                              u = _ + (r[U0 >> 2] << 3) | 0, S = h[u + 572 >> 2];
                              o: {
                                f:
                                  switch (n = r[u + 576 >> 2], n | 0) {
                                    case 0:
                                    case 3:
                                      break o;
                                    default:
                                      break f;
                                  }
                                if (r0 = h[u + 572 >> 2], !((n | 0) != 1 | r0 != r0)) {
                                  if (i = K0, S < o(0))
                                    break o;
                                  break t;
                                }
                                if (i = K0, ve & !(S < o(0)) | ((n | 0) != 2 | r0 != r0))
                                  break t;
                              }
                              S = h[(_ + (r[Te >> 2] << 2) | 0) + 516 >> 2], i = R, r0 = h[_ + 224 >> 2], r0 == r0 && (i = o(o(E0(_, T, H) + B0(_, T, H)) + o(X2 ? S * r0 : S / r0))), h[v + 360 >> 2] = i, i2 = v, n2 = o(S + o(E0(_, Q, H) + B0(_, Q, H))), h[i2 + 24 >> 2] = n2, r[v + 356 >> 2] = 1, r[v + 352 >> 2] = 1, qe(_, Q, G0, H, v + 356 | 0, v + 24 | 0), qe(_, T, z0, H, v + 352 | 0, v + 360 | 0), S = h[v + 360 >> 2], r0 = h[v + 24 >> 2], n = Q >>> 0 > 1, i = n ? S : r0, S = n ? r0 : S, n = (ue | 0) != 0 & (r[e + 24 >> 2] & 896) != 512, Me(_, S, i, C2, !(n & X2 | S != S), (!n | X2) & i == i, H, r2, 1, 2, E, I, F, Z), i = K0;
                              break t;
                            }
                            i = h[(_ + (r[U0 >> 2] << 2) | 0) + 516 >> 2], S = E0(_, T, H), r0 = B0(_, T, H), Xe(v + 24 | 0, _, T), S = o(C - o(i + o(S + r0)));
                            n: {
                              if (r[v + 28 >> 2] != 3 || (Le(v + 360 | 0, _, T), r[v + 364 >> 2] != 3))
                                break n;
                              i = o(S * o(0.5)), i = o(K0 + (n2 = o(0), nt = d0(i, o(0)), i2 = i != i, i2 ? n2 : nt));
                              break t;
                            }
                            if (Le(v + 24 | 0, _, T), i = K0, r[v + 28 >> 2] == 3)
                              break t;
                            if (Xe(v + 24 | 0, _, T), r[v + 28 >> 2] == 3) {
                              i = o(K0 + (n2 = o(0), nt = d0(S, o(0)), i2 = S != S, i2 ? n2 : nt));
                              break t;
                            }
                            n:
                              switch (u - 1 | 0) {
                                case 1:
                                  i = o(K0 + o(S * o(0.5)));
                                  break t;
                                case 0:
                                  break t;
                                default:
                                  break n;
                              }
                            i = o(K0 + S);
                          }
                          n = _ + (r[u2 >> 2] << 2) | 0, h[n + 228 >> 2] = i + o(ge + h[n + 228 >> 2]);
                        }
                        if (x = x + 1 | 0, (x | 0) == (N | 0))
                          break;
                      }
                    i = o((O2 ? Lr : o(0)) + R), n = Ve != Ve, t = o(ht + t);
                    r: {
                      if (!(n | t != t)) {
                        Ve = d0(Ve, t);
                        break r;
                      }
                      Ve = n ? t : Ve;
                    }
                    if (ge = o(ge + i), n = O2 + 1 | 0, x = N, !(fe >>> 0 > N >>> 0))
                      break;
                  }
                  r: {
                    if (!p || !ue && !Xi(e))
                      break r;
                    v0 = o(0);
                    t: {
                      n: {
                        if (z0 != z0)
                          break n;
                        t = o(z0 - ge);
                        o:
                          switch ((r[e + 24 >> 2] >>> 7 & 7) - 2 | 0) {
                            case 0:
                              K0 = o(K0 + o(t * o(0.5)));
                              break n;
                            case 2:
                              if (!(z0 > ge))
                                break n;
                              v0 = o(t / o(n >>> 0));
                              break n;
                            case 5:
                              if (z0 > ge) {
                                if (K0 = o(K0 + o(t / o(n << 1 >>> 0))), n >>> 0 < 2)
                                  break n;
                                v0 = o(t / o(n >>> 0));
                                break t;
                              }
                              K0 = o(K0 + o(t * o(0.5)));
                              break n;
                            case 4:
                              if (!(z0 > ge) | n >>> 0 < 2)
                                break n;
                              v0 = o(t / o(O2 >>> 0));
                              break t;
                            case 1:
                              break o;
                            default:
                              break n;
                          }
                        K0 = o(K0 + t);
                      }
                      if (!n)
                        break r;
                    }
                    for (t0 = 0, n = 0, u = 0; ; ) {
                      if (S = o(0), i = o(0), t = o(0), R = o(0), N = n, fe >>> 0 > n >>> 0) {
                        t: {
                          for (; ; ) {
                            if (u = r[e + 556 >> 2], r[e + 560 >> 2] - u >> 2 >>> 0 <= N >>> 0)
                              break i;
                            x = r[u + (N << 2) >> 2], _ = r[x + 24 >> 2];
                            n: {
                              if (_ & 4194304 | (_ & 196608) == 131072)
                                break n;
                              if (u = N, r[x + 548 >> 2] != (t0 | 0))
                                break t;
                              t = h[(x + (r[U0 >> 2] << 2) | 0) + 516 >> 2];
                              o: {
                                if (!(t >= o(0)))
                                  break o;
                                if (u = i != i, t = o(t + o(E0(x, T, H) + B0(x, T, H))), !(u | t != t)) {
                                  i = d0(i, t);
                                  break o;
                                }
                                i = u ? t : i;
                              }
                              if (u = _ >>> 13 & 7, u || (u = r[e + 24 >> 2] >>> 10 & 7), !(z[e + 24 | 0] & 8) | (u | 0) != 5)
                                break n;
                              t = Mt(x), C = E0(x, 0, H), t = o(t + C), C = o(o(h[x + 520 >> 2] + o(E0(x, 0, H) + B0(x, 0, H))) - t), u = i != i, x = R != R;
                              o: {
                                if (!(x | t != t)) {
                                  R = d0(R, t);
                                  break o;
                                }
                                R = x ? t : R;
                              }
                              x = S != S;
                              o: {
                                if (!(x | C != C)) {
                                  S = d0(S, C);
                                  break o;
                                }
                                S = x ? C : S;
                              }
                              if (t = o(R + S), !(u | t != t)) {
                                i = d0(i, t);
                                break n;
                              }
                              i = u ? t : i;
                            }
                            if (N = N + 1 | 0, (fe | 0) == (N | 0))
                              break;
                          }
                          u = fe;
                        }
                        t = i;
                      }
                      if (C = o(K0 + (t0 ? Lr : o(0))), i = o(v0 + t), K0 = o(C + i), n >>> 0 < u >>> 0)
                        for (r0 = o(C + R); ; ) {
                          if (N = r[e + 556 >> 2], r[e + 560 >> 2] - N >> 2 >>> 0 <= n >>> 0)
                            break i;
                          x = r[N + (n << 2) >> 2], N = r[x + 24 >> 2];
                          t: {
                            if (N & 4194304 | (N & 196608) == 131072)
                              break t;
                            N = N >>> 13 & 7, N || (N = r[e + 24 >> 2] >>> 10 & 7);
                            n: {
                              o:
                                switch (N - 1 | 0) {
                                  case 4:
                                    if (z[e + 24 | 0] & 8)
                                      break n;
                                  case 0:
                                    t = E0(x, T, H), h[(x + (r[u2 >> 2] << 2) | 0) + 228 >> 2] = C + t;
                                    break t;
                                  case 2:
                                    t = B0(x, T, H), N = x + 228 | 0, h[N + (r[u2 >> 2] << 2) >> 2] = o(K0 - t) - h[(N + (r[U0 >> 2] << 2) | 0) + 288 >> 2];
                                    break t;
                                  case 1:
                                    N = x + 228 | 0, h[N + (r[u2 >> 2] << 2) >> 2] = C + o(o(i - h[(N + (r[U0 >> 2] << 2) | 0) + 288 >> 2]) * o(0.5));
                                    break t;
                                  case 3:
                                    break o;
                                  default:
                                    break t;
                                }
                              t = E0(x, T, H), h[(x + (r[u2 >> 2] << 2) | 0) + 228 >> 2] = C + t, _ = x + (r[U0 >> 2] << 3) | 0, t = h[_ + 572 >> 2];
                              o: {
                                f:
                                  switch (N = r[_ + 576 >> 2], N | 0) {
                                    case 0:
                                    case 3:
                                      break o;
                                    default:
                                      break f;
                                  }
                                if (R = h[_ + 572 >> 2], !((N | 0) != 1 | R != R)) {
                                  if (t < o(0))
                                    break o;
                                  break t;
                                }
                                if (ve & !(t < o(0)) | ((N | 0) != 2 | R != R))
                                  break t;
                              }
                              o: {
                                if (Q >>> 0 >= 2) {
                                  S = i, t = h[x + 516 >> 2], R = o(t + o(E0(x, Q, H) + B0(x, Q, H)));
                                  break o;
                                }
                                S = o(h[x + 520 >> 2] + o(E0(x, T, H) + B0(x, T, H))), t = h[x + 516 >> 2], R = i;
                              }
                              o: {
                                f: {
                                  if (!(R != R | t != t)) {
                                    if (o(e2(o(R - t))) < o(9999999747378752e-20))
                                      break f;
                                    break o;
                                  }
                                  if (R == R | t == t)
                                    break o;
                                }
                                if (t = h[x + 520 >> 2], N = t != t, !(N | S != S)) {
                                  if (!(o(e2(o(S - t))) < o(9999999747378752e-20)))
                                    break o;
                                  break t;
                                }
                                if (S == S)
                                  break o;
                                if (N)
                                  break t;
                              }
                              Me(x, R, S, C2, 1, 1, H, r2, 1, 3, E, I, F, Z);
                              break t;
                            }
                            i2 = x, n2 = o(o(r0 - Mt(x)) + Se(x, 0, z0)), h[i2 + 232 >> 2] = n2;
                          }
                          if (n = n + 1 | 0, (u | 0) == (n | 0))
                            break;
                        }
                      if (N = (t0 | 0) != (O2 | 0), t0 = t0 + 1 | 0, n = u, !N)
                        break;
                    }
                  }
                  _ = e + 516 | 0, t = t2(e, 2, _r, a), n = t != t, i = o(o(X0(e, 2, a) + Z0(e, 2)) + o(H0(e, 2, a) + F0(e, 2)));
                  r: {
                    if (!(n | i != i)) {
                      t = d0(t, i);
                      break r;
                    }
                    t = n ? i : t;
                  }
                  h[_ >> 2] = t, t = t2(e, 0, Mr, l), n = t != t, i = o(o(X0(e, 0, a) + Z0(e, 0)) + o(H0(e, 0, a) + F0(e, 0)));
                  r: {
                    if (!(n | i != i)) {
                      t = d0(t, i);
                      break r;
                    }
                    t = n ? i : t;
                  }
                  h[e + 520 >> 2] = t;
                  r: {
                    t: {
                      n: {
                        if (we && (n = r[e + 24 >> 2] >>> 20 & 3, (n | 0) == 2 | (we | 0) != 2))
                          break n;
                        if (t = t2(e, Q, Ve, xe), n = t != t, i = o(o(X0(e, Q, a) + Z0(e, Q)) + o(H0(e, Q, a) + F0(e, Q))), !(n | i != i)) {
                          t = d0(t, i);
                          break t;
                        }
                        t = n ? i : t;
                        break t;
                      }
                      if ((we | 0) != 2 | (n | 0) != 2)
                        break r;
                      i = o(se + G0), n = i != i, t = t2(e, Q, Ve, xe);
                      n: {
                        if (!(n | t != t)) {
                          t = Tr(i, t);
                          break n;
                        }
                        t = n ? t : i;
                      }
                      if (n = t != t, !(n | se != se)) {
                        t = d0(t, se);
                        break t;
                      }
                      t = n ? se : t;
                    }
                    h[_ + (r[Te >> 2] << 2) >> 2] = t;
                  }
                  r: {
                    t: {
                      n: {
                        if (s0 && (u = (s0 | 0) != 2, n = r[e + 24 >> 2] >>> 20 & 3, u | (n | 0) == 2))
                          break n;
                        if (t = t2(e, T, o(L2 + ge), kt), n = t != t, i = o(o(X0(e, T, a) + Z0(e, T)) + o(H0(e, T, a) + F0(e, T))), !(n | i != i)) {
                          t = d0(t, i);
                          break t;
                        }
                        t = n ? i : t;
                        break t;
                      }
                      if (u | (n | 0) != 2)
                        break r;
                      i = o(L2 + z0), n = i != i, t = t2(e, T, o(L2 + ge), kt);
                      n: {
                        if (!(n | t != t)) {
                          t = Tr(i, t);
                          break n;
                        }
                        t = n ? t : i;
                      }
                      if (n = t != t, !(n | L2 != L2)) {
                        t = d0(t, L2);
                        break t;
                      }
                      t = n ? L2 : t;
                    }
                    h[_ + (r[U0 >> 2] << 2) >> 2] = t;
                  }
                  r: {
                    if (!p)
                      break r;
                    if ((r[e + 24 >> 2] & 786432) == 524288)
                      for (u = fe >>> 0 <= 1 ? 1 : fe, p = r[e + 556 >> 2], x = r[e + 560 >> 2] - p >> 2, n = 0; N = 0, N = n >>> 0 < x >>> 0 ? r[p + (n << 2) >> 2] : N, (r[N + 24 >> 2] & 196608) != 131072 && (N = N + 228 | 0, t0 = N + (r[u2 >> 2] << 2) | 0, c0 = r[U0 >> 2] << 2, h[t0 >> 2] = o(h[c0 + _ >> 2] - h[t0 >> 2]) - h[(N + c0 | 0) + 288 >> 2]), n = n + 1 | 0, (u | 0) != (n | 0); )
                        ;
                    if (u = r[e + 556 >> 2], p = r[e + 560 >> 2], (u | 0) != (p | 0))
                      for (t0 = ((Q >>> 0 > 1 ? we : f) | 0) != 0; ; ) {
                        f = r[u >> 2];
                        t: {
                          if ((r[f + 24 >> 2] & 4390912) != 131072)
                            break t;
                          R = H, G0 = r2, z[r[e + 568 >> 2] + 12 | 0] & 2 && (G0 = h[e + 520 >> 2], R = h[e + 516 >> 2]), n = r[e + 24 >> 2] >>> 2 & 3;
                          n: {
                            o: {
                              if ((C2 | 0) == 2) {
                                x = 0, N = 3;
                                f:
                                  switch (n - 2 | 0) {
                                    case 0:
                                      break n;
                                    case 1:
                                      break f;
                                    default:
                                      break o;
                                  }
                                N = 2;
                                break n;
                              }
                              if (x = 0, n >>> 0 <= 1)
                                break o;
                              N = n;
                              break n;
                            }
                            N = n, x = Ge;
                          }
                          l = o(E0(f, 2, R) + B0(f, 2, R)), a = E0(f, 0, R), S = B0(f, 0, R), t = h[f + 572 >> 2];
                          n: {
                            o: {
                              f:
                                switch (n = r[f + 576 >> 2], n | 0) {
                                  case 0:
                                  case 3:
                                    break o;
                                  default:
                                    break f;
                                }
                              i = h[f + 572 >> 2];
                              f: {
                                if (!((n | 0) != 1 | i != i)) {
                                  if (i = t, !(t < o(0)))
                                    break f;
                                  break o;
                                }
                                s: {
                                  if (!((n | 0) != 2 | i != i)) {
                                    if (R != R | t < o(0))
                                      break o;
                                    break s;
                                  }
                                  i = o(l0);
                                  u:
                                    switch (n - 1 | 0) {
                                      case 1:
                                        break s;
                                      case 0:
                                        break u;
                                      default:
                                        break f;
                                    }
                                  i = t;
                                  break f;
                                }
                                i = o(o(R * t) * o(0.009999999776482582));
                              }
                              i = o(l + i);
                              break n;
                            }
                            if (i = o(l0), !D2(f, 2) || !Ht(f, 2))
                              break n;
                            if (t = t2(f, 2, o(o(h[e + 516 >> 2] - o(Z0(e, 2) + F0(e, 2))) - o(Se(f, 2, R) + at(f, 2, R))), R), n = t != t, i = o(o(X0(f, 2, R) + Z0(f, 2)) + o(H0(f, 2, R) + F0(f, 2))), !(n | i != i)) {
                              i = d0(t, i);
                              break n;
                            }
                            i = n ? i : t;
                          }
                          S = o(a + S);
                          n: {
                            o: {
                              f: {
                                s: {
                                  u: {
                                    a: {
                                      l: {
                                        c0 = i != i, a = h[f + 580 >> 2];
                                        h: {
                                          c: {
                                            A:
                                              switch (n = r[f + 584 >> 2], n | 0) {
                                                case 0:
                                                case 3:
                                                  break c;
                                                default:
                                                  break A;
                                              }
                                            t = h[f + 580 >> 2];
                                            A: {
                                              if (!((n | 0) != 1 | t != t)) {
                                                if (t = a, !(t < o(0)))
                                                  break A;
                                                break c;
                                              }
                                              w: {
                                                if (!((n | 0) != 2 | t != t)) {
                                                  if (G0 != G0 | a < o(0))
                                                    break c;
                                                  break w;
                                                }
                                                t = o(l0);
                                                v:
                                                  switch (n - 1 | 0) {
                                                    case 1:
                                                      break w;
                                                    case 0:
                                                      break v;
                                                    default:
                                                      break A;
                                                  }
                                                t = a;
                                                break A;
                                              }
                                              t = o(o(G0 * a) * o(0.009999999776482582));
                                            }
                                            t = o(S + t);
                                            break h;
                                          }
                                          c: {
                                            if (D2(f, 0) && Ht(f, 0))
                                              break c;
                                            if (t = o(l0), i == i)
                                              break l;
                                            break f;
                                          }
                                          if (t = t2(f, 0, o(o(h[e + 520 >> 2] - o(Z0(e, 0) + F0(e, 0))) - o(Se(f, 0, G0) + at(f, 0, G0))), G0), n = t != t, a = o(o(X0(f, 0, R) + Z0(f, 0)) + o(H0(f, 0, R) + F0(f, 0))), !(n | a != a)) {
                                            t = d0(t, a);
                                            break h;
                                          }
                                          t = n ? a : t;
                                        }
                                        if ((c0 | 0) == (t != t | 0) || (C = h[f + 224 >> 2], C != C))
                                          break u;
                                        if (i != i) {
                                          i = o(o(o(t - S) * C) + l);
                                          break u;
                                        }
                                        if (t == t)
                                          break u;
                                        break a;
                                      }
                                      if (C = h[f + 224 >> 2], C != C)
                                        break s;
                                    }
                                    t = o(S + o(o(i - l) / C));
                                  }
                                  if (i != i)
                                    break f;
                                  if (t == t)
                                    break n;
                                }
                                n = 0;
                                break o;
                              }
                              n = 1;
                            }
                            c0 = R > o(0), O2 = n & t0 & N >>> 0 < 2, i = O2 && c0 ? R : i, n = n ^ 1, Me(f, i, t, C2, O2 && c0 ? 2 : n, t == t, i, t, 0, 6, E, I, F, Z), i = o(h[f + 516 >> 2] + cn(f, 2, R)), t = o(h[f + 520 >> 2] + cn(f, 0, R));
                          }
                          Me(f, i, t, C2, 1, 1, i, t, 1, 1, E, I, F, Z);
                          n: {
                            o: {
                              f: {
                                if (!Ht(f, N) || D2(f, N))
                                  break f;
                                n = r[(N << 2) + 4320 >> 2] << 2, t = N >>> 0 < 2 ? G0 : R, t = o(o(o(o(h[n + _ >> 2] - h[(n + f | 0) + 516 >> 2]) - F0(e, N)) - B0(f, N, t)) - at(f, N, t));
                                break o;
                              }
                              if (!(D2(f, N) | (r[e + 24 >> 2] & 112) != 16)) {
                                n = r[(N << 2) + 4320 >> 2] << 2, t = o(o(h[n + _ >> 2] - h[(n + f | 0) + 516 >> 2]) * o(0.5));
                                break o;
                              }
                              if (!(D2(f, N) | (r[e + 24 >> 2] & 112) != 32)) {
                                n = r[(N << 2) + 4320 >> 2] << 2, t = o(h[n + _ >> 2] - h[(n + f | 0) + 516 >> 2]);
                                break o;
                              }
                              if (!(z[r[e + 568 >> 2] + 12 | 0] & 2) || !D2(f, N))
                                break n;
                              t = h[_ + (r[(N << 2) + 4320 >> 2] << 2) >> 2], t = o(o(Se(f, N, t) + Z0(e, N)) + E0(f, N, t));
                            }
                            h[(f + (r[(N << 2) + 4288 >> 2] << 2) | 0) + 228 >> 2] = t;
                          }
                          n: {
                            o: {
                              if (!Ht(f, x) || D2(f, x))
                                break o;
                              n = r[(x << 2) + 4320 >> 2] << 2, t = N >>> 0 < 2 ? R : G0, t = o(o(o(o(h[n + _ >> 2] - h[(n + f | 0) + 516 >> 2]) - F0(e, x)) - B0(f, x, t)) - at(f, x, t));
                              break n;
                            }
                            o: {
                              if (D2(f, x) || (n = r[f + 24 >> 2] >>> 13 & 7, n || (n = r[e + 24 >> 2] >>> 10 & 7), (n | 0) != 2))
                                break o;
                              n = r[(x << 2) + 4320 >> 2] << 2, t = o(o(h[n + _ >> 2] - h[(n + f | 0) + 516 >> 2]) * o(0.5));
                              break n;
                            }
                            o: {
                              if (D2(f, x))
                                break o;
                              N = r[f + 24 >> 2] >>> 13 & 7, n = r[e + 24 >> 2], N = N || n >>> 10 & 7;
                              f: {
                                if ((N | 0) == 5) {
                                  if ((n & 786432) == 524288)
                                    break f;
                                  break o;
                                }
                                if (((N | 0) == 3 | 0) == ((n & 786432) == 524288 | 0))
                                  break o;
                              }
                              n = r[(x << 2) + 4320 >> 2] << 2, t = o(h[n + _ >> 2] - h[(n + f | 0) + 516 >> 2]);
                              break n;
                            }
                            if (!(z[r[e + 568 >> 2] + 12 | 0] & 2) || !D2(f, x))
                              break t;
                            t = h[_ + (r[(x << 2) + 4320 >> 2] << 2) >> 2], t = o(o(Se(f, x, t) + Z0(e, x)) + E0(f, x, t));
                          }
                          h[(f + (r[(x << 2) + 4288 >> 2] << 2) | 0) + 228 >> 2] = t;
                        }
                        if (u = u + 4 | 0, (p | 0) == (u | 0))
                          break;
                      }
                    if (!((T | Q) & 1))
                      break r;
                    for (u = T & 1, p = Q & 1, E = fe >>> 0 <= 1 ? 1 : fe, I = (T << 2) + 4304 | 0, F = (Q << 2) + 4304 | 0, Z = r[e + 556 >> 2], T = r[e + 560 >> 2] - Z >> 2, e = 0; ; ) {
                      if ((e | 0) == (T | 0))
                        break i;
                      n = r[Z + (e << 2) >> 2];
                      t: {
                        if (z[n + 26 | 0] & 64 || (p && (f = n + 228 | 0, N = r[Te >> 2] << 2, h[f + (r[F >> 2] << 2) >> 2] = o(h[N + _ >> 2] - h[(f + N | 0) + 288 >> 2]) - h[f + (r[q2 >> 2] << 2) >> 2]), !u))
                          break t;
                        n = n + 228 | 0, f = r[U0 >> 2] << 2, h[n + (r[I >> 2] << 2) >> 2] = o(h[f + _ >> 2] - h[(n + f | 0) + 288 >> 2]) - h[n + (r[u2 >> 2] << 2) >> 2];
                      }
                      if (e = e + 1 | 0, (E | 0) == (e | 0))
                        break;
                    }
                  }
                  if (!S2)
                    break e;
                  m2(S2);
                  break e;
                }
                We(), V0();
              }
              U = v + 384 | 0;
            }
            function Wi() {
              var e = 0, t = 0;
              Ke(7032, 7033, 7034, 0, 4352, 17, 4355, 0, 4355, 0, 2529, 4357, 18), e = B(8), r[e >> 2] = 8, r[e + 4 >> 2] = 1, D(7032, 2922, 6, 4368, 4392, 19, e | 0, 1), Ke(7036, 7037, 7038, 7032, 4352, 20, 4352, 21, 4352, 22, 2001, 4357, 23), e = B(4), r[e >> 2] = 24, D(7036, 2359, 2, 4400, 4408, 25, e | 0, 0), pe(7032, 1398, 2, 4412, 4420, 26, 27), pe(7032, 3027, 3, 4500, 4512, 28, 29), Ke(7056, 7057, 7058, 0, 4352, 30, 4355, 0, 4355, 0, 2545, 4357, 31), e = B(8), r[e >> 2] = 8, r[e + 4 >> 2] = 1, D(7056, 3293, 2, 4520, 4408, 32, e | 0, 1), Ke(7059, 7060, 7061, 7056, 4352, 33, 4352, 34, 4352, 35, 2024, 4357, 36), e = B(4), r[e >> 2] = 37, D(7059, 2359, 2, 4528, 4408, 38, e | 0, 0), pe(7056, 1398, 2, 4536, 4420, 39, 40), pe(7056, 3027, 3, 4500, 4512, 28, 41), Ke(7062, 7063, 7064, 0, 4352, 42, 4355, 0, 4355, 0, 2861, 4357, 43), Ri(7062, 1, 4584, 4352, 44, 45), pe(7062, 2915, 1, 4584, 4352, 44, 45), pe(7062, 1129, 2, 4588, 4408, 46, 47), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 48, D(7062, 3234, 4, 4608, 4624, 49, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 50, D(7062, 1981, 3, 4632, 4644, 51, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 52, D(7062, 1952, 3, 4652, 4664, 53, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 54, D(7062, 3389, 3, 4672, 4664, 55, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 56, D(7062, 1800, 3, 4652, 4664, 53, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 57, D(7062, 3264, 3, 4684, 4512, 58, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 59, D(7062, 1926, 2, 4696, 4420, 60, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 61, D(7062, 3399, 2, 4704, 4420, 62, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 63, D(7062, 1785, 2, 4696, 4420, 60, e | 0, 0), Rr(7065, 1271, 4712, 64, 4357, 65), it(1732, 0), it(1612, 8), it(2145, 16), it(2455, 24), it(2561, 32), it(1618, 40), dr(7065), Rr(7035, 2898, 4712, 66, 4357, 67), tn(2561, 0), tn(1618, 8), dr(7035), Rr(7066, 2909, 4712, 68, 4357, 69), e = B(4), r[e >> 2] = 8, t = B(4), r[t >> 2] = 8, Pt(7066, 2903, 7098, 4714, 70, e | 0, 7098, 4718, 71, t | 0), e = B(4), r[e >> 2] = 0, t = B(4), r[t >> 2] = 0, Pt(7066, 1607, 7091, 4420, 72, e | 0, 7091, 4664, 73, t | 0), dr(7066), Ke(7067, 7068, 7069, 0, 4352, 74, 4355, 0, 4355, 0, 3022, 4357, 75), Ri(7067, 1, 4724, 4352, 76, 77), pe(7067, 1593, 1, 4724, 4352, 76, 77), pe(7067, 2851, 2, 4728, 4420, 78, 79), pe(7067, 1129, 2, 4736, 4408, 80, 81), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 82, D(7067, 1753, 2, 4736, 4408, 83, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 84, D(7067, 3005, 3, 4744, 4664, 85, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 86, D(7067, 2930, 3, 4756, 4664, 87, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 88, D(7067, 2335, 4, 4768, 4784, 89, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 90, D(7067, 1485, 4, 4768, 4784, 89, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 91, D(7067, 1356, 3, 4756, 4664, 87, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 92, D(7067, 1818, 3, 4756, 4664, 87, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 93, D(7067, 2872, 3, 4756, 4664, 87, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 94, D(7067, 2379, 3, 4756, 4664, 87, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 95, D(7067, 2164, 3, 4756, 4664, 87, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 96, D(7067, 1320, 3, 4756, 4664, 87, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 97, D(7067, 2413, 4, 4768, 4784, 89, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 98, D(7067, 1504, 4, 4768, 4784, 89, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 99, D(7067, 2236, 3, 4756, 4664, 87, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 100, D(7067, 1220, 3, 4756, 4664, 87, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 101, D(7067, 1137, 3, 4756, 4664, 87, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 102, D(7067, 1159, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 104, D(7067, 1846, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 105, D(7067, 1465, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 106, D(7067, 2219, 2, 4736, 4408, 83, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 107, D(7067, 1196, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 108, D(7067, 2501, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 109, D(7067, 2591, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 110, D(7067, 1540, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 111, D(7067, 2250, 2, 4736, 4408, 83, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 112, D(7067, 1651, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 113, D(7067, 1428, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 114, D(7067, 2205, 2, 4736, 4408, 83, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 115, D(7067, 2609, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 116, D(7067, 1556, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 117, D(7067, 1671, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 118, D(7067, 1445, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 119, D(7067, 2567, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 120, D(7067, 1521, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 121, D(7067, 1625, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 122, D(7067, 1408, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 123, D(7067, 2305, 3, 4792, 4718, 103, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 124, D(7067, 2093, 4, 4768, 4784, 89, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 125, D(7067, 2719, 4, 4768, 4784, 89, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 126, D(7067, 1575, 4, 4768, 4784, 89, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 127, D(7067, 2188, 4, 4768, 4784, 89, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 128, D(7067, 2946, 2, 4804, 4420, 129, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 130, D(7067, 2347, 3, 4812, 4512, 131, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 132, D(7067, 1372, 2, 4804, 4420, 129, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 133, D(7067, 1832, 2, 4804, 4420, 129, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 134, D(7067, 2885, 2, 4804, 4420, 129, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 135, D(7067, 2396, 2, 4804, 4420, 129, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 136, D(7067, 2176, 2, 4804, 4420, 129, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 137, D(7067, 1338, 2, 4804, 4420, 129, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 138, D(7067, 2423, 3, 4812, 4512, 131, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 139, D(7067, 1859, 2, 4824, 4420, 140, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 141, D(7067, 1208, 2, 4832, 4714, 142, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 143, D(7067, 2515, 2, 4832, 4714, 142, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 144, D(7067, 2600, 2, 4824, 4420, 140, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 145, D(7067, 1661, 2, 4824, 4420, 140, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 146, D(7067, 2621, 2, 4824, 4420, 140, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 147, D(7067, 1684, 2, 4824, 4420, 140, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 148, D(7067, 2579, 2, 4824, 4420, 140, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 149, D(7067, 1638, 2, 4824, 4420, 140, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 150, D(7067, 2320, 2, 4832, 4714, 142, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 151, D(7067, 2103, 3, 4840, 4852, 152, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 153, D(7067, 1232, 2, 4804, 4420, 129, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 154, D(7067, 1148, 2, 4804, 4420, 129, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 155, D(7067, 2730, 3, 4812, 4512, 131, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 156, D(7067, 2195, 3, 4860, 4872, 157, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 158, D(7067, 3034, 4, 4880, 4624, 159, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 160, D(7067, 3055, 3, 4896, 4664, 161, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 162, D(7067, 1293, 2, 4908, 4420, 163, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 164, D(7067, 1388, 2, 4916, 4420, 165, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 166, D(7067, 3046, 3, 4924, 4512, 167, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 168, D(7067, 2962, 2, 4936, 4420, 169, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 170, D(7067, 2982, 3, 4944, 4664, 171, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 172, D(7067, 3357, 3, 4956, 4664, 173, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 174, D(7067, 3355, 2, 4736, 4408, 83, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 175, D(7067, 3374, 3, 4968, 4664, 176, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 177, D(7067, 3372, 2, 4736, 4408, 83, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 178, D(7067, 1119, 2, 4736, 4408, 83, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 179, D(7067, 1111, 2, 4980, 4420, 180, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 181, D(7067, 1244, 5, 4992, 5012, 182, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 183, D(7067, 1737, 2, 4832, 4714, 142, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 184, D(7067, 1715, 2, 4832, 4714, 142, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 185, D(7067, 2149, 2, 4832, 4714, 142, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 186, D(7067, 2462, 2, 4832, 4714, 142, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 187, D(7067, 2633, 2, 4832, 4714, 142, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 188, D(7067, 1697, 2, 4832, 4714, 142, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 189, D(7067, 1260, 2, 5020, 4420, 190, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 191, D(7067, 2433, 3, 4840, 4852, 152, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 192, D(7067, 2113, 3, 4840, 4852, 152, e | 0, 0), e = B(8), r[e + 4 >> 2] = 0, r[e >> 2] = 193, D(7067, 2741, 3, 4840, 4852, 152, e | 0, 0);
            }
            function t4(e, t, i, n, f, u) {
              e = e | 0, t = +t, i = i | 0, n = n | 0, f = f | 0, u = u | 0;
              var a = 0, l = 0, p = 0, E = 0, I = 0, F = 0, Z = 0, T = 0, v = 0, R = 0, N = 0, S = 0, x = 0, C = 0, _ = 0, H = 0, Q = 0, t0 = 0, r0 = 0;
              Z = U - 560 | 0, U = Z, r[Z + 44 >> 2] = 0, N2(+t), a = O0(1) | 0, O0(0) | 0;
              e: {
                if ((a | 0) < 0) {
                  x = 1, t0 = 1177, t = -t, N2(+t), a = O0(1) | 0, O0(0) | 0;
                  break e;
                }
                if (f & 2048) {
                  x = 1, t0 = 1180;
                  break e;
                }
                x = f & 1, t0 = x ? 1183 : 1178, r0 = !x;
              }
              e: {
                if ((a & 2146435072) == 2146435072) {
                  a = x + 3 | 0, w2(e, 32, i, a, f & -65537), c2(e, t0, x), n = u & 32, c2(e, t != t ? n ? 2451 : 3459 : n ? 2868 : 3463, 3), w2(e, 32, i, a, f ^ 8192), T = (i | 0) < (a | 0) ? a : i;
                  break e;
                }
                _ = Z + 16 | 0;
                i: {
                  r: {
                    t: {
                      if (t = Ui(t, Z + 44 | 0), t = t + t, t != 0) {
                        if (a = r[Z + 44 >> 2], r[Z + 44 >> 2] = a - 1, H = u | 32, (H | 0) != 97)
                          break t;
                        break i;
                      }
                      if (H = u | 32, (H | 0) == 97)
                        break i;
                      I = r[Z + 44 >> 2], F = (n | 0) < 0 ? 6 : n;
                      break r;
                    }
                    I = a - 29 | 0, r[Z + 44 >> 2] = I, t = t * 268435456, F = (n | 0) < 0 ? 6 : n;
                  }
                  for (N = (Z + 48 | 0) + ((I | 0) >= 0 ? 288 : 0) | 0, l = N; t < 4294967296 & t >= 0 ? n = ~~t >>> 0 : n = 0, r[l >> 2] = n, l = l + 4 | 0, t = (t - +(n >>> 0)) * 1e9, t != 0; )
                    ;
                  r: {
                    if ((I | 0) <= 0) {
                      n = I, a = l, p = N;
                      break r;
                    }
                    for (p = N, n = I; ; ) {
                      v = (n | 0) >= 29 ? 29 : n, a = l - 4 | 0;
                      t: {
                        if (p >>> 0 > a >>> 0)
                          break t;
                        for (n = 0; E = r[a >> 2], Q = n, n = v & 31, (v & 63) >>> 0 >= 32 ? (T = E << n, n = 0) : (T = (1 << n) - 1 & E >>> 32 - n, n = E << n), Q = Q + n | 0, E = T + R | 0, n = Ti(Q, n >>> 0 > Q >>> 0 ? E + 1 | 0 : E, 1e9), E = Ir(n, I2, -1e9, 0) + Q | 0, r[a >> 2] = E, a = a - 4 | 0, p >>> 0 <= a >>> 0; )
                          ;
                        if (!n)
                          break t;
                        p = p - 4 | 0, r[p >> 2] = n;
                      }
                      for (; a = l, p >>> 0 < a >>> 0 && (l = a - 4 | 0, !r[l >> 2]); )
                        ;
                      if (n = r[Z + 44 >> 2] - v | 0, r[Z + 44 >> 2] = n, l = a, !((n | 0) > 0))
                        break;
                    }
                  }
                  if ((n | 0) < 0)
                    for (C = ((F + 25 >>> 0) / 9 | 0) + 1 | 0, R = (H | 0) == 102; ; ) {
                      n = 0 - n | 0, T = (n | 0) >= 9 ? 9 : n;
                      r: {
                        if (a >>> 0 <= p >>> 0) {
                          l = r[p >> 2];
                          break r;
                        }
                        for (v = 1e9 >>> T | 0, E = -1 << T ^ -1, n = 0, l = p; Q = n, n = r[l >> 2], r[l >> 2] = Q + (n >>> T | 0), n = $0(v, n & E), l = l + 4 | 0, l >>> 0 < a >>> 0; )
                          ;
                        if (l = r[p >> 2], !n)
                          break r;
                        r[a >> 2] = n, a = a + 4 | 0;
                      }
                      if (n = T + r[Z + 44 >> 2] | 0, r[Z + 44 >> 2] = n, p = (!l << 2) + p | 0, l = R ? N : p, a = a - l >> 2 > (C | 0) ? l + (C << 2) | 0 : a, !((n | 0) < 0))
                        break;
                    }
                  n = 0;
                  r: {
                    if (a >>> 0 <= p >>> 0 || (n = $0(N - p >> 2, 9), l = 10, E = r[p >> 2], E >>> 0 < 10))
                      break r;
                    for (; n = n + 1 | 0, l = $0(l, 10), E >>> 0 >= l >>> 0; )
                      ;
                  }
                  if (l = (F - ((H | 0) != 102 ? n : 0) | 0) - ((H | 0) == 103 & (F | 0) != 0) | 0, (l | 0) < ($0(a - N >> 2, 9) - 9 | 0)) {
                    if (v = l + 9216 | 0, E = (v | 0) / 9 | 0, I = ((((I | 0) < 0 ? 4 : 292) + Z | 0) + (E << 2) | 0) - 4048 | 0, l = 10, T = v + $0(E, -9) | 0, (T | 0) <= 7)
                      for (; l = $0(l, 10), T = T + 1 | 0, (T | 0) != 8; )
                        ;
                    v = r[I >> 2], C = (v >>> 0) / (l >>> 0) | 0, R = $0(C, l), E = I + 4 | 0;
                    r: {
                      if ((v | 0) == (R | 0) & (E | 0) == (a | 0))
                        break r;
                      v = v - R | 0;
                      t: {
                        if (!(C & 1) && (t = 9007199254740992, !(P[I - 4 | 0] & 1) | ((l | 0) != 1e9 | p >>> 0 >= I >>> 0)))
                          break t;
                        t = 9007199254740994;
                      }
                      if (S = (a | 0) == (E | 0) ? 1 : 1.5, E = l >>> 1 | 0, S = E >>> 0 > v >>> 0 ? 0.5 : (E | 0) == (v | 0) ? S : 1.5, z[t0 | 0] != 45 | r0 || (S = -S, t = -t), r[I >> 2] = R, t + S == t)
                        break r;
                      if (n = l + R | 0, r[I >> 2] = n, n >>> 0 >= 1e9)
                        for (; r[I >> 2] = 0, I = I - 4 | 0, I >>> 0 < p >>> 0 && (p = p - 4 | 0, r[p >> 2] = 0), n = r[I >> 2] + 1 | 0, r[I >> 2] = n, n >>> 0 > 999999999; )
                          ;
                      if (n = $0(N - p >> 2, 9), l = 10, E = r[p >> 2], E >>> 0 < 10)
                        break r;
                      for (; n = n + 1 | 0, l = $0(l, 10), E >>> 0 >= l >>> 0; )
                        ;
                    }
                    l = I + 4 | 0, a = a >>> 0 > l >>> 0 ? l : a;
                  }
                  for (; E = a, v = a >>> 0 <= p >>> 0, !v && (a = E - 4 | 0, !r[a >> 2]); )
                    ;
                  r: {
                    if ((H | 0) != 103) {
                      I = f & 8;
                      break r;
                    }
                    if (l = F || 1, a = (l | 0) > (n | 0) & (n | 0) > -5, F = (a ? n ^ -1 : -1) + l | 0, u = (a ? -1 : -2) + u | 0, I = f & 8, I)
                      break r;
                    a = -9;
                    t: {
                      if (v || (I = r[E - 4 >> 2], !I) || (T = 10, a = 0, (I >>> 0) % 10 | 0))
                        break t;
                      for (; l = a, a = a + 1 | 0, T = $0(T, 10), !((I >>> 0) % (T >>> 0) | 0); )
                        ;
                      a = l ^ -1;
                    }
                    if (l = $0(E - N >> 2, 9), (u & -33) == 70) {
                      I = 0, a = (a + l | 0) - 9 | 0, a = (a | 0) > 0 ? a : 0, F = (a | 0) > (F | 0) ? F : a;
                      break r;
                    }
                    I = 0, a = ((n + l | 0) + a | 0) - 9 | 0, a = (a | 0) > 0 ? a : 0, F = (a | 0) > (F | 0) ? F : a;
                  }
                  if (T = -1, v = I | F, ((v ? 2147483645 : 2147483646) | 0) < (F | 0))
                    break e;
                  R = (((v | 0) != 0) + F | 0) + 1 | 0, l = u & -33;
                  r: {
                    if ((l | 0) == 70) {
                      if ((R ^ 2147483647) < (n | 0))
                        break e;
                      a = (n | 0) > 0 ? n : 0;
                      break r;
                    }
                    if (a = n >> 31, a = et((a ^ n) - a | 0, 0, _), (_ - a | 0) <= 1)
                      for (; a = a - 1 | 0, P[a | 0] = 48, (_ - a | 0) < 2; )
                        ;
                    if (C = a - 2 | 0, P[C | 0] = u, P[a - 1 | 0] = (n | 0) < 0 ? 45 : 43, a = _ - C | 0, (a | 0) > (R ^ 2147483647))
                      break e;
                  }
                  if (n = a + R | 0, (n | 0) > (x ^ 2147483647))
                    break e;
                  R = n + x | 0, w2(e, 32, i, R, f), c2(e, t0, x), w2(e, 48, i, R, f ^ 65536);
                  r: {
                    t: {
                      n: {
                        if ((l | 0) == 70) {
                          for (u = Z + 16 | 0, n = u | 8, I = u | 9, l = p >>> 0 > N >>> 0 ? N : p, p = l; ; ) {
                            a = et(r[p >> 2], 0, I);
                            o: {
                              if ((l | 0) != (p | 0)) {
                                if (Z + 16 >>> 0 >= a >>> 0)
                                  break o;
                                for (; a = a - 1 | 0, P[a | 0] = 48, Z + 16 >>> 0 < a >>> 0; )
                                  ;
                                break o;
                              }
                              if ((a | 0) != (I | 0))
                                break o;
                              P[Z + 24 | 0] = 48, a = n;
                            }
                            if (c2(e, a, I - a | 0), p = p + 4 | 0, !(N >>> 0 >= p >>> 0))
                              break;
                          }
                          if (v && c2(e, 4275, 1), (F | 0) <= 0 | p >>> 0 >= E >>> 0)
                            break n;
                          for (; ; ) {
                            if (a = et(r[p >> 2], 0, I), a >>> 0 > Z + 16 >>> 0)
                              for (; a = a - 1 | 0, P[a | 0] = 48, Z + 16 >>> 0 < a >>> 0; )
                                ;
                            if (c2(e, a, (F | 0) >= 9 ? 9 : F), a = F - 9 | 0, p = p + 4 | 0, E >>> 0 <= p >>> 0)
                              break t;
                            if (n = (F | 0) > 9, F = a, !n)
                              break;
                          }
                          break t;
                        }
                        o: {
                          if ((F | 0) < 0)
                            break o;
                          for (N = p >>> 0 < E >>> 0 ? E : p + 4 | 0, u = Z + 16 | 0, n = u | 8, E = u | 9, l = p; ; ) {
                            a = et(r[l >> 2], 0, E), (E | 0) == (a | 0) && (P[Z + 24 | 0] = 48, a = n);
                            f: {
                              if ((l | 0) != (p | 0)) {
                                if (Z + 16 >>> 0 >= a >>> 0)
                                  break f;
                                for (; a = a - 1 | 0, P[a | 0] = 48, Z + 16 >>> 0 < a >>> 0; )
                                  ;
                                break f;
                              }
                              if (c2(e, a, 1), a = a + 1 | 0, !(I | F))
                                break f;
                              c2(e, 4275, 1);
                            }
                            if (u = E - a | 0, c2(e, a, (u | 0) > (F | 0) ? F : u), F = F - u | 0, l = l + 4 | 0, N >>> 0 <= l >>> 0)
                              break o;
                            if (!((F | 0) >= 0))
                              break;
                          }
                        }
                        w2(e, 48, F + 18 | 0, 18, 0), c2(e, C, _ - C | 0);
                        break r;
                      }
                      a = F;
                    }
                    w2(e, 48, a + 9 | 0, 9, 0);
                  }
                  w2(e, 32, i, R, f ^ 8192), T = (i | 0) < (R | 0) ? R : i;
                  break e;
                }
                I = (u << 26 >> 31 & 9) + t0 | 0;
                i: {
                  if (n >>> 0 > 11)
                    break i;
                  for (a = 12 - n | 0, S = 16; S = S * 16, a = a - 1 | 0, !!a; )
                    ;
                  if (z[I | 0] == 45) {
                    t = -(S + (-t - S));
                    break i;
                  }
                  t = t + S - S;
                }
                for (N = x | 2, p = u & 32, l = r[Z + 44 >> 2], a = l >> 31, a = et((a ^ l) - a | 0, 0, _), (_ | 0) == (a | 0) && (P[Z + 15 | 0] = 48, a = Z + 15 | 0), F = a - 2 | 0, P[F | 0] = u + 15, P[a - 1 | 0] = (l | 0) < 0 ? 45 : 43, a = f & 8, l = Z + 16 | 0; u = l, e2(t) < 2147483648 ? E = ~~t : E = -2147483648, P[l | 0] = p | z[E + 5504 | 0], t = (t - +(E | 0)) * 16, l = u + 1 | 0, !(a | (n | 0) > 0) & t == 0 | (l - (Z + 16 | 0) | 0) != 1 || (P[u + 1 | 0] = 46, l = u + 2 | 0), t != 0; )
                  ;
                if (T = -1, a = _ - F | 0, u = a + N | 0, (2147483645 - u | 0) < (n | 0))
                  break e;
                i: {
                  r: {
                    if (!n || (p = l - (Z + 16 | 0) | 0, (p - 2 | 0) >= (n | 0)))
                      break r;
                    n = n + 2 | 0;
                    break i;
                  }
                  p = l - (Z + 16 | 0) | 0, n = p;
                }
                u = n + u | 0, w2(e, 32, i, u, f), c2(e, I, N), w2(e, 48, i, u, f ^ 65536), c2(e, Z + 16 | 0, p), w2(e, 48, n - p | 0, 0, 0), c2(e, F, a), w2(e, 32, i, u, f ^ 8192), T = (i | 0) < (u | 0) ? u : i;
              }
              return U = Z + 560 | 0, T | 0;
            }
            function Oi(e, t, i, n, f, u, a) {
              var l = 0, p = 0, E = 0, I = 0, F = 0, Z = 0, T = 0, v = 0, R = 0, N = 0, S = 0, x = 0, C = 0, _ = 0, H = 0, Q = 0, t0 = 0, r0 = 0, s0 = 0, c0 = 0;
              E = U - 80 | 0, U = E, r[E + 76 >> 2] = t, r0 = E + 55 | 0, C = E + 56 | 0;
              e: {
                i: {
                  r: {
                    t: {
                      n:
                        for (; ; ) {
                          if (I = t, (R ^ 2147483647) < (l | 0))
                            break t;
                          R = l + R | 0;
                          o: {
                            f: {
                              s: {
                                if (l = I, p = z[l | 0], p)
                                  for (; ; ) {
                                    u: {
                                      t = p & 255;
                                      a: {
                                        if (!t) {
                                          t = l;
                                          break a;
                                        }
                                        if ((t | 0) != 37)
                                          break u;
                                        for (p = l; ; ) {
                                          if (z[p + 1 | 0] != 37) {
                                            t = p;
                                            break a;
                                          }
                                          if (l = l + 1 | 0, F = z[p + 2 | 0], t = p + 2 | 0, p = t, (F | 0) != 37)
                                            break;
                                        }
                                      }
                                      if (l = l - I | 0, t0 = R ^ 2147483647, (l | 0) > (t0 | 0))
                                        break t;
                                      if (e && c2(e, I, l), l)
                                        continue n;
                                      r[E + 76 >> 2] = t, l = t + 1 | 0, S = -1, p = P[t + 1 | 0], !Ut(p) | z[t + 2 | 0] != 36 || (S = p - 48 | 0, _ = 1, l = t + 3 | 0), r[E + 76 >> 2] = l, v = 0, p = P[l | 0], t = p - 32 | 0;
                                      a: {
                                        if (t >>> 0 > 31) {
                                          F = l;
                                          break a;
                                        }
                                        if (F = l, t = 1 << t, !(t & 75913))
                                          break a;
                                        for (; ; ) {
                                          if (F = l + 1 | 0, r[E + 76 >> 2] = F, v = t | v, p = P[l + 1 | 0], t = p - 32 | 0, t >>> 0 >= 32)
                                            break a;
                                          if (l = F, t = 1 << t, !(t & 75913))
                                            break;
                                        }
                                      }
                                      a: {
                                        if ((p | 0) == 42) {
                                          t = P[F + 1 | 0];
                                          l: {
                                            if (!(!Ut(t) | z[F + 2 | 0] != 36)) {
                                              r[((t << 2) + f | 0) - 192 >> 2] = 10, p = F + 3 | 0, _ = 1, N = r[((P[F + 1 | 0] << 3) + n | 0) - 384 >> 2];
                                              break l;
                                            }
                                            if (_)
                                              break s;
                                            if (p = F + 1 | 0, !e) {
                                              r[E + 76 >> 2] = p, _ = 0, N = 0;
                                              break a;
                                            }
                                            t = r[i >> 2], r[i >> 2] = t + 4, _ = 0, N = r[t >> 2];
                                          }
                                          if (r[E + 76 >> 2] = p, (N | 0) >= 0)
                                            break a;
                                          N = 0 - N | 0, v = v | 8192;
                                          break a;
                                        }
                                        if (N = Qi(E + 76 | 0), (N | 0) < 0)
                                          break t;
                                        p = r[E + 76 >> 2];
                                      }
                                      l = 0, T = -1;
                                      a: {
                                        if (z[p | 0] != 46) {
                                          t = p, x = 0;
                                          break a;
                                        }
                                        if (z[p + 1 | 0] == 42) {
                                          t = P[p + 2 | 0];
                                          l: {
                                            if (!(!Ut(t) | z[p + 3 | 0] != 36)) {
                                              r[((t << 2) + f | 0) - 192 >> 2] = 10, t = p + 4 | 0, T = r[((P[p + 2 | 0] << 3) + n | 0) - 384 >> 2];
                                              break l;
                                            }
                                            if (_)
                                              break s;
                                            if (t = p + 2 | 0, T = 0, !e)
                                              break l;
                                            p = r[i >> 2], r[i >> 2] = p + 4, T = r[p >> 2];
                                          }
                                          r[E + 76 >> 2] = t, x = (T ^ -1) >>> 31 | 0;
                                          break a;
                                        }
                                        r[E + 76 >> 2] = p + 1, T = Qi(E + 76 | 0), t = r[E + 76 >> 2], x = 1;
                                      }
                                      for (; ; ) {
                                        if (Z = l, F = 28, H = t, l = P[t | 0], l - 123 >>> 0 < 4294967238)
                                          break r;
                                        if (t = H + 1 | 0, l = z[(l + $0(Z, 58) | 0) + 4975 | 0], !(l - 1 >>> 0 < 8))
                                          break;
                                      }
                                      r[E + 76 >> 2] = t;
                                      a: {
                                        l: {
                                          if ((l | 0) != 27) {
                                            if (!l)
                                              break r;
                                            if ((S | 0) >= 0) {
                                              r[(S << 2) + f >> 2] = l, l = (S << 3) + n | 0, p = r[l + 4 >> 2], r[E + 64 >> 2] = r[l >> 2], r[E + 68 >> 2] = p;
                                              break l;
                                            }
                                            if (!e)
                                              break o;
                                            Bi(E - -64 | 0, l, i, a);
                                            break a;
                                          }
                                          if ((S | 0) >= 0)
                                            break r;
                                        }
                                        if (l = 0, !e)
                                          continue n;
                                      }
                                      p = v & -65537, v = v & 8192 ? p : v, S = 0, Q = 1167, F = C;
                                      a: {
                                        l: {
                                          h: {
                                            c: {
                                              A: {
                                                w: {
                                                  v: {
                                                    k: {
                                                      p: {
                                                        g: {
                                                          m: {
                                                            R: {
                                                              E: {
                                                                y: {
                                                                  N: {
                                                                    d:
                                                                      switch (l = P[H | 0], l = Z && (l & 15) == 3 ? l & -33 : l, l - 88 | 0) {
                                                                        case 11:
                                                                          break a;
                                                                        case 9:
                                                                        case 13:
                                                                        case 14:
                                                                        case 15:
                                                                          break l;
                                                                        case 27:
                                                                          break v;
                                                                        case 12:
                                                                        case 17:
                                                                          break g;
                                                                        case 23:
                                                                          break m;
                                                                        case 0:
                                                                        case 32:
                                                                          break R;
                                                                        case 24:
                                                                          break E;
                                                                        case 22:
                                                                          break y;
                                                                        case 29:
                                                                          break N;
                                                                        case 1:
                                                                        case 2:
                                                                        case 3:
                                                                        case 4:
                                                                        case 5:
                                                                        case 6:
                                                                        case 7:
                                                                        case 8:
                                                                        case 10:
                                                                        case 16:
                                                                        case 18:
                                                                        case 19:
                                                                        case 20:
                                                                        case 21:
                                                                        case 25:
                                                                        case 26:
                                                                        case 28:
                                                                        case 30:
                                                                        case 31:
                                                                          break f;
                                                                        default:
                                                                          break d;
                                                                      }
                                                                    d:
                                                                      switch (l - 65 | 0) {
                                                                        case 0:
                                                                        case 4:
                                                                        case 5:
                                                                        case 6:
                                                                          break l;
                                                                        case 2:
                                                                          break A;
                                                                        case 1:
                                                                        case 3:
                                                                          break f;
                                                                        default:
                                                                          break d;
                                                                      }
                                                                    if ((l | 0) == 83)
                                                                      break w;
                                                                    break f;
                                                                  }
                                                                  p = r[E + 64 >> 2], Z = r[E + 68 >> 2], l = 1167;
                                                                  break p;
                                                                }
                                                                l = 0;
                                                                y:
                                                                  switch (Z & 255) {
                                                                    case 0:
                                                                      r[r[E + 64 >> 2] >> 2] = R;
                                                                      continue n;
                                                                    case 1:
                                                                      r[r[E + 64 >> 2] >> 2] = R;
                                                                      continue n;
                                                                    case 2:
                                                                      I = r[E + 64 >> 2], r[I >> 2] = R, r[I + 4 >> 2] = R >> 31;
                                                                      continue n;
                                                                    case 3:
                                                                      te[r[E + 64 >> 2] >> 1] = R;
                                                                      continue n;
                                                                    case 4:
                                                                      P[r[E + 64 >> 2]] = R;
                                                                      continue n;
                                                                    case 6:
                                                                      r[r[E + 64 >> 2] >> 2] = R;
                                                                      continue n;
                                                                    case 7:
                                                                      break y;
                                                                    default:
                                                                      continue n;
                                                                  }
                                                                I = r[E + 64 >> 2], r[I >> 2] = R, r[I + 4 >> 2] = R >> 31;
                                                                continue n;
                                                              }
                                                              T = T >>> 0 <= 8 ? 8 : T, v = v | 8, l = 120;
                                                            }
                                                            if (I = C, p = r[E + 64 >> 2], Z = r[E + 68 >> 2], p | Z)
                                                              for (s0 = l & 32; I = I - 1 | 0, P[I | 0] = s0 | z[(p & 15) + 5504 | 0], c0 = !Z & p >>> 0 > 15 | (Z | 0) != 0, H = Z, Z = Z >>> 4 | 0, p = (H & 15) << 28 | p >>> 4, !!c0; )
                                                                ;
                                                            if (!(v & 8) | !(r[E + 64 >> 2] | r[E + 68 >> 2]))
                                                              break k;
                                                            Q = (l >>> 4 | 0) + 1167 | 0, S = 2;
                                                            break k;
                                                          }
                                                          if (l = C, I = r[E + 68 >> 2], Z = I, p = r[E + 64 >> 2], I | p)
                                                            for (; l = l - 1 | 0, P[l | 0] = p & 7 | 48, H = !Z & p >>> 0 > 7 | (Z | 0) != 0, I = Z, Z = I >>> 3 | 0, p = (I & 7) << 29 | p >>> 3, !!H; )
                                                              ;
                                                          if (I = l, !(v & 8))
                                                            break k;
                                                          l = C - I | 0, T = (l | 0) < (T | 0) ? T : l + 1 | 0;
                                                          break k;
                                                        }
                                                        if (p = r[E + 64 >> 2], l = r[E + 68 >> 2], Z = l, (l | 0) < 0) {
                                                          I = 0 - (Z + ((p | 0) != 0) | 0) | 0, Z = I, p = 0 - p | 0, r[E + 64 >> 2] = p, r[E + 68 >> 2] = I, S = 1, l = 1167;
                                                          break p;
                                                        }
                                                        if (v & 2048) {
                                                          S = 1, l = 1168;
                                                          break p;
                                                        }
                                                        S = v & 1, l = S ? 1169 : 1167;
                                                      }
                                                      Q = l, I = et(p, Z, C);
                                                    }
                                                    if ((T | 0) < 0 && x)
                                                      break t;
                                                    if (v = x ? v & -65537 : v, l = r[E + 64 >> 2], p = r[E + 68 >> 2], !((l | p) != 0 | T)) {
                                                      I = C, T = 0;
                                                      break f;
                                                    }
                                                    l = !(l | p) + (C - I | 0) | 0, T = (l | 0) < (T | 0) ? T : l;
                                                    break f;
                                                  }
                                                  v = 0, x = T >>> 0 >= 2147483647 ? 2147483647 : T, Z = x, F = (Z | 0) != 0;
                                                  v: {
                                                    k: {
                                                      l = r[E + 64 >> 2], I = l || 4277, l = I;
                                                      p: {
                                                        g: {
                                                          m: {
                                                            if (!(l & 3) | !Z)
                                                              break m;
                                                            for (; ; ) {
                                                              if (v = z[l | 0], !v)
                                                                break g;
                                                              if (Z = Z - 1 | 0, F = (Z | 0) != 0, l = l + 1 | 0, !(l & 3))
                                                                break m;
                                                              if (!Z)
                                                                break;
                                                            }
                                                          }
                                                          if (!F)
                                                            break k;
                                                          m: {
                                                            if (!(!z[l | 0] | Z >>> 0 < 4))
                                                              for (; ; ) {
                                                                if (F = r[l >> 2], (F ^ -1) & F - 16843009 & -2139062144)
                                                                  break m;
                                                                if (l = l + 4 | 0, Z = Z - 4 | 0, !(Z >>> 0 > 3))
                                                                  break;
                                                              }
                                                            if (!Z)
                                                              break k;
                                                          }
                                                          F = 0;
                                                          break p;
                                                        }
                                                        F = 1;
                                                      }
                                                      for (; ; ) {
                                                        if (!F) {
                                                          v = z[l | 0], F = 1;
                                                          continue;
                                                        }
                                                        if (!v)
                                                          break v;
                                                        if (l = l + 1 | 0, Z = Z - 1 | 0, !Z)
                                                          break k;
                                                        F = 0;
                                                      }
                                                    }
                                                    l = 0;
                                                  }
                                                  if (l = l ? l - I | 0 : x, F = l + I | 0, (T | 0) >= 0) {
                                                    v = p, T = l;
                                                    break f;
                                                  }
                                                  if (v = p, T = l, z[F | 0])
                                                    break t;
                                                  break f;
                                                }
                                                if (T) {
                                                  p = r[E + 64 >> 2];
                                                  break c;
                                                }
                                                l = 0, w2(e, 32, N, 0, v);
                                                break h;
                                              }
                                              r[E + 12 >> 2] = 0, r[E + 8 >> 2] = r[E + 64 >> 2], p = E + 8 | 0, r[E + 64 >> 2] = p, T = -1;
                                            }
                                            l = 0;
                                            c: {
                                              for (; ; ) {
                                                if (I = r[p >> 2], !I)
                                                  break c;
                                                if (I = en(E + 4 | 0, I), F = (I | 0) < 0, !(F | I >>> 0 > T - l >>> 0)) {
                                                  if (p = p + 4 | 0, l = l + I | 0, T >>> 0 > l >>> 0)
                                                    continue;
                                                  break c;
                                                }
                                                break;
                                              }
                                              if (F)
                                                break i;
                                            }
                                            if (F = 61, (l | 0) < 0)
                                              break r;
                                            if (w2(e, 32, N, l, v), !l) {
                                              l = 0;
                                              break h;
                                            }
                                            for (F = 0, p = r[E + 64 >> 2]; ; ) {
                                              if (I = r[p >> 2], !I || (I = en(E + 4 | 0, I), F = I + F | 0, F >>> 0 > l >>> 0))
                                                break h;
                                              if (c2(e, E + 4 | 0, I), p = p + 4 | 0, !(l >>> 0 > F >>> 0))
                                                break;
                                            }
                                          }
                                          w2(e, 32, N, l, v ^ 8192), l = (l | 0) < (N | 0) ? N : l;
                                          continue n;
                                        }
                                        if ((T | 0) < 0 && x)
                                          break t;
                                        if (F = 61, l = e0[u | 0](e, b0[E + 64 >> 3], N, T, v, l) | 0, (l | 0) >= 0)
                                          continue n;
                                        break r;
                                      }
                                      P[E + 55 | 0] = r[E + 64 >> 2], T = 1, I = r0, v = p;
                                      break f;
                                    }
                                    p = z[l + 1 | 0], l = l + 1 | 0;
                                  }
                                if (e)
                                  break e;
                                if (!_)
                                  break o;
                                for (l = 1; ; ) {
                                  if (e = r[(l << 2) + f >> 2], e) {
                                    if (Bi((l << 3) + n | 0, e, i, a), R = 1, l = l + 1 | 0, (l | 0) != 10)
                                      continue;
                                    break e;
                                  }
                                  break;
                                }
                                if (R = 1, l >>> 0 >= 10)
                                  break e;
                                for (; ; ) {
                                  if (r[(l << 2) + f >> 2])
                                    break s;
                                  if (l = l + 1 | 0, (l | 0) == 10)
                                    break;
                                }
                                break e;
                              }
                              F = 28;
                              break r;
                            }
                            if (Z = F - I | 0, T = (T | 0) > (Z | 0) ? T : Z, (T | 0) > (S ^ 2147483647))
                              break t;
                            if (F = 61, p = T + S | 0, l = (p | 0) < (N | 0) ? N : p, (t0 | 0) < (l | 0))
                              break r;
                            w2(e, 32, l, p, v), c2(e, Q, S), w2(e, 48, l, p, v ^ 65536), w2(e, 48, T, Z, 0), c2(e, I, Z), w2(e, 32, l, p, v ^ 8192);
                            continue;
                          }
                          break;
                        }
                      R = 0;
                      break e;
                    }
                    F = 61;
                  }
                  r[1781] = F;
                }
                R = -1;
              }
              return U = E + 80 | 0, R;
            }
            function r4(e, t, i, n) {
              e = e | 0, t = +t, i = +i, n = n | 0;
              var f = o(0), u = o(0), a = 0, l = o(0), p = 0, E = o(0), I = 0, F = o(0), Z = 0;
              Z = U + -64 | 0, U = Z, a = r[e >> 2], x2(Z + 8 | 0, 0, 56), r[1755] = r[1755] + 1, Zi(a), l = o(t), u = h[a + 572 >> 2];
              e: {
                i: {
                  r:
                    switch (e = r[a + 576 >> 2], e | 0) {
                      case 0:
                      case 3:
                        break i;
                      default:
                        break r;
                    }
                  f = h[a + 572 >> 2];
                  r: {
                    if (!((e | 0) != 1 | f != f)) {
                      if (f = u, !(f < o(0)))
                        break r;
                      break i;
                    }
                    t: {
                      if (!((e | 0) != 2 | f != f)) {
                        if (l != l | u < o(0))
                          break i;
                        break t;
                      }
                      f = o(l0);
                      n:
                        switch (e - 1 | 0) {
                          case 1:
                            break t;
                          case 0:
                            break n;
                          default:
                            break r;
                        }
                      f = u;
                      break r;
                    }
                    f = o(o(u * l) * o(0.009999999776482582));
                  }
                  F = o(f + o(E0(a, 2, l) + B0(a, 2, l))), I = 1;
                  break e;
                }
                f = o(0), u = h[a + 216 >> 2];
                i: {
                  r: {
                    e = r[a + 216 >> 2];
                    t: {
                      n: {
                        if ((e | 0) == 2139156720)
                          break n;
                        if ((e | 0) == 2140081935)
                          break i;
                        I = 4336;
                        o: {
                          if ((e | 0) != 2141891242) {
                            if (u == u)
                              break o;
                            I = 4344;
                          }
                          switch (f = h[I >> 2], r[I + 4 >> 2] - 1 | 0) {
                            case 0:
                              break t;
                            case 1:
                              break n;
                            default:
                              break r;
                          }
                        }
                        if (f = (j(2, (e & -1073741825) + 536870912 | 0), f0()), !(e & 1073741824))
                          break t;
                      }
                      f = o(o(f * l) * o(0.009999999776482582));
                    }
                    if (f != f)
                      break r;
                    f = o(0);
                    t: {
                      if ((e | 0) == 2139156720)
                        break t;
                      if ((e | 0) == 2140081935)
                        break i;
                      p = 4336;
                      n: {
                        if ((e | 0) != 2141891242) {
                          if (u == u)
                            break n;
                          p = 4344;
                        }
                        switch (f = h[p >> 2], F = o(l0), I = 2, r[p + 4 >> 2] - 1 | 0) {
                          case 1:
                            break t;
                          case 0:
                            break i;
                          default:
                            break e;
                        }
                      }
                      if (f = (j(2, (e & -1073741825) + 536870912 | 0), f0()), !(e & 1073741824))
                        break i;
                    }
                    F = o(o(f * l) * o(0.009999999776482582)), I = 2;
                    break e;
                  }
                  I = l == l, F = l;
                  break e;
                }
                I = 2, F = f;
              }
              E = o(i), u = h[a + 580 >> 2];
              e: {
                i: {
                  r:
                    switch (e = r[a + 584 >> 2], e | 0) {
                      case 0:
                      case 3:
                        break i;
                      default:
                        break r;
                    }
                  f = h[a + 580 >> 2];
                  r: {
                    if (!((e | 0) != 1 | f != f)) {
                      if (f = u, !(f < o(0)))
                        break r;
                      break i;
                    }
                    t: {
                      if (!((e | 0) != 2 | f != f)) {
                        if (E != E | u < o(0))
                          break i;
                        break t;
                      }
                      f = o(l0);
                      n:
                        switch (e - 1 | 0) {
                          case 1:
                            break t;
                          case 0:
                            break n;
                          default:
                            break r;
                        }
                      f = u;
                      break r;
                    }
                    f = o(o(u * E) * o(0.009999999776482582));
                  }
                  u = o(f + o(E0(a, 0, l) + B0(a, 0, l))), e = 1;
                  break e;
                }
                f = o(0), u = h[a + 220 >> 2];
                i: {
                  r: {
                    e = r[a + 220 >> 2];
                    t: {
                      n: {
                        if ((e | 0) == 2139156720)
                          break n;
                        if ((e | 0) == 2140081935)
                          break i;
                        p = 4336;
                        o: {
                          if ((e | 0) != 2141891242) {
                            if (u == u)
                              break o;
                            p = 4344;
                          }
                          switch (f = h[p >> 2], r[p + 4 >> 2] - 1 | 0) {
                            case 0:
                              break t;
                            case 1:
                              break n;
                            default:
                              break r;
                          }
                        }
                        if (f = (j(2, (e & -1073741825) + 536870912 | 0), f0()), !(e & 1073741824))
                          break t;
                      }
                      f = o(o(f * E) * o(0.009999999776482582));
                    }
                    if (f != f)
                      break r;
                    f = o(0);
                    t: {
                      if ((e | 0) == 2139156720)
                        break t;
                      if ((e | 0) == 2140081935)
                        break i;
                      p = 4336;
                      n: {
                        if ((e | 0) != 2141891242) {
                          if (u == u)
                            break n;
                          p = 4344;
                        }
                        switch (f = h[p >> 2], u = o(l0), e = 2, r[p + 4 >> 2] - 1 | 0) {
                          case 0:
                            break i;
                          case 1:
                            break t;
                          default:
                            break e;
                        }
                      }
                      if (f = (j(2, (e & -1073741825) + 536870912 | 0), f0()), !(e & 1073741824))
                        break i;
                    }
                    u = o(o(f * E) * o(0.009999999776482582)), e = 2;
                    break e;
                  }
                  e = E == E, u = E;
                  break e;
                }
                e = 2, u = f;
              }
              Me(a, F, u, n, I, e, l, E, 1, 0, r[a + 568 >> 2], Z + 8 | 0, 0, r[1755]) && (Mi(a, z[a + 300 | 0] & 3, l, E, l), Fi(a, +h[r[a + 568 >> 2] + 20 >> 2], 0, 0)), U = Z - -64 | 0;
            }
            function i4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0, n = o(0), f = 0, u = 0, a = o(0), l = 0, p = 0, E = 0, I = o(0);
              e: {
                p = r[t >> 2], t = r[e >> 2];
                i: {
                  if ((r[p + 24 >> 2] ^ r[t + 24 >> 2]) & 8388607)
                    break i;
                  I = h[p + 40 >> 2], f = r[p + 40 >> 2], n = h[t + 40 >> 2];
                  r: {
                    t: {
                      if (i = r[t + 40 >> 2], (i | 0) != 2139156720) {
                        if (a = o(l0), e = 3, (i | 0) == 2141891242)
                          break r;
                        if ((i | 0) != 2140081935)
                          break t;
                        a = o(0), e = 1;
                        break r;
                      }
                      e = 2;
                      break r;
                    }
                    if (e = 0, n != n)
                      break r;
                    a = (j(2, (i & -1073741825) + 536870912 | 0), f0()), e = i & 1073741824 ? 2 : 1;
                  }
                  r: {
                    t: {
                      if ((f | 0) != 2139156720) {
                        if (n = o(l0), i = 3, (f | 0) == 2141891242)
                          break r;
                        if ((f | 0) != 2140081935)
                          break t;
                        n = o(0), i = 1;
                        break r;
                      }
                      n = o(0), i = 2;
                      break r;
                    }
                    if (i = 0, I != I)
                      break r;
                    n = (j(2, (f & -1073741825) + 536870912 | 0), f0()), i = f & 1073741824 ? 2 : 1;
                  }
                  if ((i | 0) != (e | 0) | !(!e | a != a & n != n | o(e2(o(a - n))) < o(9999999747378752e-20)) || (i = t + 44 | 0, u = p + 44 | 0, r[i >> 2] != r[u >> 2]))
                    break i;
                  e = 0;
                  r: {
                    for (; ; ) {
                      if (f = e, e = e + 1 | 0, (e | 0) == 9)
                        break r;
                      if (l = e << 2, r[l + i >> 2] != r[u + l >> 2])
                        break;
                    }
                    if (f >>> 0 < 8)
                      break i;
                  }
                  if (i = t + 80 | 0, u = p + 80 | 0, r[i >> 2] != r[u >> 2])
                    break i;
                  e = 0;
                  r: {
                    for (; ; ) {
                      if (f = e, e = e + 1 | 0, (e | 0) == 9)
                        break r;
                      if (l = e << 2, r[l + i >> 2] != r[u + l >> 2])
                        break;
                    }
                    if (f >>> 0 < 8)
                      break i;
                  }
                  if (i = t + 116 | 0, u = p + 116 | 0, r[i >> 2] != r[u >> 2])
                    break i;
                  e = 0;
                  r: {
                    for (; ; ) {
                      if (f = e, e = e + 1 | 0, (e | 0) == 9)
                        break r;
                      if (l = e << 2, r[l + i >> 2] != r[u + l >> 2])
                        break;
                    }
                    if (f >>> 0 < 8)
                      break i;
                  }
                  if (i = t + 152 | 0, u = p + 152 | 0, r[i >> 2] != r[u >> 2])
                    break i;
                  e = 0;
                  r: {
                    for (; ; ) {
                      if (f = e, e = e + 1 | 0, (e | 0) == 9)
                        break r;
                      if (l = e << 2, r[l + i >> 2] != r[u + l >> 2])
                        break;
                    }
                    if (f >>> 0 < 8)
                      break i;
                  }
                  if (i = t + 188 | 0, u = p + 188 | 0, r[i >> 2] != r[u >> 2])
                    break i;
                  e = 0;
                  r: {
                    for (; ; ) {
                      if (f = e, e = e + 1 | 0, (e | 0) == 3)
                        break r;
                      if (l = e << 2, r[l + i >> 2] != r[u + l >> 2])
                        break;
                    }
                    if (f >>> 0 < 2)
                      break i;
                  }
                  for (l = p + 200 | 0, E = t + 200 | 0, e = 0, f = 1; ; ) {
                    r: {
                      if (e = e << 2, i = r[e + l >> 2], u = r[e + E >> 2], !f)
                        break r;
                      if (f = 0, e = 1, (i | 0) == (u | 0))
                        continue;
                    }
                    break;
                  }
                  if ((i | 0) != (u | 0))
                    break i;
                  for (l = p + 208 | 0, E = t + 208 | 0, e = 0, f = 1; ; ) {
                    r: {
                      if (e = e << 2, i = r[e + l >> 2], u = r[e + E >> 2], !f)
                        break r;
                      if (f = 0, e = 1, (i | 0) == (u | 0))
                        continue;
                    }
                    break;
                  }
                  if ((i | 0) != (u | 0))
                    break i;
                  for (l = p + 216 | 0, E = t + 216 | 0, e = 0, f = 1; ; ) {
                    r: {
                      if (e = e << 2, i = r[e + l >> 2], u = r[e + E >> 2], !f)
                        break r;
                      if (f = 0, e = 1, (i | 0) == (u | 0))
                        continue;
                    }
                    break;
                  }
                  if ((i | 0) != (u | 0) || (a = h[p + 28 >> 2], e = a != a, n = h[t + 28 >> 2], (e | 0) == (n == n | 0) | !(e | n != n) & n != a) || (n = h[t + 32 >> 2], a = h[p + 32 >> 2], (n == n | 0) == (a != a | 0) | n == n & n != a) || (a = h[p + 36 >> 2], e = a != a, n = h[t + 36 >> 2], (e | 0) == (n == n | 0) | !e & n != a))
                    break i;
                  if (e = 0, n = h[t + 224 >> 2], n != n && (e = 1, a = h[p + 224 >> 2], a != a) || (a = n, n = h[p + 224 >> 2], a == n | n != n & e))
                    break e;
                }
                for (T2(t + 24 | 0, p + 24 | 0, 204); ; ) {
                  if (e = z[t + 4 | 0], e & 4)
                    break e;
                  if (P[t + 4 | 0] = e | 4, e = r[t + 20 >> 2], e && e0[e | 0](t), r[t + 308 >> 2] = 2143289344, t = r[t + 552 >> 2], !t)
                    break;
                }
              }
            }
            function n4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0, n = 0, f = 0, u = 0, a = 0, l = 0, p = 0, E = 0, I = 0, F = 0, Z = 0, T = 0, v = 0, R = 0, N = 0, S = 0;
              i = t, t = r[t >> 2] + 7 & -8, r[i >> 2] = t + 16, v = e, p = r[t >> 2], n = r[t + 4 >> 2], e = r[t + 12 >> 2], Z = e, a = U - 32 | 0, U = a, e = e & 2147483647, l = e, f = e - 1006698496 | 0, e = e - 1140785152 | 0, i = r[t + 8 >> 2], t = i;
              e: {
                if ((f | 0) == (e | 0) & t >>> 0 < t >>> 0 | e >>> 0 > f >>> 0) {
                  if (e = i, i = Z << 4 | e >>> 28, t = e << 4 | n >>> 28, e = i, n = n & 268435455, (n | 0) == 134217728 & (p | 0) != 0 | n >>> 0 > 134217728) {
                    e = e + 1073741824 | 0, t = t + 1 | 0, e = t ? e : e + 1 | 0;
                    break e;
                  }
                  if (e = e + 1073741824 | 0, p | (n | 0) != 134217728)
                    break e;
                  n = t & 1, t = n + t | 0, e = t >>> 0 < n >>> 0 ? e + 1 | 0 : e;
                  break e;
                }
                if (!(!t & (l | 0) == 2147418112 ? !(n | p) : l >>> 0 < 2147418112)) {
                  e = i, i = Z << 4 | e >>> 28, t = e << 4 | n >>> 28, e = i & 524287 | 2146959360;
                  break e;
                }
                if (t = 0, e = 2146435072, l >>> 0 > 1140785151 || (e = 0, T = l >>> 16 | 0, T >>> 0 < 15249))
                  break e;
                t = p, e = n, f = Z & 65535 | 65536, l = f, F = i, u = i, E = T - 15233 | 0;
                i: {
                  if (E & 64) {
                    i = t, f = E + -64 | 0, t = f & 31, (f & 63) >>> 0 >= 32 ? (e = i << t, u = 0) : (e = (1 << t) - 1 & i >>> 32 - t | e << t, u = i << t), f = e, t = 0, e = 0;
                    break i;
                  }
                  if (!E)
                    break i;
                  I = u, u = E & 31, (E & 63) >>> 0 >= 32 ? (i = I << u, u = 0) : (i = (1 << u) - 1 & I >>> 32 - u | f << u, u = I << u), f = i, R = u, I = t, i = 64 - E | 0, u = i & 31, (i & 63) >>> 0 >= 32 ? (i = 0, t = e >>> u | 0) : (i = e >>> u | 0, t = ((1 << u) - 1 & e) << 32 - u | I >>> u), u = R | t, f = i | f, t = E & 31, (E & 63) >>> 0 >= 32 ? (i = I << t, t = 0) : (i = (1 << t) - 1 & I >>> 32 - t | e << t, t = I << t), e = i;
                }
                r[a + 16 >> 2] = t, r[a + 20 >> 2] = e, r[a + 24 >> 2] = u, r[a + 28 >> 2] = f, t = 15361 - T | 0;
                i: {
                  if (t & 64) {
                    n = F, t = t + -64 | 0, e = t & 31, (t & 63) >>> 0 >= 32 ? (i = 0, p = l >>> e | 0) : (i = l >>> e | 0, p = ((1 << e) - 1 & l) << 32 - e | n >>> e), n = i, F = 0, l = 0;
                    break i;
                  }
                  if (!t)
                    break i;
                  f = F, e = 64 - t | 0, i = e & 31, (e & 63) >>> 0 >= 32 ? (e = f << i, u = 0) : (e = (1 << i) - 1 & f >>> 32 - i | l << i, u = f << i), f = p, p = t & 31, (t & 63) >>> 0 >= 32 ? (i = 0, f = n >>> p | 0) : (i = n >>> p | 0, f = ((1 << p) - 1 & n) << 32 - p | f >>> p), p = u | f, n = e | i, f = F, i = t & 31, (t & 63) >>> 0 >= 32 ? (e = 0, F = l >>> i | 0) : (e = l >>> i | 0, F = ((1 << i) - 1 & l) << 32 - i | f >>> i), l = e;
                }
                if (r[a >> 2] = p, r[a + 4 >> 2] = n, r[a + 8 >> 2] = F, r[a + 12 >> 2] = l, t = r[a + 8 >> 2], e = r[a + 12 >> 2] << 4 | t >>> 28, t = t << 4, i = r[a >> 2], l = r[a + 4 >> 2], t = l >>> 28 | t, n = l & 268435455, i = i | (r[a + 16 >> 2] | r[a + 24 >> 2] | (r[a + 20 >> 2] | r[a + 28 >> 2])) != 0, (n | 0) == 134217728 & (i | 0) != 0 | n >>> 0 > 134217728) {
                  t = t + 1 | 0, e = t ? e : e + 1 | 0;
                  break e;
                }
                if (i | (n | 0) != 134217728)
                  break e;
                i = t, t = t + (t & 1) | 0, e = i >>> 0 > t >>> 0 ? e + 1 | 0 : e;
              }
              U = a + 32 | 0, j(0, t | 0), j(1, Z & -2147483648 | e), N = v, S = +y2(), b0[N >> 3] = S;
            }
            function Me(e, t, i, n, f, u, a, l, p, E, I, F, Z, T) {
              var v = o(0), R = 0, N = 0, S = 0, x = 0, C = o(0), _ = 0, H = 0, Q = o(0);
              e: {
                if (!(r[e + 312 >> 2] != (T | 0) && z[e + 4 | 0] & 4) && (x = 0, r[e + 316 >> 2] == (n | 0)))
                  break e;
                r[e + 540 >> 2] = -1082130432, r[e + 544 >> 2] = -1082130432, r[e + 532 >> 2] = 0, r[e + 536 >> 2] = 0, r[e + 524 >> 2] = -1082130432, r[e + 528 >> 2] = -1082130432, r[e + 320 >> 2] = 0, x = 1;
              }
              _ = Z + 1 | 0;
              e: {
                i: {
                  r: {
                    t: {
                      if (r[e + 8 >> 2]) {
                        if (C = E0(e, 2, a), Q = B0(e, 2, a), v = o(E0(e, 0, a) + B0(e, 0, a)), Z = e + 524 | 0, C = o(C + Q), Ii(f, t, u, i, r[e + 532 >> 2], h[Z >> 2], r[e + 536 >> 2], h[e + 528 >> 2], h[e + 540 >> 2], h[e + 544 >> 2], C, v, I))
                          break r;
                        if (N = r[e + 320 >> 2], !N)
                          break t;
                        for (R = e + 324 | 0; ; ) {
                          if (Z = R + $0(S, 24) | 0, Ii(f, t, u, i, r[Z + 8 >> 2], h[Z >> 2], r[Z + 12 >> 2], h[Z + 4 >> 2], h[Z + 16 >> 2], h[Z + 20 >> 2], C, v, I))
                            break r;
                          if (S = S + 1 | 0, (N | 0) == (S | 0))
                            break;
                        }
                        break t;
                      }
                      if (!p) {
                        if (H = r[e + 320 >> 2], !H)
                          break t;
                        for (N = e + 324 | 0; ; ) {
                          R = $0(S, 24), Z = R + N | 0, v = h[Z >> 2];
                          n: {
                            o: {
                              if (!(v != v | t != t)) {
                                if (o(e2(o(v - t))) < o(9999999747378752e-20))
                                  break o;
                                break n;
                              }
                              if (v == v | t == t)
                                break n;
                            }
                            R = N + R | 0, v = h[R + 4 >> 2];
                            o: {
                              if (!(v != v | i != i)) {
                                if (o(e2(o(v - i))) < o(9999999747378752e-20))
                                  break o;
                                break n;
                              }
                              if (v == v | i == i)
                                break n;
                            }
                            if (r[R + 8 >> 2] != (f | 0))
                              break n;
                            if (r[R + 12 >> 2] == (u | 0))
                              break r;
                          }
                          if (S = S + 1 | 0, (H | 0) == (S | 0))
                            break;
                        }
                        break t;
                      }
                      Z = e + 524 | 0, v = h[Z >> 2];
                      n: {
                        if (!(v != v | t != t)) {
                          if (o(e2(o(v - t))) < o(9999999747378752e-20))
                            break n;
                          break t;
                        }
                        if (v == v | t == t)
                          break t;
                      }
                      R = r[e + 532 >> 2] == (f | 0) && r[e + 536 >> 2] == (u | 0) ? Z : 0, v = h[e + 528 >> 2], Z = v != v, N = i != i;
                      n: {
                        if (Z | N) {
                          Z = Z & N;
                          break n;
                        }
                        Z = o(e2(o(v - i))) < o(9999999747378752e-20);
                      }
                      Z = Z ? R : 0;
                      break r;
                    }
                    Ni(e, t, i, n, f, u, a, l, p, I, F, _, T, E), r[e + 316 >> 2] = n;
                    break i;
                  }
                  if (!(!Z | x)) {
                    h[e + 516 >> 2] = h[Z + 16 >> 2], h[e + 520 >> 2] = h[Z + 20 >> 2], n = (p ? 12 : 16) + F | 0, r[n >> 2] = r[n >> 2] + 1;
                    break e;
                  }
                  if (Ni(e, t, i, n, f, u, a, l, p, I, F, _, T, E), r[e + 316 >> 2] = n, Z)
                    break e;
                }
                Z = r[e + 320 >> 2], n = Z + 1 | 0, n >>> 0 > wi[F + 8 >> 2] && (r[F + 8 >> 2] = n), (Z | 0) == 8 && (r[e + 320 >> 2] = 0, Z = 0), p ? n = e + 524 | 0 : (r[e + 320 >> 2] = Z + 1, n = ($0(Z, 24) + e | 0) + 324 | 0), r[n + 12 >> 2] = u, r[n + 8 >> 2] = f, h[n + 4 >> 2] = i, h[n >> 2] = t, h[n + 16 >> 2] = h[e + 516 >> 2], h[n + 20 >> 2] = h[e + 520 >> 2], Z = 0;
              }
              e: {
                if (!p || (n = r[e + 520 >> 2], r[e + 244 >> 2] = r[e + 516 >> 2], r[e + 248 >> 2] = n, n = z[e + 4 | 0], f = n | 1, P[e + 4 | 0] = f, !(n & 4)))
                  break e;
                P[e + 4 | 0] = f & 251;
              }
              return r[e + 312 >> 2] = T, !Z | x;
            }
            function Er(e) {
              e = e | 0;
              var t = 0, i = 0, n = 0, f = 0, u = 0, a = 0, l = 0, p = 0, E = 0, I = 0, F = 0;
              l = 8;
              e: {
                if (e >>> 0 > 4294967239)
                  break e;
                i: {
                  for (; ; ) {
                    l = l >>> 0 <= 8 ? 8 : l, t = r[1751], u = t, f = r[1750], e = e >>> 0 <= 8 ? 8 : e + 3 & -4;
                    r: {
                      if (e >>> 0 <= 127) {
                        a = (e >>> 3 | 0) - 1 | 0;
                        break r;
                      }
                      if (n = J2(e), a = ((e >>> 29 - n ^ 4) - (n << 2) | 0) + 110 | 0, e >>> 0 <= 4095)
                        break r;
                      n = ((e >>> 30 - n ^ 2) - (n << 1) | 0) + 71 | 0, a = n >>> 0 >= 63 ? 63 : n;
                    }
                    if (i = a & 31, (a & 63) >>> 0 >= 32 ? (n = 0, t = t >>> i | 0) : (n = t >>> i | 0, t = ((1 << i) - 1 & t) << 32 - i | f >>> i), t | n) {
                      for (; ; ) {
                        f = n;
                        r: {
                          if (t | n) {
                            i = n - 1 | 0, p = i + 1 | 0, u = i, i = t - 1 | 0, u = (i | 0) != -1 ? p : u, n = J2(n ^ u), n = (n | 0) == 32 ? J2(t ^ i) + 32 | 0 : n, i = 63 - n | 0, I2 = 0 - (n >>> 0 > 63) | 0;
                            break r;
                          }
                          I2 = 0, i = 64;
                        }
                        u = i, i = u & 31, (u & 63) >>> 0 >= 32 ? (n = 0, t = f >>> i | 0) : (n = f >>> i | 0, t = ((1 << i) - 1 & f) << 32 - i | t >>> i), p = t, a = u + a | 0, i = a << 4, t = r[i + 5976 >> 2], u = i + 5968 | 0;
                        r: {
                          if ((t | 0) != (u | 0)) {
                            if (f = Or(t, l, e), f)
                              break e;
                            f = r[t + 4 >> 2], r[f + 8 >> 2] = r[t + 8 >> 2], r[r[t + 8 >> 2] + 4 >> 2] = f, r[t + 8 >> 2] = u, f = i + 5972 | 0, r[t + 4 >> 2] = r[f >> 2], r[f >> 2] = t, r[r[t + 4 >> 2] + 8 >> 2] = t, a = a + 1 | 0, t = (n & 1) << 31 | p >>> 1, n = n >>> 1 | 0;
                            break r;
                          }
                          E = r[1751], u = a & 63, t = u, f = t & 31, t >>> 0 >= 32 ? (t = 0, i = -1 >>> f | 0) : (t = -1 >>> f | 0, i = t | (1 << f) - 1 << 32 - f), i = i & -2, f = u & 31, u >>> 0 >= 32 ? (t = i << f, i = 0) : (t = (1 << f) - 1 & i >>> 32 - f | t << f, i = i << f), I = i, f = t, u = 0 - a & 63, i = u, t = i & 31, i >>> 0 >= 32 ? (t = -1 << t, i = 0) : (i = -1 << t, t = i | (1 << t) - 1 & -1 >>> 32 - t), F = i & -2, i = u & 31, u >>> 0 >= 32 ? (u = 0, t = t >>> i | 0) : (u = t >>> i | 0, t = ((1 << i) - 1 & t) << 32 - i | F >>> i), t = t | I, I2 = f | u, r[1750] = r[1750] & t, r[1751] = I2 & E, t = p ^ 1;
                        }
                        if (!(t | n))
                          break;
                      }
                      u = r[1751], f = r[1750];
                    }
                    r: {
                      if (f | u) {
                        n = J2(u), i = 63 - ((n | 0) == 32 ? J2(f) + 32 | 0 : n) | 0, t = i << 4, n = r[t + 5976 >> 2];
                        t: {
                          if (!u & f >>> 0 < 1073741824 || (a = 99, t = t + 5968 | 0, (t | 0) == (n | 0)))
                            break t;
                          for (; ; ) {
                            if (!a)
                              break t;
                            if (f = Or(n, l, e), f)
                              break e;
                            if (a = a - 1 | 0, n = r[n + 8 >> 2], (t | 0) == (n | 0))
                              break;
                          }
                          n = t;
                        }
                        if (Wr(e + 48 | 0))
                          break r;
                        if (!n || (t = (i << 4) + 5968 | 0, (t | 0) == (n | 0)))
                          break i;
                        for (; ; ) {
                          if (f = Or(n, l, e), f)
                            break e;
                          if (n = r[n + 8 >> 2], (t | 0) == (n | 0))
                            break;
                        }
                        break i;
                      }
                      if (!Wr(e + 48 | 0))
                        break i;
                    }
                    if (f = 0, l - 1 & l)
                      break e;
                    if (!(e >>> 0 <= 4294967239))
                      break;
                  }
                  break e;
                }
                f = 0;
              }
              return f | 0;
            }
            function o4(e, t, i) {
              e = e | 0, t = t | 0, i = i | 0;
              var n = 0, f = 0, u = 0, a = 0, l = 0, p = 0, E = 0, I = 0, F = 0, Z = 0;
              l = U - 80 | 0, U = l, e = r[e >> 2];
              e: {
                i: {
                  if (p = r[t >> 2], !r[p + 552 >> 2]) {
                    if (r[e + 8 >> 2])
                      break i;
                    t = r[e + 556 >> 2], a = t + (i << 2) | 0, n = r[e + 560 >> 2], f = e + 564 | 0, u = r[f >> 2];
                    r: {
                      if (n >>> 0 < u >>> 0) {
                        if ((n | 0) == (a | 0)) {
                          r[a >> 2] = p, r[e + 560 >> 2] = a + 4;
                          break r;
                        }
                        if (i = n, t = n - 4 | 0, n >>> 0 > t >>> 0)
                          for (; r[i >> 2] = r[t >> 2], i = i + 4 | 0, t = t + 4 | 0, n >>> 0 > t >>> 0; )
                            ;
                        r[e + 560 >> 2] = i, t = a + 4 | 0, (t | 0) != (n | 0) && (t = n - t | 0, Oe(n - (t & -4) | 0, a, t)), r[a >> 2] = p;
                        break r;
                      }
                      if (n = (n - t >> 2) + 1 | 0, n >>> 0 >= 1073741824)
                        break e;
                      t = u - t | 0, u = t >> 1, f = lt(l + 32 | 0, t >>> 0 >= 2147483644 ? 1073741823 : n >>> 0 < u >>> 0 ? u : n, i, f), i = r[f + 8 >> 2];
                      t: {
                        if ((i | 0) != r[f + 12 >> 2])
                          break t;
                        if (t = r[f + 4 >> 2], n = r[f >> 2], t >>> 0 > n >>> 0) {
                          n = ((t - n >> 2) + 1 | 0) / -2 << 2, E = n + t | 0, u = t, t = i - t | 0, i = Oe(E, u, t) + t | 0, r[f + 8 >> 2] = i, r[f + 4 >> 2] = n + r[f + 4 >> 2];
                          break t;
                        }
                        t = (i | 0) == (n | 0) ? 1 : i - n >> 1, u = lt(l + 56 | 0, t, t >>> 2 | 0, r[f + 16 >> 2]), n = r[u + 8 >> 2], t = r[f + 4 >> 2], i = r[f + 8 >> 2];
                        n: {
                          if ((t | 0) == (i | 0)) {
                            i = n, n = t;
                            break n;
                          }
                          for (i = (i - t | 0) + n | 0; r[n >> 2] = r[t >> 2], t = t + 4 | 0, n = n + 4 | 0, (n | 0) != (i | 0); )
                            ;
                          t = r[f + 8 >> 2], n = r[f + 4 >> 2];
                        }
                        if (E = r[f >> 2], r[f >> 2] = r[u >> 2], r[u >> 2] = E, r[f + 4 >> 2] = r[u + 4 >> 2], r[u + 4 >> 2] = n, r[f + 8 >> 2] = i, r[u + 8 >> 2] = t, I = r[f + 12 >> 2], r[f + 12 >> 2] = r[u + 12 >> 2], r[u + 12 >> 2] = I, (t | 0) != (n | 0) && (r[u + 8 >> 2] = ((n - t | 0) + 3 & -4) + t), !E)
                          break t;
                        m2(E), i = r[f + 8 >> 2];
                      }
                      if (r[i >> 2] = p, r[f + 8 >> 2] = r[f + 8 >> 2] + 4, t = r[e + 556 >> 2], i = a - t | 0, F = f, Z = Oe(r[f + 4 >> 2] - i | 0, t, i), r[F + 4 >> 2] = Z, n = r[e + 560 >> 2] - a | 0, a = Oe(r[f + 8 >> 2], a, n), t = r[e + 556 >> 2], r[e + 556 >> 2] = r[f + 4 >> 2], r[f + 4 >> 2] = t, i = r[e + 560 >> 2], r[e + 560 >> 2] = n + a, r[f + 8 >> 2] = i, n = r[e + 564 >> 2], r[e + 564 >> 2] = r[f + 12 >> 2], r[f >> 2] = t, r[f + 12 >> 2] = n, (t | 0) != (i | 0) && (r[f + 8 >> 2] = i + ((t - i | 0) + 3 & -4)), !t)
                        break r;
                      m2(t);
                    }
                    for (r[p + 552 >> 2] = e; t = z[e + 4 | 0], !!(!(t & 4) && (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], e)); )
                      ;
                    U = l + 80 | 0;
                    return;
                  }
                  r[l + 16 >> 2] = 4075, Y2(e, l + 16 | 0), M2(), V0();
                }
                r[l >> 2] = 4208, Y2(e, l), M2(), V0();
              }
              We(), V0();
            }
            function Si(e, t) {
              var i = 0, n = 0;
              for (r[e >> 2] = 0, r[e + 8 >> 2] = 0, r[e + 12 >> 2] = 0, r[e + 16 >> 2] = 0, r[e + 20 >> 2] = 0, r[e + 24 >> 2] = 0, r[e + 36 >> 2] = 2143289344, r[e + 40 >> 2] = 2141891242, r[e + 28 >> 2] = 2143289344, r[e + 32 >> 2] = 2143289344, P[e + 4 | 0] = z[e + 4 | 0] & 128, n = x2(e + 44 | 0, 0, 36); r[n + (i << 2) >> 2] = 2143289344, i = i + 1 | 0, (i | 0) != 9; )
                ;
              for (i = 0, n = x2(e + 80 | 0, 0, 36); r[n + (i << 2) >> 2] = 2143289344, i = i + 1 | 0, (i | 0) != 9; )
                ;
              for (i = 0, n = x2(e + 116 | 0, 0, 36); r[n + (i << 2) >> 2] = 2143289344, i = i + 1 | 0, (i | 0) != 9; )
                ;
              for (i = 0, n = x2(e + 152 | 0, 0, 36); r[n + (i << 2) >> 2] = 2143289344, i = i + 1 | 0, (i | 0) != 9; )
                ;
              for (i = 0, r[e + 196 >> 2] = 0, n = e + 188 | 0, r[n >> 2] = 0, r[n + 4 >> 2] = 0; r[n + (i << 2) >> 2] = 2143289344, i = i + 1 | 0, (i | 0) != 3; )
                ;
              for (r[e + 24 >> 2] = 4224, r[e + 224 >> 2] = 2143289344, r[e + 216 >> 2] = 2143289344, r[e + 220 >> 2] = 2143289344, r[e + 208 >> 2] = 2143289344, r[e + 212 >> 2] = 2143289344, r[e + 200 >> 2] = 2141891242, r[e + 204 >> 2] = 2141891242, x2(e + 228 | 0, 0, 288), r[e + 244 >> 2] = 2143289344, r[e + 248 >> 2] = 2143289344, x2(e + 252 | 0, 0, 49), r[e + 308 >> 2] = 2143289344, n = e + 516 | 0, i = e + 324 | 0; r[i + 16 >> 2] = -1082130432, r[i + 20 >> 2] = -1082130432, r[i + 8 >> 2] = 0, r[i + 12 >> 2] = 0, r[i >> 2] = -1082130432, r[i + 4 >> 2] = -1082130432, i = i + 24 | 0, (n | 0) != (i | 0); )
                ;
              return r[e + 548 >> 2] = 0, r[e + 552 >> 2] = 0, r[e + 516 >> 2] = 2143289344, r[e + 520 >> 2] = 2143289344, r[e + 572 >> 2] = 2143289344, r[e + 576 >> 2] = 0, r[e + 568 >> 2] = t, r[e + 540 >> 2] = -1082130432, r[e + 544 >> 2] = -1082130432, r[e + 532 >> 2] = 0, r[e + 536 >> 2] = 0, r[e + 524 >> 2] = -1082130432, r[e + 528 >> 2] = -1082130432, r[e + 556 >> 2] = 0, r[e + 560 >> 2] = 0, r[e + 564 >> 2] = 0, r[e + 580 >> 2] = 2143289344, r[e + 584 >> 2] = 0, sn((t | 0) != 0, 2760), P[e + 4 | 0] = z[e + 4 | 0] | 1, P[t + 8 | 0] & 1 && (r[e + 24 >> 2] = r[e + 24 >> 2] & -909 | 520), e;
            }
            function t2(e, t, i, n) {
              var f = o(0), u = o(0), a = 0, l = o(0);
              e: {
                i: {
                  r: {
                    t: {
                      n: {
                        o: {
                          if (t >>> 0 <= 1) {
                            u = h[e + 212 >> 2], t = r[e + 212 >> 2];
                            f: {
                              if ((t | 0) == 2139156720)
                                break f;
                              if ((t | 0) == 2140081935)
                                break o;
                              a = 4336;
                              s: {
                                if ((t | 0) != 2141891242) {
                                  if (u == u)
                                    break s;
                                  a = 4344;
                                }
                                switch (f = h[a >> 2], u = o(l0), r[a + 4 >> 2] - 1 | 0) {
                                  case 0:
                                    break o;
                                  case 1:
                                    break f;
                                  default:
                                    break n;
                                }
                              }
                              if (f = (j(2, (t & -1073741825) + 536870912 | 0), f0()), !(t & 1073741824))
                                break o;
                            }
                            u = o(o(f * n) * o(0.009999999776482582));
                            break n;
                          }
                          u = h[e + 208 >> 2];
                          f: {
                            s: {
                              t = r[e + 208 >> 2];
                              u: {
                                if ((t | 0) == 2139156720)
                                  break u;
                                if ((t | 0) == 2140081935)
                                  break s;
                                a = 4336;
                                a: {
                                  if ((t | 0) != 2141891242) {
                                    if (u == u)
                                      break a;
                                    a = 4344;
                                  }
                                  switch (f = h[a >> 2], u = o(l0), r[a + 4 >> 2] - 1 | 0) {
                                    case 0:
                                      break s;
                                    case 1:
                                      break u;
                                    default:
                                      break f;
                                  }
                                }
                                if (f = (j(2, (t & -1073741825) + 536870912 | 0), f0()), !(t & 1073741824))
                                  break s;
                              }
                              u = o(o(f * n) * o(0.009999999776482582));
                              break f;
                            }
                            u = f;
                          }
                          f = o(0), l = h[e + 216 >> 2], e = r[e + 216 >> 2];
                          f: {
                            if ((e | 0) == 2139156720)
                              break f;
                            if ((e | 0) == 2140081935)
                              break r;
                            t = 4336;
                            s: {
                              if ((e | 0) != 2141891242) {
                                if (l == l)
                                  break s;
                                t = 4344;
                              }
                              switch (f = h[t >> 2], r[t + 4 >> 2] - 1 | 0) {
                                case 1:
                                  break f;
                                case 0:
                                  break t;
                                default:
                                  break i;
                              }
                            }
                            if (f = (j(2, (e & -1073741825) + 536870912 | 0), f0()), !(e & 1073741824))
                              break t;
                          }
                          f = o(o(f * n) * o(0.009999999776482582));
                          break t;
                        }
                        u = f;
                      }
                      f = o(0), l = h[e + 220 >> 2], e = r[e + 220 >> 2];
                      n: {
                        if ((e | 0) == 2139156720)
                          break n;
                        if ((e | 0) == 2140081935)
                          break r;
                        t = 4336;
                        o: {
                          if ((e | 0) != 2141891242) {
                            if (l == l)
                              break o;
                            t = 4344;
                          }
                          switch (f = h[t >> 2], r[t + 4 >> 2] - 1 | 0) {
                            case 1:
                              break n;
                            case 0:
                              break t;
                            default:
                              break i;
                          }
                        }
                        if (f = (j(2, (e & -1073741825) + 536870912 | 0), f0()), !(e & 1073741824))
                          break t;
                      }
                      f = o(o(f * n) * o(0.009999999776482582));
                    }
                    if (!(f >= o(0)))
                      break i;
                  }
                  if (i > f)
                    break e;
                }
                if (!(u >= o(0)))
                  return i;
                f = i < u ? u : i;
              }
              return f;
            }
            function Zi(e) {
              var t = 0, i = 0, n = o(0), f = o(0), u = o(0), a = 0, l = 0, p = 0, E = 0, I = 0, F = 0, Z = 0, T = 0, v = 0;
              for (a = U - 16 | 0, r[a + 8 >> 2] = 0, r[a + 12 >> 2] = 1, I = e + 200 | 0, F = e + 572 | 0, Z = e + 208 | 0, T = e + 216 | 0, e = 0; ; ) {
                v = e, E = r[(a + 8 | 0) + (e << 2) >> 2], l = E << 2, e = T + l | 0, n = h[e >> 2];
                e: {
                  i: {
                    r: {
                      t: {
                        n: {
                          o: {
                            if (t = r[e >> 2], p = (t | 0) == 2139156720, !(p | (t | 0) == 2140081935 | (t | 0) == 2141891242) & n != n)
                              break o;
                            e = l + Z | 0, f = h[e >> 2], i = r[e >> 2];
                            f: {
                              s: {
                                if ((i | 0) != 2139156720) {
                                  if (u = o(l0), e = 3, (i | 0) == 2141891242)
                                    break f;
                                  if ((i | 0) != 2140081935)
                                    break s;
                                  u = o(0), e = 1;
                                  break f;
                                }
                                u = o(0), e = 2;
                                break f;
                              }
                              if (e = 0, f != f)
                                break f;
                              u = (j(2, (i & -1073741825) + 536870912 | 0), f0()), e = i & 1073741824 ? 2 : 1;
                            }
                            i = e;
                            f: {
                              s: {
                                if (!p) {
                                  if (f = o(l0), e = 3, (t | 0) == 2141891242)
                                    break f;
                                  if ((t | 0) != 2140081935)
                                    break s;
                                  f = o(0), e = 1;
                                  break f;
                                }
                                f = o(0), e = 2;
                                break f;
                              }
                              if (e = 0, n != n)
                                break f;
                              f = (j(2, (t & -1073741825) + 536870912 | 0), f0()), e = t & 1073741824 ? 2 : 1;
                            }
                            if ((i | 0) != (e | 0) | !(!e | f != f & u != u | o(e2(o(f - u))) < o(9999999747378752e-20)))
                              break o;
                            if (e = 0, p)
                              break n;
                            if ((t | 0) == 2140081935)
                              break i;
                            if ((t | 0) == 2141891242)
                              break r;
                            if (n != n)
                              break t;
                            e = (t & -1073741825) + 536870912 | 0, t = t & 1073741824 ? 2 : 1;
                            break e;
                          }
                          if (e = 0, t = l + I | 0, n = h[t >> 2], t = r[t >> 2], (t | 0) == 2139156720)
                            break n;
                          if ((t | 0) == 2140081935)
                            break i;
                          if ((t | 0) == 2141891242)
                            break r;
                          if (n != n)
                            break t;
                          e = (t & -1073741825) + 536870912 | 0, t = t & 1073741824 ? 2 : 1;
                          break e;
                        }
                        t = 2;
                        break e;
                      }
                      e = 2143289344, t = 0;
                      break e;
                    }
                    e = 2143289344, t = 3;
                    break e;
                  }
                  t = 1;
                }
                if (i = (E << 3) + F | 0, r[i + 4 >> 2] = t, r[i >> 2] = e, e = 1, !!(v & 1))
                  break;
              }
            }
            function T2(e, t, i) {
              var n = 0, f = 0, u = 0;
              if (i >>> 0 >= 512)
                return Q1(e | 0, t | 0, i | 0), e;
              f = e + i | 0;
              e: {
                if (!((e ^ t) & 3)) {
                  i: {
                    if (!(e & 3)) {
                      i = e;
                      break i;
                    }
                    if (!i) {
                      i = e;
                      break i;
                    }
                    for (i = e; ; ) {
                      if (P[i | 0] = z[t | 0], t = t + 1 | 0, i = i + 1 | 0, !(i & 3))
                        break i;
                      if (!(i >>> 0 < f >>> 0))
                        break;
                    }
                  }
                  n = f & -4;
                  i: {
                    if (n >>> 0 < 64 || (u = n + -64 | 0, u >>> 0 < i >>> 0))
                      break i;
                    for (; r[i >> 2] = r[t >> 2], r[i + 4 >> 2] = r[t + 4 >> 2], r[i + 8 >> 2] = r[t + 8 >> 2], r[i + 12 >> 2] = r[t + 12 >> 2], r[i + 16 >> 2] = r[t + 16 >> 2], r[i + 20 >> 2] = r[t + 20 >> 2], r[i + 24 >> 2] = r[t + 24 >> 2], r[i + 28 >> 2] = r[t + 28 >> 2], r[i + 32 >> 2] = r[t + 32 >> 2], r[i + 36 >> 2] = r[t + 36 >> 2], r[i + 40 >> 2] = r[t + 40 >> 2], r[i + 44 >> 2] = r[t + 44 >> 2], r[i + 48 >> 2] = r[t + 48 >> 2], r[i + 52 >> 2] = r[t + 52 >> 2], r[i + 56 >> 2] = r[t + 56 >> 2], r[i + 60 >> 2] = r[t + 60 >> 2], t = t - -64 | 0, i = i - -64 | 0, u >>> 0 >= i >>> 0; )
                      ;
                  }
                  if (i >>> 0 >= n >>> 0)
                    break e;
                  for (; r[i >> 2] = r[t >> 2], t = t + 4 | 0, i = i + 4 | 0, n >>> 0 > i >>> 0; )
                    ;
                  break e;
                }
                if (f >>> 0 < 4) {
                  i = e;
                  break e;
                }
                if (n = f - 4 | 0, n >>> 0 < e >>> 0) {
                  i = e;
                  break e;
                }
                for (i = e; P[i | 0] = z[t | 0], P[i + 1 | 0] = z[t + 1 | 0], P[i + 2 | 0] = z[t + 2 | 0], P[i + 3 | 0] = z[t + 3 | 0], t = t + 4 | 0, i = i + 4 | 0, n >>> 0 >= i >>> 0; )
                  ;
              }
              if (i >>> 0 < f >>> 0)
                for (; P[i | 0] = z[t | 0], t = t + 1 | 0, i = i + 1 | 0, (f | 0) != (i | 0); )
                  ;
              return e;
            }
            function Gi(e, t, i, n, f) {
              var u = o(0), a = 0, l = o(0), p = o(0), E = 0, I = 0, F = o(0), Z = o(0), T = 0;
              if (l = o(i - n), I = l != l, !I) {
                i = o(0), a = (t << 2) + e | 0, u = h[a + 208 >> 2];
                e: {
                  i: {
                    a = r[a + 208 >> 2];
                    r: {
                      t: {
                        if ((a | 0) == 2139156720)
                          break t;
                        if ((a | 0) == 2140081935)
                          break i;
                        E = 4336;
                        n: {
                          if ((a | 0) != 2141891242) {
                            if (u == u)
                              break n;
                            E = 4344;
                          }
                          switch (i = h[E >> 2], r[E + 4 >> 2] - 1 | 0) {
                            case 0:
                              break r;
                            case 1:
                              break t;
                            default:
                              break e;
                          }
                        }
                        if (i = (j(2, (a & -1073741825) + 536870912 | 0), f0()), !(a & 1073741824))
                          break r;
                      }
                      i = o(o(i * f) * o(0.009999999776482582));
                    }
                    if (i == i)
                      break i;
                    break e;
                  }
                  p = o(i - n);
                }
                i = o(0), e = (t << 2) + e | 0, u = h[e + 216 >> 2];
                e: {
                  i: {
                    t = r[e + 216 >> 2];
                    r: {
                      t: {
                        if ((t | 0) == 2139156720)
                          break t;
                        if ((t | 0) == 2140081935)
                          break i;
                        e = 4336;
                        n: {
                          if ((t | 0) != 2141891242) {
                            if (u == u)
                              break n;
                            e = 4344;
                          }
                          switch (i = h[e >> 2], u = o(34028234663852886e22), r[e + 4 >> 2] - 1 | 0) {
                            case 0:
                              break r;
                            case 1:
                              break t;
                            default:
                              break e;
                          }
                        }
                        if (i = (j(2, (t & -1073741825) + 536870912 | 0), f0()), !(t & 1073741824))
                          break r;
                      }
                      i = o(o(i * f) * o(0.009999999776482582));
                    }
                    if (i == i)
                      break i;
                    u = o(34028234663852886e22);
                    break e;
                  }
                  u = o(i - n);
                }
                if (i = (F = l, Z = Tr(l, u), T = u != u | I, T ? F : Z), e = i != i, !(e | p != p))
                  return d0(i, p);
                l = e ? p : i;
              }
              return l;
            }
            function Ii(e, t, i, n, f, u, a, l, p, E, I, F, Z) {
              var T = o(0), v = o(0), R = 0, N = 0, S = o(0), x = o(0), C = o(0), _ = 0, H = 0;
              if (p < o(0) | E < o(0))
                e = 0;
              else {
                S = u, x = t, C = n, v = l;
                e: {
                  if (!Z || (T = h[Z + 20 >> 2], v = l, T == o(0)))
                    break e;
                  _ = +T, x = ne(+t, _, 0, 0), C = ne(+n, _, 0, 0), S = ne(+u, _, 0, 0), v = ne(+l, _, 0, 0);
                }
                T = v, Z = 0;
                e: {
                  if ((e | 0) != (f | 0))
                    break e;
                  if (H = S != S, Z = x != x, H | Z) {
                    Z = Z & H;
                    break e;
                  }
                  Z = o(e2(o(S - x))) < o(9999999747378752e-20);
                }
                H = Z;
                e: {
                  if ((i | 0) != (a | 0))
                    break e;
                  if (R = T != T, Z = C != C, R | Z) {
                    R = Z & R;
                    break e;
                  }
                  R = o(e2(o(T - C))) < o(9999999747378752e-20);
                }
                N = 1, Z = 1;
                e: {
                  if (H)
                    break e;
                  t = o(t - I);
                  i: {
                    if ((e | 0) == 1)
                      break i;
                    if (e = (e | 0) != 2, !(e | f)) {
                      if (!(t >= p))
                        break i;
                      break e;
                    }
                    if (Z = 0, !(t < u) | (e | (f | 0) != 2 | (t != t | u != u | p != p)) || (Z = 1, t >= p))
                      break e;
                  }
                  if (f = t != t, e = p != p, f | e) {
                    Z = e & f;
                    break e;
                  }
                  Z = o(e2(o(t - p))) < o(9999999747378752e-20);
                }
                e: {
                  if (R)
                    break e;
                  t = o(n - F);
                  i: {
                    if ((i | 0) == 1)
                      break i;
                    if (e = (i | 0) != 2, !(e | a)) {
                      if (!(t >= E))
                        break i;
                      break e;
                    }
                    if (N = 0, !(t < l) | (e | (a | 0) != 2 | (t != t | l != l | E != E)) || (N = 1, t >= E))
                      break e;
                  }
                  if (i = t != t, e = E != E, i | e) {
                    N = e & i;
                    break e;
                  }
                  N = o(e2(o(t - E))) < o(9999999747378752e-20);
                }
                e = Z & N;
              }
              return e;
            }
            function Nr(e) {
              var t = 0, i = 0, n = 0, f = 0, u = 0, a = 0, l = 0, p = 0;
              if (N2(+e), u = O0(1) | 0, n = O0(0) | 0, f = u >>> 20 & 2047, (f | 0) == 2047)
                return e = e * 1, e / e;
              if (t = n << 1, a = u << 1 | n >>> 31, !t & (a | 0) == 2145386496 | a >>> 0 < 2145386496)
                return !t & (a | 0) == 2145386496 ? e * 0 : e;
              e: {
                if (!f) {
                  if (f = 0, i = n << 12, t = u << 12 | n >>> 20, (t | 0) > 0 | (t | 0) >= 0)
                    for (; f = f - 1 | 0, t = t << 1 | i >>> 31, i = i << 1, !!((t | 0) > 0 | (t | 0) >= 0); )
                      ;
                  t = 1 - f | 0, i = t & 31, (t & 63) >>> 0 >= 32 ? (t = n << i, n = 0) : (t = (1 << i) - 1 & n >>> 32 - i | u << i, n = n << i);
                  break e;
                }
                t = u & 1048575 | 1048576;
              }
              if (i = n, (f | 0) > 1023) {
                for (; ; ) {
                  e: {
                    if (n = t + -1048576 | 0, (n | 0) < 0 || (t = n, t | i))
                      break e;
                    return e * 0;
                  }
                  if (t = t << 1 | i >>> 31, i = i << 1, f = f - 1 | 0, !((f | 0) > 1023))
                    break;
                }
                f = 1023;
              }
              e: {
                if (n = t + -1048576 | 0, (n | 0) < 0 || (t = n, t | i))
                  break e;
                return e * 0;
              }
              if ((t | 0) == 1048575 | t >>> 0 < 1048575)
                for (; f = f - 1 | 0, n = t >>> 0 < 524288, a = t << 1 | i >>> 31, i = i << 1, t = a, !!n; )
                  ;
              return p = u & -2147483648, a = t + -1048576 | f << 20, l = i, u = t, l = i, n = 1 - f | 0, i = n & 31, (n & 63) >>> 0 >= 32 ? (t = 0, n = u >>> i | 0) : (t = u >>> i | 0, n = ((1 << i) - 1 & u) << 32 - i | l >>> i), i = (f | 0) > 0, j(0, (i ? l : n) | 0), j(1, (i ? a : t) | p), +y2();
            }
            function Wr(e) {
              var t = 0, i = 0, n = 0, f = 0, u = 0;
              n = r[1416], t = e + 7 & -8, i = n + t | 0;
              e: {
                i: {
                  if (i >>> 0 <= n >>> 0 && t || i >>> 0 > yn() << 16 >>> 0 && !(J1(i | 0) | 0))
                    break i;
                  r[1416] = i;
                  break e;
                }
                r[1781] = 48, n = -1;
              }
              if ((n | 0) != -1) {
                t = e + n | 0, i = t - 16 | 0, r[i + 12 >> 2] = 16, r[i >> 2] = 16, e = r[1748], e ? u = r[e + 8 >> 2] : u = 0;
                e: {
                  i: {
                    if ((u | 0) == (n | 0)) {
                      if (f = n - (r[n - 4 >> 2] & -2) | 0, u = r[f - 4 >> 2], r[e + 8 >> 2] = t, e = f - (u & -2) | 0, t = -16, !(P[(e + r[e >> 2] | 0) - 4 | 0] & 1))
                        break i;
                      t = r[e + 4 >> 2], r[t + 8 >> 2] = r[e + 8 >> 2], r[r[e + 8 >> 2] + 4 >> 2] = t, i = i - e | 0, r[e >> 2] = i;
                      break e;
                    }
                    r[n + 12 >> 2] = 16, r[n >> 2] = 16, r[n + 8 >> 2] = t, r[n + 4 >> 2] = e, r[1748] = n, t = 16;
                  }
                  e = t + n | 0, i = i - e | 0, r[e >> 2] = i;
                }
                r[((i & -4) + e | 0) - 4 >> 2] = i | 1, t = r[e >> 2] - 8 | 0;
                e: {
                  if (t >>> 0 <= 127) {
                    i = (t >>> 3 | 0) - 1 | 0;
                    break e;
                  }
                  if (f = J2(t), i = ((t >>> 29 - f ^ 4) - (f << 2) | 0) + 110 | 0, t >>> 0 <= 4095)
                    break e;
                  i = ((t >>> 30 - f ^ 2) - (f << 1) | 0) + 71 | 0, i = i >>> 0 >= 63 ? 63 : i;
                }
                t = i << 4, r[e + 4 >> 2] = t + 5968, t = t + 5976 | 0, r[e + 8 >> 2] = r[t >> 2], r[t >> 2] = e, r[r[e + 8 >> 2] + 4 >> 2] = e, t = r[1750], f = r[1751], e = i & 31, (i & 63) >>> 0 >= 32 ? (i = 1 << e, u = 0) : (u = 1 << e, i = u - 1 & 1 >>> 32 - e), r[1750] = u | t, r[1751] = i | f;
              }
              return (n | 0) != -1;
            }
            function Ti(e, t, i) {
              var n = 0, f = 0, u = 0, a = 0, l = 0, p = 0, E = 0, I = 0, F = 0;
              e: {
                i: {
                  r: {
                    t: {
                      n: {
                        o: {
                          f: {
                            s: {
                              u: {
                                a: {
                                  if (t) {
                                    if (!i)
                                      break a;
                                    break u;
                                  }
                                  e = (e >>> 0) / (i >>> 0) | 0, I2 = 0;
                                  break e;
                                }
                                if (!e)
                                  break s;
                                break f;
                              }
                              if (!(i - 1 & i))
                                break o;
                              u = (J2(i) + 33 | 0) - J2(t) | 0, a = 0 - u | 0;
                              break t;
                            }
                            e = (t >>> 0) / 0 | 0, I2 = 0;
                            break e;
                          }
                          if (n = 32 - J2(t) | 0, n >>> 0 < 31)
                            break n;
                          break r;
                        }
                        if ((i | 0) == 1)
                          break i;
                        u = i ? 31 - J2(i - 1 ^ i) | 0 : 32, i = u & 31, (u & 63) >>> 0 >= 32 ? e = t >>> i | 0 : (n = t >>> i | 0, e = ((1 << i) - 1 & t) << 32 - i | e >>> i), I2 = n;
                        break e;
                      }
                      u = n + 1 | 0, a = 63 - n | 0;
                    }
                    if (n = u & 63, f = n & 31, n >>> 0 >= 32 ? (n = 0, l = t >>> f | 0) : (n = t >>> f | 0, l = ((1 << f) - 1 & t) << 32 - f | e >>> f), a = a & 63, f = a & 31, a >>> 0 >= 32 ? (t = e << f, e = 0) : (t = (1 << f) - 1 & e >>> 32 - f | t << f, e = e << f), u)
                      for (a = i - 1 | 0, F = (a | 0) == -1 ? -1 : 0; p = n << 1 | l >>> 31, n = l << 1 | t >>> 31, f = F - (p + (n >>> 0 > a >>> 0) | 0) >> 31, E = i & f, l = n - E | 0, n = p - (n >>> 0 < E >>> 0) | 0, t = t << 1 | e >>> 31, e = I | e << 1, I = f & 1, u = u - 1 | 0, !!u; )
                        ;
                    I2 = t << 1 | e >>> 31, e = I | e << 1;
                    break e;
                  }
                  e = 0, t = 0;
                }
                I2 = t;
              }
              return e;
            }
            function _t(e, t, i) {
              var n = o(0), f = o(0);
              e: {
                i: {
                  r: {
                    if ((t & -2) == 2) {
                      if (t = r[e + 188 >> 2], n = h[e + 188 >> 2], (t | 0) == 2139156720 | (t | 0) == 2140081935 | (t | 0) == 2141891242 | n == n || (t = r[e + 196 >> 2], n = h[e + 196 >> 2], (t | 0) == 2139156720 | (t | 0) == 2140081935 | (t | 0) == 2141891242 | n == n))
                        break r;
                      break i;
                    }
                    if (t = r[e + 192 >> 2], n = h[e + 192 >> 2], (t | 0) == 2139156720 | (t | 0) == 2140081935 | (t | 0) == 2141891242 | n == n || (n = h[e + 196 >> 2], t = r[e + 196 >> 2], (t | 0) == 2139156720 | (t | 0) == 2140081935 | (t | 0) == 2141891242))
                      break r;
                    if (n != n)
                      break i;
                  }
                  n = o(0);
                  r: {
                    t: {
                      if ((t | 0) == 2139156720)
                        break t;
                      if ((t | 0) == 2140081935)
                        break e;
                      e = 4336;
                      n: {
                        if ((t | 0) != 2141891242) {
                          if (n = (j(2, t), f0()), n == n)
                            break n;
                          e = 4344;
                        }
                        switch (n = h[e >> 2], f = o(l0), r[e + 4 >> 2] - 1 | 0) {
                          case 0:
                            break e;
                          case 1:
                            break t;
                          default:
                            break r;
                        }
                      }
                      if (n = (j(2, (t & -1073741825) + 536870912 | 0), f0()), !(t & 1073741824))
                        break e;
                    }
                    f = o(o(n * i) * o(0.009999999776482582));
                  }
                  return f;
                }
                n = o(0);
              }
              return n;
            }
            function xi(e, t) {
              var i = 0, n = 0, f = 0, u = 0, a = 0, l = 0;
              for (i = U - 320 | 0, U = i, n = x2(i, 0, 288), i = n, r[i + 16 >> 2] = 2143289344, r[i + 20 >> 2] = 2143289344, x2(i + 24 | 0, 0, 49), r[i + 80 >> 2] = 2143289344, u = i + 288 | 0, f = i + 96 | 0; i = f, r[i + 16 >> 2] = -1082130432, r[i + 20 >> 2] = -1082130432, r[i + 8 >> 2] = 0, r[i + 12 >> 2] = 0, r[i >> 2] = -1082130432, r[i + 4 >> 2] = -1082130432, f = i + 24 | 0, (u | 0) != (f | 0); )
                ;
              if (r[n + 312 >> 2] = -1082130432, r[n + 316 >> 2] = -1082130432, r[n + 304 >> 2] = 0, r[n + 308 >> 2] = 0, r[n + 296 >> 2] = -1082130432, r[n + 300 >> 2] = -1082130432, r[n + 288 >> 2] = 2143289344, r[n + 292 >> 2] = 2143289344, T2(e + 228 | 0, n, 320), r[e + 244 >> 2] = 0, r[e + 248 >> 2] = 0, P[e + 4 | 0] = z[e + 4 | 0] | 1, f = r[e + 556 >> 2], a = r[e + 560 >> 2], (f | 0) != (a | 0))
                for (; i = r[f >> 2], r[i + 552 >> 2] != (e | 0) && (u = r[e + 568 >> 2], i = _i(r[u >> 2], z[u + 8 | 0], i, e, l, t), r[f >> 2] = i, r[i + 552 >> 2] = e, i = r[f >> 2]), xi(i, t), l = l + 1 | 0, f = f + 4 | 0, (a | 0) != (f | 0); )
                  ;
              U = n + 320 | 0;
            }
            function Or(e, t, i) {
              var n = 0, f = 0, u = 0, a = 0;
              if (n = e + 4 | 0, f = (n + t | 0) - 1 & 0 - t, t = r[e >> 2], f + i >>> 0 <= (t + e | 0) - 4 >>> 0) {
                u = r[e + 4 >> 2], r[u + 8 >> 2] = r[e + 8 >> 2], r[r[e + 8 >> 2] + 4 >> 2] = u, (n | 0) != (f | 0) && (f = f - n | 0, u = e - (r[e - 4 >> 2] & -2) | 0, n = f + r[u >> 2] | 0, r[u >> 2] = n, r[(u + (n & -4) | 0) - 4 >> 2] = n, e = e + f | 0, t = t - f | 0, r[e >> 2] = t);
                e: {
                  if (i + 24 >>> 0 <= t >>> 0) {
                    n = (e + i | 0) + 8 | 0, t = (t - i | 0) - 8 | 0, r[n >> 2] = t, r[(n + (t & -4) | 0) - 4 >> 2] = t | 1, f = r[n >> 2] - 8 | 0;
                    i: {
                      if (f >>> 0 <= 127) {
                        t = (f >>> 3 | 0) - 1 | 0;
                        break i;
                      }
                      if (u = J2(f), t = ((f >>> 29 - u ^ 4) - (u << 2) | 0) + 110 | 0, f >>> 0 <= 4095)
                        break i;
                      t = ((f >>> 30 - u ^ 2) - (u << 1) | 0) + 71 | 0, t = t >>> 0 >= 63 ? 63 : t;
                    }
                    f = t << 4, r[n + 4 >> 2] = f + 5968, f = f + 5976 | 0, r[n + 8 >> 2] = r[f >> 2], r[f >> 2] = n, r[r[n + 8 >> 2] + 4 >> 2] = n, f = r[1750], u = r[1751], n = t & 31, (t & 63) >>> 0 >= 32 ? (t = 1 << n, n = 0) : (a = 1 << n, t = a - 1 & 1 >>> 32 - n, n = a), r[1750] = n | f, r[1751] = t | u, t = i + 8 | 0, r[e >> 2] = t, r[((t & -4) + e | 0) - 4 >> 2] = t;
                    break e;
                  }
                  r[(e + t | 0) - 4 >> 2] = t;
                }
                e = e + 4 | 0;
              } else
                e = 0;
              return e;
            }
            function f4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0, n = 0, f = 0, u = 0;
              f = U - 320 | 0, U = f, e = r[e >> 2];
              e: {
                if (r[e + 560 >> 2] == r[e + 556 >> 2] || (n = r[t >> 2], t = r[n + 552 >> 2], !zi(e, n)))
                  break e;
                if ((e | 0) == (t | 0)) {
                  for (i = x2(f, 0, 288), t = i, r[t + 16 >> 2] = 2143289344, r[t + 20 >> 2] = 2143289344, x2(t + 24 | 0, 0, 49), r[t + 80 >> 2] = 2143289344, u = t + 288 | 0, t = t + 96 | 0; r[t + 16 >> 2] = -1082130432, r[t + 20 >> 2] = -1082130432, r[t + 8 >> 2] = 0, r[t + 12 >> 2] = 0, r[t >> 2] = -1082130432, r[t + 4 >> 2] = -1082130432, t = t + 24 | 0, (u | 0) != (t | 0); )
                    ;
                  r[i + 312 >> 2] = -1082130432, r[i + 316 >> 2] = -1082130432, r[i + 304 >> 2] = 0, r[i + 308 >> 2] = 0, r[i + 296 >> 2] = -1082130432, r[i + 300 >> 2] = -1082130432, r[i + 288 >> 2] = 2143289344, r[i + 292 >> 2] = 2143289344, T2(n + 228 | 0, i, 320), r[n + 552 >> 2] = 0;
                }
                for (; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
              U = f + 320 | 0;
            }
            function Ci(e) {
              e = e | 0;
              var t = 0, i = 0, n = 0, f = 0, u = 0, a = 0, l = 0;
              if (e) {
                if (a = U - 32 | 0, U = a, t = r[e >> 2], n = r[t + 552 >> 2], n && (zi(n, t), r[t + 552 >> 2] = 0), n = r[t + 556 >> 2], i = r[t + 560 >> 2], (n | 0) != (i | 0))
                  for (i = i - n >> 2, f = i >>> 0 <= 1 ? 1 : i, i = 0; r[r[(i << 2) + n >> 2] + 552 >> 2] = 0, i = i + 1 | 0, (f | 0) != (i | 0); )
                    ;
                r[t + 560 >> 2] = n, i = t + 564 | 0;
                e: {
                  if (r[i >> 2] == (n | 0) || (i = lt(a + 8 | 0, 0, 0, i), f = r[t + 556 >> 2], u = r[t + 560 >> 2] - f | 0, n = r[i + 4 >> 2] - u | 0, u = Oe(n, f, u), f = r[t + 556 >> 2], r[t + 556 >> 2] = u, r[i + 4 >> 2] = f, u = r[t + 560 >> 2], r[t + 560 >> 2] = r[i + 8 >> 2], r[i + 8 >> 2] = u, l = r[t + 564 >> 2], r[t + 564 >> 2] = r[i + 12 >> 2], r[i >> 2] = f, r[i + 12 >> 2] = l, (f | 0) != (u | 0) && (r[i + 8 >> 2] = u + ((f - u | 0) + 3 & -4)), !f))
                    break e;
                  m2(f), n = r[t + 556 >> 2];
                }
                n && (r[t + 560 >> 2] = n, m2(n)), m2(t), t = r[e + 8 >> 2], r[e + 8 >> 2] = 0, t && e0[r[r[t >> 2] + 4 >> 2]](t), t = r[e + 4 >> 2], r[e + 4 >> 2] = 0, t && e0[r[r[t >> 2] + 4 >> 2]](t), U = a + 32 | 0, m2(e);
              }
            }
            function s4(e) {
              e = e | 0;
              var t = 0, i = 0, n = 0;
              n = U - 624 | 0, U = n, t = r[e + 4 >> 2], r[e + 4 >> 2] = 0, t && e0[r[r[t >> 2] + 4 >> 2]](t), t = r[e + 8 >> 2], r[e + 8 >> 2] = 0, t && e0[r[r[t >> 2] + 4 >> 2]](t);
              e: {
                if (e = r[e >> 2], r[e + 560 >> 2] == r[e + 556 >> 2]) {
                  if (r[e + 552 >> 2])
                    break e;
                  t = Si(n + 32 | 0, r[e + 568 >> 2]), i = r[t + 4 >> 2], r[e >> 2] = r[t >> 2], r[e + 4 >> 2] = i, i = r[t + 20 >> 2], r[e + 16 >> 2] = r[t + 16 >> 2], r[e + 20 >> 2] = i, i = r[t + 12 >> 2], r[e + 8 >> 2] = r[t + 8 >> 2], r[e + 12 >> 2] = i, T2(e + 24 | 0, t + 24 | 0, 204), T2(e + 228 | 0, t + 228 | 0, 328), i = r[e + 556 >> 2], i && (r[e + 560 >> 2] = i, m2(i)), r[e + 556 >> 2] = r[t + 556 >> 2], r[e + 560 >> 2] = r[t + 560 >> 2], r[e + 564 >> 2] = r[t + 564 >> 2], r[e + 584 >> 2] = r[t + 584 >> 2], i = r[t + 580 >> 2], r[e + 576 >> 2] = r[t + 576 >> 2], r[e + 580 >> 2] = i, i = r[t + 572 >> 2], r[e + 568 >> 2] = r[t + 568 >> 2], r[e + 572 >> 2] = i, U = n + 624 | 0;
                  return;
                }
                r[n + 16 >> 2] = 3301, Y2(e, n + 16 | 0), M2(), V0();
              }
              r[n >> 2] = 2047, Y2(e, n), M2(), V0();
            }
            function Vi() {
              e4(7084, 3067), q1(7085, 2480, 1, 1, 0), me(7086, 2140, 1, -128, 127), me(7087, 2133, 1, -128, 127), me(7088, 2131, 1, 0, 255), me(7089, 1287, 2, -32768, 32767), me(7090, 1278, 2, 0, 65535), me(7091, 1316, 4, -2147483648, 2147483647), me(7092, 1307, 4, 0, -1), me(7093, 2659, 4, -2147483648, 2147483647), me(7094, 2650, 4, 0, -1), kn(7095, 1777, -2147483648, 2147483647), kn(7096, 1776, 0, -1), yi(7097, 1770, 4), yi(7098, 3015, 8), di(7099, 2677), di(7100, 3904), yr(7101, 4, 2664), yr(7102, 2, 2689), yr(7103, 4, 2704), K1(7104, 2485), d2(7105, 0, 3835), d2(7106, 0, 3937), d2(7107, 1, 3865), d2(7108, 2, 3467), d2(7109, 3, 3498), d2(7110, 4, 3538), d2(7111, 5, 3567), d2(7112, 4, 3974), d2(7113, 5, 4004), d2(7106, 0, 3669), d2(7107, 1, 3636), d2(7108, 2, 3735), d2(7109, 3, 3701), d2(7110, 4, 3802), d2(7111, 5, 3768), d2(7114, 6, 3605), d2(7115, 7, 4043);
            }
            function Oe(e, t, i) {
              var n = 0, f = 0;
              e: {
                if ((e | 0) == (t | 0))
                  break e;
                if (f = e + i | 0, t - f >>> 0 <= 0 - (i << 1) >>> 0)
                  return T2(e, t, i);
                n = (e ^ t) & 3;
                i: {
                  r: {
                    if (e >>> 0 < t >>> 0) {
                      if (n) {
                        n = e;
                        break i;
                      }
                      if (!(e & 3)) {
                        n = e;
                        break r;
                      }
                      for (n = e; ; ) {
                        if (!i)
                          break e;
                        if (P[n | 0] = z[t | 0], t = t + 1 | 0, i = i - 1 | 0, n = n + 1 | 0, !(n & 3))
                          break;
                      }
                      break r;
                    }
                    t: {
                      if (n)
                        break t;
                      if (f & 3)
                        for (; ; ) {
                          if (!i)
                            break e;
                          if (i = i - 1 | 0, n = i + e | 0, P[n | 0] = z[t + i | 0], !(n & 3))
                            break;
                        }
                      if (i >>> 0 <= 3)
                        break t;
                      for (; i = i - 4 | 0, r[i + e >> 2] = r[t + i >> 2], i >>> 0 > 3; )
                        ;
                    }
                    if (!i)
                      break e;
                    for (; i = i - 1 | 0, P[i + e | 0] = z[t + i | 0], !!i; )
                      ;
                    break e;
                  }
                  if (i >>> 0 <= 3)
                    break i;
                  for (; r[n >> 2] = r[t >> 2], t = t + 4 | 0, n = n + 4 | 0, i = i - 4 | 0, i >>> 0 > 3; )
                    ;
                }
                if (!i)
                  break e;
                for (; P[n | 0] = z[t | 0], n = n + 1 | 0, t = t + 1 | 0, i = i - 1 | 0, !!i; )
                  ;
              }
              return e;
            }
            function Bi(e, t, i, n) {
              e:
                switch (t - 9 | 0) {
                  case 0:
                    t = r[i >> 2], r[i >> 2] = t + 4, r[e >> 2] = r[t >> 2];
                    return;
                  case 6:
                    t = r[i >> 2], r[i >> 2] = t + 4, t = te[t >> 1], r[e >> 2] = t, r[e + 4 >> 2] = t >> 31;
                    return;
                  case 7:
                    t = r[i >> 2], r[i >> 2] = t + 4, r[e >> 2] = $e[t >> 1], r[e + 4 >> 2] = 0;
                    return;
                  case 8:
                    t = r[i >> 2], r[i >> 2] = t + 4, t = P[t | 0], r[e >> 2] = t, r[e + 4 >> 2] = t >> 31;
                    return;
                  case 9:
                    t = r[i >> 2], r[i >> 2] = t + 4, r[e >> 2] = z[t | 0], r[e + 4 >> 2] = 0;
                    return;
                  case 16:
                    t = r[i >> 2] + 7 & -8, r[i >> 2] = t + 8, b0[e >> 3] = b0[t >> 3];
                    return;
                  case 17:
                    e0[n | 0](e, i);
                  default:
                    return;
                  case 1:
                  case 4:
                  case 14:
                    t = r[i >> 2], r[i >> 2] = t + 4, t = r[t >> 2], r[e >> 2] = t, r[e + 4 >> 2] = t >> 31;
                    return;
                  case 2:
                  case 5:
                  case 11:
                  case 15:
                    t = r[i >> 2], r[i >> 2] = t + 4, r[e >> 2] = r[t >> 2], r[e + 4 >> 2] = 0;
                    return;
                  case 3:
                  case 10:
                  case 12:
                  case 13:
                    break e;
                }
              t = r[i >> 2] + 7 & -8, r[i >> 2] = t + 8, i = r[t + 4 >> 2], r[e >> 2] = r[t >> 2], r[e + 4 >> 2] = i;
            }
            function Fi(e, t, i, n) {
              var f = 0, u = 0, a = 0, l = 0, p = 0, E = 0, I = 0, F = 0, Z = 0, T = o(0), v = o(0), R = o(0), N = 0, S = o(0);
              e: {
                if (t == 0 || (T = h[e + 248 >> 2], v = h[e + 244 >> 2], R = h[e + 232 >> 2], p = +h[e + 228 >> 2], f = z[e + 4 | 0] & 8, u = f >>> 3 | 0, N = e, S = ne(p, t, 0, u), h[N + 228 >> 2] = S, E = +R, N = e, S = ne(E, t, 0, u), h[N + 232 >> 2] = S, I = +v, a = Nr(I * t), u = a == a & e2(a) < 1e-4, l = !(u | a != a ? u : e2(a + -1) < 1e-4), F = +T, a = Nr(F * t), u = a == a & e2(a) < 1e-4, Z = !(u | a != a ? u : e2(a + -1) < 1e-4), u = 0, i = p + i, f = (f | 0) != 0, N = e, S = o(ne(i + I, t, f & l, f & !l) - ne(i, t, 0, f)), h[N + 244 >> 2] = S, n = E + n, N = e, S = o(ne(n + F, t, f & Z, f & !Z) - ne(n, t, 0, f)), h[N + 248 >> 2] = S, f = r[e + 560 >> 2], l = r[e + 556 >> 2], (f | 0) == (l | 0)))
                  break e;
                for (f = f - l >> 2, l = f >>> 0 <= 1 ? 1 : f; f = r[e + 556 >> 2], r[e + 560 >> 2] - f >> 2 >>> 0 > u >>> 0 ? f = r[f + (u << 2) >> 2] : f = 0, Fi(f, t, i, n), u = u + 1 | 0, (l | 0) != (u | 0); )
                  ;
              }
            }
            function x2(e, t, i) {
              var n = 0, f = 0, u = 0, a = 0;
              e: {
                if (!i || (P[e | 0] = t, n = e + i | 0, P[n - 1 | 0] = t, i >>> 0 < 3) || (P[e + 2 | 0] = t, P[e + 1 | 0] = t, P[n - 3 | 0] = t, P[n - 2 | 0] = t, i >>> 0 < 7) || (P[e + 3 | 0] = t, P[n - 4 | 0] = t, i >>> 0 < 9) || (n = 0 - e & 3, f = n + e | 0, t = $0(t & 255, 16843009), r[f >> 2] = t, n = i - n & -4, i = n + f | 0, r[i - 4 >> 2] = t, n >>> 0 < 9) || (r[f + 8 >> 2] = t, r[f + 4 >> 2] = t, r[i - 8 >> 2] = t, r[i - 12 >> 2] = t, n >>> 0 < 25) || (r[f + 24 >> 2] = t, r[f + 20 >> 2] = t, r[f + 16 >> 2] = t, r[f + 12 >> 2] = t, r[i - 16 >> 2] = t, r[i - 20 >> 2] = t, r[i - 24 >> 2] = t, r[i - 28 >> 2] = t, a = f & 4 | 24, i = n - a | 0, i >>> 0 < 32))
                  break e;
                for (n = Ir(t, 0, 1, 1), u = I2, t = f + a | 0; r[t + 24 >> 2] = n, r[t + 28 >> 2] = u, r[t + 16 >> 2] = n, r[t + 20 >> 2] = u, r[t + 8 >> 2] = n, r[t + 12 >> 2] = u, r[t >> 2] = n, r[t + 4 >> 2] = u, t = t + 32 | 0, i = i - 32 | 0, i >>> 0 > 31; )
                  ;
              }
              return e;
            }
            function m2(e) {
              e = e | 0;
              var t = 0, i = 0, n = 0, f = 0, u = 0;
              if (e) {
                t = e - 4 | 0, f = r[t >> 2], i = f, n = t, u = r[e - 8 >> 2], e = u & -2, (e | 0) != (u | 0) && (n = t - e | 0, i = r[n + 4 >> 2], r[i + 8 >> 2] = r[n + 8 >> 2], r[r[n + 8 >> 2] + 4 >> 2] = i, i = e + f | 0), e = t + f | 0, t = r[e >> 2], (t | 0) != r[(e + t | 0) - 4 >> 2] && (f = r[e + 4 >> 2], r[f + 8 >> 2] = r[e + 8 >> 2], r[r[e + 8 >> 2] + 4 >> 2] = f, i = t + i | 0), r[n >> 2] = i, r[((i & -4) + n | 0) - 4 >> 2] = i | 1, t = r[n >> 2] - 8 | 0;
                e: {
                  if (t >>> 0 <= 127) {
                    e = (t >>> 3 | 0) - 1 | 0;
                    break e;
                  }
                  if (i = J2(t), e = ((t >>> 29 - i ^ 4) - (i << 2) | 0) + 110 | 0, t >>> 0 <= 4095)
                    break e;
                  e = ((t >>> 30 - i ^ 2) - (i << 1) | 0) + 71 | 0, e = e >>> 0 >= 63 ? 63 : e;
                }
                t = e << 4, r[n + 4 >> 2] = t + 5968, t = t + 5976 | 0, r[n + 8 >> 2] = r[t >> 2], r[t >> 2] = n, r[r[n + 8 >> 2] + 4 >> 2] = n, t = r[1750], i = r[1751], n = e & 31, (e & 63) >>> 0 >= 32 ? (e = 1 << n, f = 0) : (f = 1 << n, e = f - 1 & 1 >>> 32 - n), r[1750] = f | t, r[1751] = e | i;
              }
            }
            function u4(e, t, i) {
              e = e | 0, t = t | 0, i = i | 0;
              var n = 0, f = 0, u = 0, a = 0, l = 0, p = 0, E = 0;
              n = U - 32 | 0, U = n, f = r[e + 28 >> 2], r[n + 16 >> 2] = f, u = r[e + 20 >> 2], r[n + 28 >> 2] = i, r[n + 24 >> 2] = t, t = u - f | 0, r[n + 20 >> 2] = t, u = t + i | 0, p = 2, t = n + 16 | 0;
              e: {
                for (; ; ) {
                  i: {
                    r: {
                      t: {
                        if (!ln(b1(r[e + 60 >> 2], t | 0, p | 0, n + 12 | 0) | 0)) {
                          if (a = r[n + 12 >> 2], (a | 0) == (u | 0))
                            break t;
                          if ((a | 0) >= 0)
                            break r;
                          break i;
                        }
                        if ((u | 0) != -1)
                          break i;
                      }
                      t = r[e + 44 >> 2], r[e + 28 >> 2] = t, r[e + 20 >> 2] = t, r[e + 16 >> 2] = t + r[e + 48 >> 2], e = i;
                      break e;
                    }
                    l = r[t + 4 >> 2], E = l >>> 0 < a >>> 0, f = (E << 3) + t | 0, l = a - (E ? l : 0) | 0, r[f >> 2] = l + r[f >> 2], t = (E ? 12 : 4) + t | 0, r[t >> 2] = r[t >> 2] - l, u = u - a | 0, p = p - E | 0, t = f;
                    continue;
                  }
                  break;
                }
                if (r[e + 28 >> 2] = 0, r[e + 16 >> 2] = 0, r[e + 20 >> 2] = 0, r[e >> 2] = r[e >> 2] | 32, e = 0, (p | 0) == 2)
                  break e;
                e = i - r[t + 4 >> 2] | 0;
              }
              return U = n + 32 | 0, e | 0;
            }
            function a4(e) {
              e = e | 0;
              var t = 0, i = 0, n = 0, f = 0, u = 0;
              i = U - 96 | 0, U = i, r[i >> 2] = e, n = U - 16 | 0, U = n, r[n + 12 >> 2] = i, e = U - 144 | 0, U = e, e = T2(e, 5520, 144), u = i + 16 | 0, t = u, r[e + 44 >> 2] = t, r[e + 20 >> 2] = t, f = -2 - t | 0, f = f >>> 0 >= 2147483647 ? 2147483647 : f, r[e + 48 >> 2] = f, t = t + f | 0, r[e + 28 >> 2] = t, r[e + 16 >> 2] = t, Pi(e, 2202, i, 0, 0), f && (t = r[e + 20 >> 2], P[t - ((t | 0) == r[e + 16 >> 2]) | 0] = 0), U = e + 144 | 0, U = n + 16 | 0, e = u;
              e: {
                if (e & 3)
                  for (; ; ) {
                    if (!z[e | 0])
                      break e;
                    if (e = e + 1 | 0, !(e & 3))
                      break;
                  }
                for (; t = e, e = e + 4 | 0, n = r[t >> 2], !((n ^ -1) & n - 16843009 & -2139062144); )
                  ;
                for (; e = t, t = e + 1 | 0, !!z[e | 0]; )
                  ;
              }
              return e = (e - u | 0) + 1 | 0, t = Er(e), t ? e = T2(t, u, e) : e = 0, U = i + 96 | 0, e | 0;
            }
            function Pi(e, t, i, n, f) {
              var u = 0, a = 0, l = 0, p = 0;
              u = U - 208 | 0, U = u, r[u + 204 >> 2] = i, i = u + 160 | 0, x2(i, 0, 40), r[u + 200 >> 2] = r[u + 204 >> 2];
              e: {
                if ((Oi(0, t, u + 200 | 0, u + 80 | 0, i, n, f) | 0) < 0) {
                  f = -1;
                  break e;
                }
                p = r[e + 76 >> 2] >= 0, a = r[e >> 2], r[e + 72 >> 2] <= 0 && (r[e >> 2] = a & -33);
                i: {
                  r: {
                    t: {
                      if (!r[e + 48 >> 2]) {
                        r[e + 48 >> 2] = 80, r[e + 28 >> 2] = 0, r[e + 16 >> 2] = 0, r[e + 20 >> 2] = 0, l = r[e + 44 >> 2], r[e + 44 >> 2] = u;
                        break t;
                      }
                      if (r[e + 16 >> 2])
                        break r;
                    }
                    if (i = -1, bi(e))
                      break i;
                  }
                  i = Oi(e, t, u + 200 | 0, u + 80 | 0, u + 160 | 0, n, f);
                }
                if (l && (e0[r[e + 36 >> 2]](e, 0, 0) | 0, r[e + 48 >> 2] = 0, r[e + 44 >> 2] = l, r[e + 28 >> 2] = 0, t = r[e + 20 >> 2], r[e + 16 >> 2] = 0, r[e + 20 >> 2] = 0, i = t ? i : -1), t = e, e = r[e >> 2], r[t >> 2] = e | a & 32, f = e & 32 ? -1 : i, !p)
                  break e;
              }
              return U = u + 208 | 0, f;
            }
            function Mt(e) {
              var t = 0, i = o(0), n = 0, f = 0, u = 0, a = 0, l = 0, p = o(0), E = 0;
              u = U - 16 | 0, U = u, t = r[e + 12 >> 2];
              e: {
                if (t) {
                  p = h[e + 520 >> 2], i = h[e + 516 >> 2];
                  i: {
                    if (z[e + 4 | 0] & 32) {
                      i = o(e0[t | 0](e, i, p, 0));
                      break i;
                    }
                    i = o(e0[t | 0](e, i, p));
                  }
                  if (i == i)
                    break e;
                  r[u >> 2] = 3409, Y2(e, u), M2(), V0();
                }
                i: {
                  r: {
                    if (a = r[e + 556 >> 2], t = r[e + 560 >> 2], (a | 0) != (t | 0)) {
                      for (t = t - a >> 2, E = t >>> 0 <= 1 ? 1 : t; ; ) {
                        if (f = r[(l << 2) + a >> 2], !r[f + 548 >> 2]) {
                          if (t = r[f + 24 >> 2], (t & 196608) != 131072) {
                            if (t = t >>> 13 & 7, t || (t = r[e + 24 >> 2] >>> 10 & 7), z[f + 4 | 0] & 2 | (z[e + 24 | 0] & 8 ? (t | 0) == 5 : 0))
                              break r;
                            n = n || f;
                          }
                          if (l = l + 1 | 0, (E | 0) != (l | 0))
                            continue;
                        }
                        break;
                      }
                      if (n)
                        break i;
                    }
                    i = h[e + 520 >> 2];
                    break e;
                  }
                  n = f;
                }
                i = o(Mt(n) + h[n + 232 >> 2]);
              }
              return U = u + 16 | 0, i;
            }
            function qe(e, t, i, n, f, u) {
              var a = 0, l = o(0), p = 0, E = o(0);
              a = (r[(t << 2) + 4320 >> 2] << 2) + e | 0, l = h[a + 216 >> 2];
              e: {
                i: {
                  a = r[a + 216 >> 2];
                  r: {
                    if ((a | 0) == 2139156720)
                      break r;
                    if ((a | 0) == 2140081935)
                      break i;
                    p = 4336;
                    t: {
                      if ((a | 0) != 2141891242) {
                        if (l == l)
                          break t;
                        p = 4344;
                      }
                      switch (E = h[p >> 2], l = o(l0), r[p + 4 >> 2] - 1 | 0) {
                        case 0:
                          break i;
                        case 1:
                          break r;
                        default:
                          break e;
                      }
                    }
                    if (E = (j(2, (a & -1073741825) + 536870912 | 0), f0()), !(a & 1073741824))
                      break i;
                  }
                  l = o(o(E * i) * o(0.009999999776482582));
                  break e;
                }
                l = E;
              }
              n = o(l + o(E0(e, t, n) + B0(e, t, n)));
              e: {
                i: {
                  r:
                    switch (r[f >> 2]) {
                      case 1:
                      case 2:
                        i = h[u >> 2], n = n != n || i < n ? i : n;
                        break i;
                      case 0:
                        break r;
                      default:
                        break e;
                    }
                  if (n != n)
                    break e;
                  r[f >> 2] = 2;
                }
                h[u >> 2] = n;
              }
            }
            function X0(e, t, i) {
              var n = o(0), f = o(0), u = 0, a = o(0);
              e = e + 116 | 0, u = r[(t << 2) + 4288 >> 2];
              e: {
                if ((t & -2) == 2) {
                  t = re(e, 4, u, 2140081935);
                  break e;
                }
                t = ie(e, u, 2140081935);
              }
              e: {
                i: {
                  r: {
                    t: {
                      if ((t | 0) == 2139156720)
                        break t;
                      if ((t | 0) == 2140081935)
                        break e;
                      e = 4336;
                      n: {
                        if ((t | 0) != 2141891242) {
                          if (n = (j(2, t), f0()), n == n)
                            break n;
                          e = 4344;
                        }
                        switch (n = h[e >> 2], f = o(l0), r[e + 4 >> 2] - 1 | 0) {
                          case 0:
                            break r;
                          case 1:
                            break t;
                          default:
                            break i;
                        }
                      }
                      if (n = (j(2, (t & -1073741825) + 536870912 | 0), f0()), !(t & 1073741824))
                        break r;
                    }
                    n = o(o(n * i) * o(0.009999999776482582));
                  }
                  if (n >= o(0))
                    return n;
                  if (f = n, n < o(0))
                    break e;
                }
                a = f == f ? f : o(0);
              }
              return a;
            }
            function H0(e, t, i) {
              var n = o(0), f = o(0), u = 0, a = o(0);
              e = e + 116 | 0, u = r[(t << 2) + 4304 >> 2];
              e: {
                if ((t & -2) == 2) {
                  t = re(e, 5, u, 2140081935);
                  break e;
                }
                t = ie(e, u, 2140081935);
              }
              e: {
                i: {
                  r: {
                    t: {
                      if ((t | 0) == 2139156720)
                        break t;
                      if ((t | 0) == 2140081935)
                        break e;
                      e = 4336;
                      n: {
                        if ((t | 0) != 2141891242) {
                          if (n = (j(2, t), f0()), n == n)
                            break n;
                          e = 4344;
                        }
                        switch (n = h[e >> 2], f = o(l0), r[e + 4 >> 2] - 1 | 0) {
                          case 0:
                            break r;
                          case 1:
                            break t;
                          default:
                            break i;
                        }
                      }
                      if (n = (j(2, (t & -1073741825) + 536870912 | 0), f0()), !(t & 1073741824))
                        break r;
                    }
                    n = o(o(n * i) * o(0.009999999776482582));
                  }
                  if (n >= o(0))
                    return n;
                  if (f = n, n < o(0))
                    break e;
                }
                a = f == f ? f : o(0);
              }
              return a;
            }
            function _i(e, t, i, n, f, u) {
              var a = 0;
              e: {
                i: {
                  if (e) {
                    r: {
                      if (t & 4) {
                        u = e0[e | 0](i, n, f, u) | 0;
                        break r;
                      }
                      u = e0[e | 0](i, n, f) | 0;
                    }
                    if (u)
                      break i;
                  }
                  if (u = B(588), t = T2(u, i, 552), r[t + 564 >> 2] = 0, r[t + 556 >> 2] = 0, r[t + 560 >> 2] = 0, f = r[i + 556 >> 2], n = r[i + 560 >> 2], (f | 0) != (n | 0)) {
                    if (a = n - f | 0, (a | 0) < 0)
                      break e;
                    for (e = B(a), r[t + 556 >> 2] = e, r[t + 564 >> 2] = e + a; r[e >> 2] = r[f >> 2], e = e + 4 | 0, f = f + 4 | 0, (n | 0) != (f | 0); )
                      ;
                    r[t + 560 >> 2] = e;
                  }
                  e = r[i + 572 >> 2], r[t + 568 >> 2] = r[i + 568 >> 2], r[t + 572 >> 2] = e, r[t + 584 >> 2] = r[i + 584 >> 2], e = r[i + 580 >> 2], r[t + 576 >> 2] = r[i + 576 >> 2], r[t + 580 >> 2] = e, r[t + 552 >> 2] = 0;
                }
                return u;
              }
              We(), V0();
            }
            function Y2(e, t) {
              var i = 0, n = 0, f = 0;
              f = U - 16 | 0, U = f, r[f + 12 >> 2] = t;
              e: {
                i: {
                  if (!e) {
                    t = r[f + 12 >> 2];
                    break i;
                  }
                  if (t = r[f + 12 >> 2], i = r[e + 568 >> 2], !i)
                    break i;
                  if (n = r[i + 4 >> 2], z[i + 8 | 0] & 8) {
                    e0[n | 0](i, e, 5, 0, 4284, t) | 0;
                    break e;
                  }
                  e0[n | 0](i, e, 5, 4284, t) | 0;
                  break e;
                }
                i: {
                  if (!z[7016]) {
                    i = B(28), r[i + 20 >> 2] = 1065353216, r[i + 24 >> 2] = 0, r[i + 12 >> 2] = 0, r[i + 16 >> 2] = 0, r[i >> 2] = 0, P[i + 8 | 0] = 0, n = 1, r[i + 4 >> 2] = 1, r[1753] = i, P[7016] = 1, r[1752] = r[1752] + 1;
                    break i;
                  }
                  if (i = r[1753], n = r[i + 4 >> 2], !(z[i + 8 | 0] & 8))
                    break i;
                  e0[n | 0](i, e, 5, 0, 4284, t) | 0;
                  break e;
                }
                e0[n | 0](i, e, 5, 4284, t) | 0;
              }
              U = f + 16 | 0;
            }
            function at(e, t, i) {
              var n = o(0), f = 0, u = o(0);
              e = e + 80 | 0, f = r[(t << 2) + 4304 >> 2];
              e: {
                i: {
                  if ((t & -2) == 2) {
                    t = re(e, 5, f, 2140081935);
                    break i;
                  }
                  t = ie(e, f, 2140081935);
                }
                i: {
                  r: {
                    if ((t | 0) == 2139156720)
                      break r;
                    if ((t | 0) == 2140081935)
                      break e;
                    e = 4336;
                    t: {
                      if ((t | 0) != 2141891242) {
                        if (n = (j(2, t), f0()), n == n)
                          break t;
                        e = 4344;
                      }
                      switch (n = h[e >> 2], u = o(l0), r[e + 4 >> 2] - 1 | 0) {
                        case 0:
                          break e;
                        case 1:
                          break r;
                        default:
                          break i;
                      }
                    }
                    if (n = (j(2, (t & -1073741825) + 536870912 | 0), f0()), !(t & 1073741824))
                      break e;
                  }
                  u = o(o(n * i) * o(0.009999999776482582));
                }
                return u;
              }
              return n;
            }
            function Se(e, t, i) {
              var n = o(0), f = 0, u = o(0);
              e = e + 80 | 0, f = r[(t << 2) + 4288 >> 2];
              e: {
                i: {
                  if ((t & -2) == 2) {
                    t = re(e, 4, f, 2140081935);
                    break i;
                  }
                  t = ie(e, f, 2140081935);
                }
                i: {
                  r: {
                    if ((t | 0) == 2139156720)
                      break r;
                    if ((t | 0) == 2140081935)
                      break e;
                    e = 4336;
                    t: {
                      if ((t | 0) != 2141891242) {
                        if (n = (j(2, t), f0()), n == n)
                          break t;
                        e = 4344;
                      }
                      switch (n = h[e >> 2], u = o(l0), r[e + 4 >> 2] - 1 | 0) {
                        case 0:
                          break e;
                        case 1:
                          break r;
                        default:
                          break i;
                      }
                    }
                    if (n = (j(2, (t & -1073741825) + 536870912 | 0), f0()), !(t & 1073741824))
                      break e;
                  }
                  u = o(o(n * i) * o(0.009999999776482582));
                }
                return u;
              }
              return n;
            }
            function re(e, t, i, n) {
              var f = o(0);
              t = (t << 2) + e | 0, f = h[t >> 2], t = r[t >> 2];
              e: {
                if ((t | 0) == 2139156720 | (t | 0) == 2140081935 | (t | 0) == 2141891242 | f == f || (t = (i << 2) + e | 0, f = h[t >> 2], t = r[t >> 2], (t | 0) == 2139156720 | (t | 0) == 2140081935 | (t | 0) == 2141891242 | f == f) || (t = r[e + 24 >> 2], f = h[e + 24 >> 2], (t | 0) == 2139156720 | (t | 0) == 2140081935 | (t | 0) == 2141891242 | f == f) || (f = h[e + 32 >> 2], e = r[e + 32 >> 2], !((e | 0) == 2139156720 | (e | 0) == 2140081935 | (e | 0) == 2141891242) && (t = n, f != f)))
                  break e;
                t = e;
              }
              return t;
            }
            function l4(e, t) {
              e = e | 0, t = o(t);
              var i = 0, n = 0, f = 0;
              if (i = U - 16 | 0, U = i, e = r[e >> 2], !(t >= o(0))) {
                r[i >> 2] = 2263, n = U - 16 | 0, U = n, r[n + 12 >> 2] = i;
                e: {
                  if (e)
                    break e;
                  if (z[7016]) {
                    e = r[1753];
                    break e;
                  }
                  e = B(28), r[e + 20 >> 2] = 1065353216, r[e + 24 >> 2] = 0, r[e + 12 >> 2] = 0, r[e + 16 >> 2] = 0, r[e >> 2] = 0, P[e + 8 | 0] = 0, r[e + 4 >> 2] = 1, r[1753] = e, P[7016] = 1, r[1752] = r[1752] + 1;
                }
                f = r[e + 4 >> 2];
                e: {
                  if (z[e + 8 | 0] & 8) {
                    e0[f | 0](e, 0, 5, 0, 4284, i) | 0;
                    break e;
                  }
                  e0[f | 0](e, 0, 5, 4284, i) | 0;
                }
                U = n + 16 | 0, M2(), V0();
              }
              h[e + 20 >> 2] = t == o(0) ? o(0) : t, U = i + 16 | 0;
            }
            function Mi(e, t, i, n, f) {
              var u = 0, a = 0, l = o(0), p = 0;
              u = 2, a = r[e + 24 >> 2] >>> 2 & 3;
              e: {
                i: {
                  r: {
                    if (!(!r[e + 552 >> 2] | (t | 0) != 2)) {
                      t = 0, u = 3;
                      t:
                        switch (a - 2 | 0) {
                          case 0:
                            break e;
                          case 1:
                            break t;
                          default:
                            break r;
                        }
                      u = 2;
                      break e;
                    }
                    if (t = 0, a >>> 0 > 1)
                      break i;
                  }
                  t = u;
                }
                u = a;
              }
              i = fn(e, u, i), n = fn(e, t, n), l = E0(e, u, f), a = e + 228 | 0, p = u << 2, h[a + (r[p + 4288 >> 2] << 2) >> 2] = i + l, l = B0(e, u, f), h[a + (r[p + 4304 >> 2] << 2) >> 2] = i + l, i = E0(e, t, f), u = t << 2, h[a + (r[u + 4288 >> 2] << 2) >> 2] = n + i, i = B0(e, t, f), h[a + (r[u + 4304 >> 2] << 2) >> 2] = n + i;
            }
            function c4(e, t, i, n, f, u) {
              e = e | 0, t = t | 0, i = o(i), n = n | 0, f = o(f), u = u | 0;
              var a = 0, l = 0, p = 0;
              a = U - 48 | 0, U = a, p = r[t + 8 >> 2];
              e: {
                if (P[7052] & 1) {
                  t = r[1762];
                  break e;
                }
                t = gi(5, 4480) | 0, P[7052] = 1, r[1762] = t;
              }
              r[a + 40 >> 2] = u, h[a + 32 >> 2] = f, r[a + 24 >> 2] = n, h[a + 16 >> 2] = i, l = +U1(t | 0, p | 0, 2922, a + 12 | 0, a + 16 | 0);
              e: {
                if (l < 4294967296 & l >= 0) {
                  t = ~~l >>> 0;
                  break e;
                }
                t = 0;
              }
              n = r[a + 12 >> 2], u = r[t + 4 >> 2], r[e >> 2] = r[t >> 2], r[e + 4 >> 2] = u, u = r[t + 12 >> 2], r[e + 8 >> 2] = r[t + 8 >> 2], r[e + 12 >> 2] = u, z1(n | 0), U = a + 48 | 0;
            }
            function k4(e, t, i) {
              e = e | 0, t = t | 0, i = i | 0;
              var n = 0, f = 0, u = 0, a = 0;
              if (n = U - 32 | 0, U = n, f = r[t >> 2], f >>> 0 < 2147483632) {
                e: {
                  i: {
                    if (f >>> 0 >= 11) {
                      u = (f | 15) + 1 | 0, a = B(u), r[n + 16 >> 2] = u | -2147483648, r[n + 8 >> 2] = a, r[n + 12 >> 2] = f, u = f + a | 0;
                      break i;
                    }
                    if (P[n + 19 | 0] = f, a = n + 8 | 0, u = a + f | 0, !f)
                      break e;
                  }
                  T2(a, t + 4 | 0, f);
                }
                return P[u | 0] = 0, r[n >> 2] = i, e0[e | 0](n + 24 | 0, n + 8 | 0, n), H1(r[n + 24 >> 2]), e = r[n + 24 >> 2], ut(e | 0), ut(r[n >> 2]), P[n + 19 | 0] < 0 && m2(r[n + 8 >> 2]), U = n + 32 | 0, e | 0;
              }
              We(), V0();
            }
            function c2(e, t, i) {
              var n = 0, f = 0, u = 0;
              if (!(z[e | 0] & 32))
                e: {
                  n = t, t = e, e = r[t + 16 >> 2];
                  i: {
                    if (!e) {
                      if (bi(t))
                        break i;
                      e = r[t + 16 >> 2];
                    }
                    if (u = r[t + 20 >> 2], e - u >>> 0 < i >>> 0) {
                      e0[r[t + 36 >> 2]](t, n, i) | 0;
                      break e;
                    }
                    r: {
                      if (r[t + 80 >> 2] < 0)
                        break r;
                      for (e = i; ; ) {
                        if (f = e, !e)
                          break r;
                        if (e = f - 1 | 0, z[n + e | 0] == 10)
                          break;
                      }
                      if (e0[r[t + 36 >> 2]](t, n, f) >>> 0 < f >>> 0)
                        break i;
                      n = n + f | 0, i = i - f | 0, u = r[t + 20 >> 2];
                    }
                    T2(u, n, i), r[t + 20 >> 2] = r[t + 20 >> 2] + i;
                  }
                }
            }
            function Sr(e, t, i) {
              var n = 0, f = 0, u = 0;
              n = U - 16 | 0, U = n, f = e + 24 | 0, e0[t | 0](n + 8 | 0, f), u = r[n + 12 >> 2];
              e: {
                if ((r[r[n + 8 >> 2] >> 2] & 7 << u) >> u == (i | 0))
                  break e;
                for (e0[t | 0](n + 8 | 0, f), t = r[n + 8 >> 2], f = t, u = r[t >> 2], t = r[n + 12 >> 2], r[f >> 2] = u & (7 << t ^ -1) | (i & 7) << t; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
              U = n + 16 | 0;
            }
            function ie(e, t, i) {
              var n = o(0);
              t = (t << 2) + e | 0, n = h[t >> 2], t = r[t >> 2];
              e: {
                if ((t | 0) == 2139156720 | (t | 0) == 2140081935 | (t | 0) == 2141891242 | n == n || (t = r[e + 28 >> 2], n = h[e + 28 >> 2], (t | 0) == 2139156720 | (t | 0) == 2140081935 | (t | 0) == 2141891242 | n == n) || (n = h[e + 32 >> 2], e = r[e + 32 >> 2], !((e | 0) == 2139156720 | (e | 0) == 2140081935 | (e | 0) == 2141891242) && (t = i, n != n)))
                  break e;
                t = e;
              }
              return t;
            }
            function B0(e, t, i) {
              var n = o(0), f = 0;
              e = e + 44 | 0, f = r[(t << 2) + 4304 >> 2];
              e: {
                if ((t & -2) == 2) {
                  e = re(e, 5, f, 2140081935);
                  break e;
                }
                e = ie(e, f, 2140081935);
              }
              e: {
                if ((e | 0) != 2139156720) {
                  if ((e | 0) == 2140081935 | (e | 0) == 2141891242)
                    break e;
                  if (n = (j(2, e), f0()), n != n)
                    return o(l0);
                  if (n = (j(2, (e & -1073741825) + 536870912 | 0), f0()), !(e & 1073741824))
                    break e;
                }
                n = o(o(n * i) * o(0.009999999776482582));
              }
              return n;
            }
            function E0(e, t, i) {
              var n = o(0), f = 0;
              e = e + 44 | 0, f = r[(t << 2) + 4288 >> 2];
              e: {
                if ((t & -2) == 2) {
                  e = re(e, 4, f, 2140081935);
                  break e;
                }
                e = ie(e, f, 2140081935);
              }
              e: {
                if ((e | 0) != 2139156720) {
                  if ((e | 0) == 2140081935 | (e | 0) == 2141891242)
                    break e;
                  if (n = (j(2, e), f0()), n != n)
                    return o(l0);
                  if (n = (j(2, (e & -1073741825) + 536870912 | 0), f0()), !(e & 1073741824))
                    break e;
                }
                n = o(o(n * i) * o(0.009999999776482582));
              }
              return n;
            }
            function h4(e, t, i) {
              e = e | 0, t = t | 0, i = i | 0;
              var n = 0, f = 0, u = 0, a = 0, l = 0;
              return f = r[e + 84 >> 2], u = r[f >> 2], n = r[f + 4 >> 2], l = r[e + 28 >> 2], a = r[e + 20 >> 2] - l | 0, a = n >>> 0 < a >>> 0 ? n : a, a && (T2(u, l, a), u = a + r[f >> 2] | 0, r[f >> 2] = u, n = r[f + 4 >> 2] - a | 0, r[f + 4 >> 2] = n), n = i >>> 0 > n >>> 0 ? n : i, n && (T2(u, t, n), u = n + r[f >> 2] | 0, r[f >> 2] = u, r[f + 4 >> 2] = r[f + 4 >> 2] - n), P[u | 0] = 0, t = r[e + 44 >> 2], r[e + 28 >> 2] = t, r[e + 20 >> 2] = t, i | 0;
            }
            function F0(e, t) {
              var i = o(0), n = 0;
              e = e + 152 | 0, n = r[(t << 2) + 4304 >> 2];
              e: {
                if ((t & -2) == 2) {
                  e = re(e, 5, n, 2140081935);
                  break e;
                }
                e = ie(e, n, 2140081935);
              }
              i = o(0);
              e: {
                if ((e | 0) == 2139156720 || (i = o(0), (e | 0) == 2140081935))
                  break e;
                i: {
                  if ((e | 0) == 2141891242 || (i = (j(2, e), f0()), i != i))
                    break i;
                  i = (j(2, (e & -1073741825) + 536870912 | 0), f0());
                  break e;
                }
                i = o(l0);
              }
              return d0(i, o(0));
            }
            function Z0(e, t) {
              var i = o(0), n = 0;
              e = e + 152 | 0, n = r[(t << 2) + 4288 >> 2];
              e: {
                if ((t & -2) == 2) {
                  e = re(e, 4, n, 2140081935);
                  break e;
                }
                e = ie(e, n, 2140081935);
              }
              i = o(0);
              e: {
                if ((e | 0) == 2139156720 || (i = o(0), (e | 0) == 2140081935))
                  break e;
                i: {
                  if ((e | 0) == 2141891242 || (i = (j(2, e), f0()), i != i))
                    break i;
                  i = (j(2, (e & -1073741825) + 536870912 | 0), f0());
                  break e;
                }
                i = o(l0);
              }
              return d0(i, o(0));
            }
            function A4(e, t, i) {
              e = e | 0, t = t | 0, i = i | 0;
              var n = 0, f = 0, u = o(0);
              n = 2, t = r[t >> 2] + (i << 2) | 0, u = h[t + 116 >> 2];
              e: {
                i: {
                  if (t = r[t + 116 >> 2], (t | 0) != 2139156720) {
                    if (f = l0, (t | 0) == 2141891242) {
                      n = 3;
                      break e;
                    }
                    if ((t | 0) != 2140081935)
                      break i;
                    f = 0, n = 1;
                    break e;
                  }
                  break e;
                }
                if (u != u) {
                  n = 0;
                  break e;
                }
                n = t & 1073741824 ? 2 : 1, f = (j(2, (t & -1073741825) + 536870912 | 0), +f0());
              }
              b0[e + 8 >> 3] = f, r[e >> 2] = n;
            }
            function p4(e, t, i) {
              e = e | 0, t = t | 0, i = i | 0;
              var n = 0, f = 0, u = o(0);
              n = 2, t = r[t >> 2] + (i << 2) | 0, u = h[t + 80 >> 2];
              e: {
                i: {
                  if (t = r[t + 80 >> 2], (t | 0) != 2139156720) {
                    if (f = l0, (t | 0) == 2141891242) {
                      n = 3;
                      break e;
                    }
                    if ((t | 0) != 2140081935)
                      break i;
                    f = 0, n = 1;
                    break e;
                  }
                  break e;
                }
                if (u != u) {
                  n = 0;
                  break e;
                }
                n = t & 1073741824 ? 2 : 1, f = (j(2, (t & -1073741825) + 536870912 | 0), +f0());
              }
              b0[e + 8 >> 3] = f, r[e >> 2] = n;
            }
            function m4(e, t, i) {
              e = e | 0, t = t | 0, i = i | 0;
              var n = 0, f = 0, u = o(0);
              n = 2, t = r[t >> 2] + (i << 2) | 0, u = h[t + 44 >> 2];
              e: {
                i: {
                  if (t = r[t + 44 >> 2], (t | 0) != 2139156720) {
                    if (f = l0, (t | 0) == 2141891242) {
                      n = 3;
                      break e;
                    }
                    if ((t | 0) != 2140081935)
                      break i;
                    f = 0, n = 1;
                    break e;
                  }
                  break e;
                }
                if (u != u) {
                  n = 0;
                  break e;
                }
                n = t & 1073741824 ? 2 : 1, f = (j(2, (t & -1073741825) + 536870912 | 0), +f0());
              }
              b0[e + 8 >> 3] = f, r[e >> 2] = n;
            }
            function ne(e, t, i, n) {
              var f = 0, u = 0, a = 0;
              e = e * t, f = Nr(e), f = f < 0 ? f + 1 : f, a = f != f;
              e: {
                if (!(a | !(e2(f) < 1e-4))) {
                  e = e - f;
                  break e;
                }
                i: {
                  if (f != f) {
                    e = e - f;
                    break i;
                  }
                  if (e = e - f, !(e2(f + -1) < 1e-4))
                    break i;
                  e = e + 1;
                  break e;
                }
                if (i) {
                  e = e + 1;
                  break e;
                }
                if (n)
                  break e;
                u = 0;
                i: {
                  if (a || (u = 1, f > 0.5))
                    break i;
                  u = e2(f + -0.5) < 1e-4 ? 1 : 0;
                }
                e = e + u;
              }
              return e != e | t != t ? o(l0) : o(e / t);
            }
            function Li(e, t) {
              var i = o(0);
              e: {
                if ((t | 0) != 2139156720) {
                  if ((t | 0) != 2140081935) {
                    if ((t | 0) != 2141891242)
                      break e;
                    r[e >> 2] = 2143289344, r[e + 4 >> 2] = 3;
                    return;
                  }
                  r[e >> 2] = 0, r[e + 4 >> 2] = 1;
                  return;
                }
                r[e >> 2] = 0, r[e + 4 >> 2] = 2;
                return;
              }
              if (i = (j(2, t), f0()), i != i) {
                r[e >> 2] = 2143289344, r[e + 4 >> 2] = 0;
                return;
              }
              r[e + 4 >> 2] = t & 1073741824 ? 2 : 1, r[e >> 2] = (t & -1073741825) + 536870912;
            }
            function Xi(e) {
              var t = 0, i = 0, n = 0;
              i = r[e + 24 >> 2];
              e: {
                if (!(i & 8) || (t = 1, (i & 7168) == 5120) || (t = 0, n = r[e + 560 >> 2], i = r[e + 556 >> 2], (n | 0) == (i | 0)))
                  break e;
                for (e = n - i >> 2, n = e >>> 0 <= 1 ? 1 : e, e = 0; ; ) {
                  if (t = r[r[i + (e << 2) >> 2] + 24 >> 2], t = (t & 196608) != 131072 & (t & 57344) == 40960, t)
                    break e;
                  if (e = e + 1 | 0, (n | 0) == (e | 0))
                    break;
                }
              }
              return t;
            }
            function w4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0, n = 0, f = o(0);
              t = r[t >> 2], f = h[t + 220 >> 2];
              e: {
                i: {
                  if (t = r[t + 220 >> 2], (t | 0) != 2139156720) {
                    if (n = l0, i = 3, (t | 0) == 2141891242)
                      break e;
                    if ((t | 0) != 2140081935)
                      break i;
                    n = 0, i = 1;
                    break e;
                  }
                  i = 2;
                  break e;
                }
                if (i = 0, f != f)
                  break e;
                n = (j(2, (t & -1073741825) + 536870912 | 0), +f0()), i = t & 1073741824 ? 2 : 1;
              }
              t = i, b0[e + 8 >> 3] = n, r[e >> 2] = t;
            }
            function v4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0, n = 0, f = o(0);
              t = r[t >> 2], f = h[t + 200 >> 2];
              e: {
                i: {
                  if (t = r[t + 200 >> 2], (t | 0) != 2139156720) {
                    if (n = l0, i = 3, (t | 0) == 2141891242)
                      break e;
                    if ((t | 0) != 2140081935)
                      break i;
                    n = 0, i = 1;
                    break e;
                  }
                  i = 2;
                  break e;
                }
                if (i = 0, f != f)
                  break e;
                n = (j(2, (t & -1073741825) + 536870912 | 0), +f0()), i = t & 1073741824 ? 2 : 1;
              }
              t = i, b0[e + 8 >> 3] = n, r[e >> 2] = t;
            }
            function g4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0, n = 0, f = o(0);
              t = r[t >> 2], f = h[t + 204 >> 2];
              e: {
                i: {
                  if (t = r[t + 204 >> 2], (t | 0) != 2139156720) {
                    if (n = l0, i = 3, (t | 0) == 2141891242)
                      break e;
                    if ((t | 0) != 2140081935)
                      break i;
                    n = 0, i = 1;
                    break e;
                  }
                  i = 2;
                  break e;
                }
                if (i = 0, f != f)
                  break e;
                n = (j(2, (t & -1073741825) + 536870912 | 0), +f0()), i = t & 1073741824 ? 2 : 1;
              }
              t = i, b0[e + 8 >> 3] = n, r[e >> 2] = t;
            }
            function y4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0, n = 0, f = o(0);
              t = r[t >> 2], f = h[t + 208 >> 2];
              e: {
                i: {
                  if (t = r[t + 208 >> 2], (t | 0) != 2139156720) {
                    if (n = l0, i = 3, (t | 0) == 2141891242)
                      break e;
                    if ((t | 0) != 2140081935)
                      break i;
                    n = 0, i = 1;
                    break e;
                  }
                  i = 2;
                  break e;
                }
                if (i = 0, f != f)
                  break e;
                n = (j(2, (t & -1073741825) + 536870912 | 0), +f0()), i = t & 1073741824 ? 2 : 1;
              }
              t = i, b0[e + 8 >> 3] = n, r[e >> 2] = t;
            }
            function d4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0, n = 0, f = o(0);
              t = r[t >> 2], f = h[t + 212 >> 2];
              e: {
                i: {
                  if (t = r[t + 212 >> 2], (t | 0) != 2139156720) {
                    if (n = l0, i = 3, (t | 0) == 2141891242)
                      break e;
                    if ((t | 0) != 2140081935)
                      break i;
                    n = 0, i = 1;
                    break e;
                  }
                  i = 2;
                  break e;
                }
                if (i = 0, f != f)
                  break e;
                n = (j(2, (t & -1073741825) + 536870912 | 0), +f0()), i = t & 1073741824 ? 2 : 1;
              }
              t = i, b0[e + 8 >> 3] = n, r[e >> 2] = t;
            }
            function R4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0, n = 0, f = o(0);
              t = r[t >> 2], f = h[t + 216 >> 2];
              e: {
                i: {
                  if (t = r[t + 216 >> 2], (t | 0) != 2139156720) {
                    if (n = l0, i = 3, (t | 0) == 2141891242)
                      break e;
                    if ((t | 0) != 2140081935)
                      break i;
                    n = 0, i = 1;
                    break e;
                  }
                  i = 2;
                  break e;
                }
                if (i = 0, f != f)
                  break e;
                n = (j(2, (t & -1073741825) + 536870912 | 0), +f0()), i = t & 1073741824 ? 2 : 1;
              }
              t = i, b0[e + 8 >> 3] = n, r[e >> 2] = t;
            }
            function E4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              if (i = U - 16 | 0, U = i, e = r[e >> 2], (t | 0) < 6) {
                U = i + 16 | 0;
                e: {
                  i:
                    switch (t - 4 | 0) {
                      case 0:
                        if (t = e + 260 | 0, (z[e + 300 | 0] & 3) == 2)
                          break e;
                        t = e + 252 | 0;
                        break e;
                      case 1:
                        if (t = e + 252 | 0, (z[e + 300 | 0] & 3) == 2)
                          break e;
                        t = e + 260 | 0;
                        break e;
                      default:
                        break i;
                    }
                  t = (e + (t << 2) | 0) + 252 | 0;
                }
                return +h[t >> 2];
              }
              r[i >> 2] = 1872, Y2(e, i), M2(), V0();
            }
            function N4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              if (i = U - 16 | 0, U = i, e = r[e >> 2], (t | 0) < 6) {
                U = i + 16 | 0;
                e: {
                  i:
                    switch (t - 4 | 0) {
                      case 0:
                        if (t = e + 276 | 0, (z[e + 300 | 0] & 3) == 2)
                          break e;
                        t = e + 268 | 0;
                        break e;
                      case 1:
                        if (t = e + 268 | 0, (z[e + 300 | 0] & 3) == 2)
                          break e;
                        t = e + 276 | 0;
                        break e;
                      default:
                        break i;
                    }
                  t = (e + (t << 2) | 0) + 268 | 0;
                }
                return +h[t >> 2];
              }
              r[i >> 2] = 1872, Y2(e, i), M2(), V0();
            }
            function W4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              if (i = U - 16 | 0, U = i, e = r[e >> 2], (t | 0) < 6) {
                U = i + 16 | 0;
                e: {
                  i:
                    switch (t - 4 | 0) {
                      case 0:
                        if (t = e + 292 | 0, (z[e + 300 | 0] & 3) == 2)
                          break e;
                        t = e + 284 | 0;
                        break e;
                      case 1:
                        if (t = e + 284 | 0, (z[e + 300 | 0] & 3) == 2)
                          break e;
                        t = e + 292 | 0;
                        break e;
                      default:
                        break i;
                    }
                  t = (e + (t << 2) | 0) + 284 | 0;
                }
                return +h[t >> 2];
              }
              r[i >> 2] = 1872, Y2(e, i), M2(), V0();
            }
            function O4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0, n = o(0), f = o(0);
              n = o(l0), t = r[t >> 2], f = h[t + 40 >> 2], t = r[t + 40 >> 2], i = 3;
              e: {
                if ((t | 0) == 2141891242)
                  break e;
                if ((t | 0) == 2140081935) {
                  n = o(0), i = 1;
                  break e;
                }
                if ((t | 0) == 2139156720) {
                  n = o(0), i = 2;
                  break e;
                }
                if (i = 0, f != f)
                  break e;
                n = (j(2, (t & -1073741825) + 536870912 | 0), f0()), i = t & 1073741824 ? 2 : 1;
              }
              r[e >> 2] = i, b0[e + 8 >> 3] = n;
            }
            function oe(e) {
              var t = 0, i = o(0);
              t = 2143289344;
              e: {
                if (o(e2(e)) == o(vi) | e != e || (t = 2139156720, e < o(10842021724855044e-35) & e > o(-10842021724855044e-35) | e == o(0)))
                  break e;
                i = (j(2, (A2(e), O0(2) & -2147483648 | 1602224127)), f0()), t = (A2(e > o(18446742974197924e3) || e < o(-18446742974197924e3) ? i : e), O0(2) - 536870912 | 1073741824);
              }
              return t;
            }
            function Q2(e) {
              var t = 0, i = o(0);
              t = 2143289344;
              e: {
                if (o(e2(e)) == o(vi) | e != e || (t = 2140081935, e < o(10842021724855044e-35) & e > o(-10842021724855044e-35) | e == o(0)))
                  break e;
                i = (j(2, (A2(e), O0(2) & -2147483648 | 1610612735)), f0()), t = (A2(e > o(36893485948395848e3) || e < o(-36893485948395848e3) ? i : e), O0(2) - 536870912 | 0);
              }
              return t;
            }
            function S4(e, t) {
              e = e | 0, t = t | 0;
              var i = o(0), n = o(0);
              e = r[e >> 2] + (t << 2) | 0, n = h[e + 188 >> 2];
              e: {
                i: {
                  if (e = r[e + 188 >> 2], (e | 0) == 2139156720 | (e | 0) == 2140081935)
                    break i;
                  if (i = o(l0), (e | 0) == 2141891242 | n != n)
                    break e;
                  if ((e | 0) == 2139156720)
                    break i;
                  return o((j(2, (e & -1073741825) + 536870912 | 0), f0()));
                }
                i = o(0);
              }
              return o(i);
            }
            function Z4(e, t, i, n, f, u) {
              e = e | 0, t = t | 0, i = o(i), n = n | 0, f = o(f), u = u | 0;
              var a = 0, l = 0;
              return a = U - 16 | 0, U = a, l = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (l = r[l + r[t >> 2] >> 2]), e0[l | 0](a, t, i, n, f, u), e = B(16), t = r[a + 12 >> 2], r[e + 8 >> 2] = r[a + 8 >> 2], r[e + 12 >> 2] = t, t = r[a + 4 >> 2], r[e >> 2] = r[a >> 2], r[e + 4 >> 2] = t, U = a + 16 | 0, e | 0;
            }
            function Hi(e, t) {
              e: {
                if (t) {
                  t = an(r[t >> 2]);
                  break e;
                }
                i: {
                  if (z[7016]) {
                    t = r[1753];
                    break i;
                  }
                  t = B(28), r[t + 20 >> 2] = 1065353216, r[t + 24 >> 2] = 0, r[t + 12 >> 2] = 0, r[t + 16 >> 2] = 0, r[t >> 2] = 0, P[t + 8 | 0] = 0, r[t + 4 >> 2] = 1, r[1753] = t, P[7016] = 1, r[1752] = r[1752] + 1;
                }
                t = an(t);
              }
              return r[e + 4 >> 2] = 0, r[e + 8 >> 2] = 0, r[e >> 2] = t, r[t >> 2] = e, e;
            }
            function G4(e, t, i) {
              e = e | 0, t = t | 0, i = +i;
              var n = 0, f = 0;
              e: {
                if (e = r[e >> 2], t = e + (t << 2) | 0, f = r[t + 152 >> 2], n = Q2(o(i)), (f | 0) == (n | 0))
                  break e;
                for (r[t + 152 >> 2] = n; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function I4(e, t, i) {
              e = e | 0, t = t | 0, i = +i;
              var n = 0, f = 0;
              e: {
                if (e = r[e >> 2], t = e + (t << 2) | 0, f = r[t + 188 >> 2], n = Q2(o(i)), (f | 0) == (n | 0))
                  break e;
                for (r[t + 188 >> 2] = n; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function T4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0, n = o(0);
              e = r[e >> 2] + (t << 2) | 0, n = h[e + 152 >> 2];
              e: {
                i: {
                  if (e = r[e + 152 >> 2], (e | 0) == 2139156720 | (e | 0) == 2140081935)
                    break i;
                  if (i = l0, (e | 0) == 2141891242 | n != n)
                    break e;
                  if ((e | 0) == 2139156720)
                    break i;
                  return j(2, (e & -1073741825) + 536870912 | 0), +f0();
                }
                i = 0;
              }
              return +i;
            }
            function x4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              e: {
                if (e = r[e >> 2], i = r[e + 24 >> 2], (i >>> 20 & 3) == (t | 0))
                  break e;
                for (r[e + 24 >> 2] = i & -3145729 | t << 20 & 3145728; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function et(e, t, i) {
              var n = 0, f = 0, u = 0;
              e: {
                if (!t) {
                  n = e;
                  break e;
                }
                for (; n = Ti(e, t, 10), f = I2, e = Ir(n, f, 246, 0) + e | 0, i = i - 1 | 0, P[i | 0] = e | 48, u = t >>> 0 > 9, e = n, t = f, !!u; )
                  ;
              }
              if (n)
                for (; i = i - 1 | 0, e = (n >>> 0) / 10 | 0, P[i | 0] = $0(e, 246) + n | 48, t = n >>> 0 > 9, n = e, !!t; )
                  ;
              return i;
            }
            function C4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              e: {
                if (e = r[e >> 2], i = r[e + 24 >> 2], (i >>> 22 & 1) == (t | 0))
                  break e;
                for (r[e + 24 >> 2] = i & -4194305 | t << 22 & 4194304; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function V4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              e: {
                if (e = r[e >> 2], i = r[e + 24 >> 2], (i >>> 18 & 3) == (t | 0))
                  break e;
                for (r[e + 24 >> 2] = i & -786433 | t << 18 & 786432; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function B4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              e: {
                if (e = r[e >> 2], i = r[e + 24 >> 2], (i >>> 16 & 3) == (t | 0))
                  break e;
                for (r[e + 24 >> 2] = i & -196609 | t << 16 & 196608; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function F4(e, t) {
              e = e | 0, t = +t;
              var i = 0, n = o(0), f = o(0);
              e: {
                if (n = o(t), e = r[e >> 2], f = h[e + 224 >> 2], n == f | n != n & f != f)
                  break e;
                for (h[e + 224 >> 2] = n; ; ) {
                  if (i = z[e + 4 | 0], i & 4)
                    break e;
                  if (P[e + 4 | 0] = i | 4, i = r[e + 20 >> 2], i && e0[i | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function P4(e, t) {
              e = e | 0, t = +t;
              var i = 0, n = o(0), f = o(0);
              e: {
                if (n = o(t), e = r[e >> 2], f = h[e + 28 >> 2], n == f | n != n & f != f)
                  break e;
                for (h[e + 28 >> 2] = n; ; ) {
                  if (i = z[e + 4 | 0], i & 4)
                    break e;
                  if (P[e + 4 | 0] = i | 4, i = r[e + 20 >> 2], i && e0[i | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function _4(e, t) {
              e = e | 0, t = +t;
              var i = 0, n = o(0), f = o(0);
              e: {
                if (n = o(t), e = r[e >> 2], f = h[e + 32 >> 2], n == f | n != n & f != f)
                  break e;
                for (h[e + 32 >> 2] = n; ; ) {
                  if (i = z[e + 4 | 0], i & 4)
                    break e;
                  if (P[e + 4 | 0] = i | 4, i = r[e + 20 >> 2], i && e0[i | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function M4(e, t) {
              e = e | 0, t = +t;
              var i = 0, n = o(0), f = o(0);
              e: {
                if (n = o(t), e = r[e >> 2], f = h[e + 36 >> 2], n == f | n != n & f != f)
                  break e;
                for (h[e + 36 >> 2] = n; ; ) {
                  if (i = z[e + 4 | 0], i & 4)
                    break e;
                  if (P[e + 4 | 0] = i | 4, i = r[e + 20 >> 2], i && e0[i | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function L4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              e: {
                if (e = r[e >> 2], i = r[e + 24 >> 2], (i >>> 4 & 7) == (t | 0))
                  break e;
                for (r[e + 24 >> 2] = i & -113 | t << 4 & 112; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function X4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              e: {
                if (e = r[e >> 2], i = r[e + 24 >> 2], (i >>> 2 & 3) == (t | 0))
                  break e;
                for (r[e + 24 >> 2] = i & -13 | t << 2 & 12; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function H4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              e: {
                if (e = r[e >> 2], i = z[e + 4 | 0], ((i & 2) >>> 1 | 0) == (t | 0))
                  break e;
                for (P[e + 4 | 0] = i & 253 | (t ? 2 : 0); ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function z4(e, t, i) {
              e = e | 0, t = t | 0, i = i | 0;
              var n = 0, f = 0;
              return n = U - 16 | 0, U = n, f = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (f = r[f + r[t >> 2] >> 2]), e0[f | 0](n, t, i), e = B(16), t = r[n + 12 >> 2], r[e + 8 >> 2] = r[n + 8 >> 2], r[e + 12 >> 2] = t, t = r[n + 4 >> 2], r[e >> 2] = r[n >> 2], r[e + 4 >> 2] = t, U = n + 16 | 0, e | 0;
            }
            function zi(e, t) {
              var i = 0, n = 0;
              e: {
                i: {
                  if (i = r[e + 556 >> 2], n = r[e + 560 >> 2], (i | 0) == (n | 0))
                    break i;
                  for (; ; ) {
                    if (r[i >> 2] == (t | 0))
                      break i;
                    if (i = i + 4 | 0, (n | 0) == (i | 0))
                      break;
                  }
                  break e;
                }
                if ((i | 0) == (n | 0))
                  break e;
                return t = i + 4 | 0, Oe(i, t, n - t | 0), r[e + 560 >> 2] = n - 4, 1;
              }
              return 0;
            }
            function U4(e) {
              e = e | 0;
              var t = 0, i = 0;
              if (i = U - 16 | 0, U = i, e = r[e >> 2], r[e + 8 >> 2]) {
                for (; t = z[e + 4 | 0], !!(!(t & 4) && (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], e)); )
                  ;
                U = i + 16 | 0;
                return;
              }
              r[i >> 2] = 1024, Y2(e, i), M2(), V0();
            }
            function Ui(e, t) {
              var i = 0, n = 0, f = 0;
              if (N2(+e), n = O0(1) | 0, f = O0(0) | 0, i = n >>> 20 & 2047, (i | 0) != 2047) {
                if (!i)
                  return e == 0 ? i = 0 : (e = Ui(e * 18446744073709552e3, t), i = r[t >> 2] + -64 | 0), r[t >> 2] = i, e;
                r[t >> 2] = i - 1022, j(0, f | 0), j(1, n & -2146435073 | 1071644672), e = +y2();
              }
              return e;
            }
            function Y4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0, n = 0;
              return i = U - 16 | 0, U = i, n = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (n = r[n + r[t >> 2] >> 2]), e0[n | 0](i, t), e = B(16), t = r[i + 12 >> 2], r[e + 8 >> 2] = r[i + 8 >> 2], r[e + 12 >> 2] = t, t = r[i + 4 >> 2], r[e >> 2] = r[i >> 2], r[e + 4 >> 2] = t, U = i + 16 | 0, e | 0;
            }
            function Lt(e, t, i) {
              var n = 0;
              e: {
                if (n = e + 24 | 0, r[(n + (t << 2) | 0) + 184 >> 2] == (i | 0))
                  break e;
                for (r[((t << 2) + n | 0) + 184 >> 2] = i; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function Xt(e, t, i) {
              var n = 0;
              e: {
                if (n = e + 24 | 0, r[(n + (t << 2) | 0) + 192 >> 2] == (i | 0))
                  break e;
                for (r[((t << 2) + n | 0) + 192 >> 2] = i; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function tt(e, t, i) {
              var n = 0;
              e: {
                if (n = e + 24 | 0, r[(n + (t << 2) | 0) + 176 >> 2] == (i | 0))
                  break e;
                for (r[((t << 2) + n | 0) + 176 >> 2] = i; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function Zr(e, t) {
              var i = 0, n = 0, f = 0;
              e: {
                if (i = e + 24 | 0, r[i + 16 >> 2] == (t | 0))
                  break e;
                for (n = e0[9](i) | 0, f = t, r[n + 16 >> 2] = f; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function Yi(e, t, i) {
              var n = 0;
              e: {
                if (n = e + 24 | 0, r[(n + (t << 2) | 0) + 92 >> 2] == (i | 0))
                  break e;
                for (r[((t << 2) + n | 0) + 92 >> 2] = i; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function Gr(e, t, i) {
              var n = 0;
              e: {
                if (n = e + 24 | 0, r[(n + (t << 2) | 0) + 20 >> 2] == (i | 0))
                  break e;
                for (r[((t << 2) + n | 0) + 20 >> 2] = i; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function Di(e, t, i) {
              var n = 0;
              e: {
                if (n = e + 24 | 0, r[(n + (t << 2) | 0) + 56 >> 2] == (i | 0))
                  break e;
                for (r[((t << 2) + n | 0) + 56 >> 2] = i; ; ) {
                  if (t = z[e + 4 | 0], t & 4)
                    break e;
                  if (P[e + 4 | 0] = t | 4, t = r[e + 20 >> 2], t && e0[t | 0](e), r[e + 308 >> 2] = 2143289344, e = r[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function D4() {
              for (var e = 0, t = 0, i = 0; t = e << 4, i = t + 5968 | 0, r[t + 5972 >> 2] = i, r[t + 5976 >> 2] = i, e = e + 1 | 0, (e | 0) != 64; )
                ;
              Wr(48), r[1756] = 16, r[1757] = 0, Wi(), r[1757] = r[1768], r[1768] = 7024, r[1769] = 198, r[1770] = 0, Vi(), r[1770] = r[1768], r[1768] = 7076;
            }
            function D2(e, t) {
              var i = 0, n = o(0);
              e = e + 80 | 0, i = r[(t << 2) + 4288 >> 2];
              e: {
                if ((t & -2) == 2) {
                  e = re(e, 4, i, 2143289344);
                  break e;
                }
                e = ie(e, i, 2143289344);
              }
              return (e | 0) == 2139156720 | (e | 0) == 2140081935 | (e | 0) == 2141891242 ? e = 1 : (n = (j(2, e), f0()), e = n == n), e;
            }
            function Ht(e, t) {
              var i = 0, n = o(0);
              e = e + 80 | 0, i = r[(t << 2) + 4304 >> 2];
              e: {
                if ((t & -2) == 2) {
                  e = re(e, 5, i, 2143289344);
                  break e;
                }
                e = ie(e, i, 2143289344);
              }
              return (e | 0) == 2139156720 | (e | 0) == 2140081935 | (e | 0) == 2141891242 ? e = 1 : (n = (j(2, e), f0()), e = n == n), e;
            }
            function Ir(e, t, i, n) {
              var f = 0, u = 0, a = 0, l = 0, p = 0, E = 0;
              return f = i >>> 16 | 0, u = e >>> 16 | 0, E = $0(f, u), a = i & 65535, l = e & 65535, p = $0(a, l), u = (p >>> 16 | 0) + $0(u, a) | 0, f = (u & 65535) + $0(f, l) | 0, I2 = ($0(t, i) + E | 0) + $0(e, n) + (u >>> 16) + (f >>> 16) | 0, p & 65535 | f << 16;
            }
            function ji(e, t) {
              var i = 0, n = 0, f = 0;
              n = U - 16 | 0, U = n, i = z[e + 4 | 0], f = i & -17, P[e + 4 | 0] = f;
              e: {
                if (t) {
                  if (r[e + 560 >> 2] != r[e + 556 >> 2])
                    break e;
                  i = f | 8;
                } else
                  i = i & 231;
                r[e + 8 >> 2] = t, P[e + 4 | 0] = i, U = n + 16 | 0;
                return;
              }
              r[n >> 2] = 4128, Y2(e, n), M2(), V0();
            }
            function Ji(e) {
              var t = 0, i = o(0);
              t = 0;
              e: {
                if ((r[e + 24 >> 2] & 196608) == 131072)
                  break e;
                i: {
                  if (!r[e + 552 >> 2] || (i = h[e + 32 >> 2], i != i && (i = h[e + 28 >> 2], !(i > o(0)))))
                    break i;
                  if (t = 1, i != o(0))
                    break e;
                }
                t = rt(e) != o(0);
              }
              return t;
            }
            function w2(e, t, i, n, f) {
              var u = 0;
              if (u = U - 256 | 0, U = u, !(f & 73728 | (i | 0) <= (n | 0))) {
                if (n = i - n | 0, i = n >>> 0 < 256, x2(u, t & 255, i ? n : 256), !i)
                  for (; c2(e, u, 256), n = n - 256 | 0, n >>> 0 > 255; )
                    ;
                c2(e, u, n);
              }
              U = u + 256 | 0;
            }
            function Le(e, t, i) {
              var n = 0, f = o(0);
              e: {
                if ((i & -2) == 2 && (n = t - -64 | 0, f = h[n >> 2], n = r[n >> 2], (n | 0) == 2139156720 | (n | 0) == 2140081935 | (n | 0) == 2141891242 | f == f))
                  break e;
                n = r[((r[(i << 2) + 4304 >> 2] << 2) + t | 0) + 44 >> 2];
              }
              Li(e, n);
            }
            function Xe(e, t, i) {
              var n = 0, f = o(0);
              e: {
                if ((i & -2) == 2 && (n = r[t + 60 >> 2], f = h[t + 60 >> 2], (n | 0) == 2139156720 | (n | 0) == 2140081935 | (n | 0) == 2141891242 | f == f))
                  break e;
                n = r[((r[(i << 2) + 4288 >> 2] << 2) + t | 0) + 44 >> 2];
              }
              Li(e, n);
            }
            function rt(e) {
              var t = o(0), i = o(0);
              if (!r[e + 552 >> 2])
                return o(0);
              t = h[e + 36 >> 2];
              e: {
                if (t == t || (t = o(1), P[r[e + 568 >> 2] + 8 | 0] & 1) || (t = o(0), i = h[e + 28 >> 2], !(i < o(0))))
                  break e;
                t = o(-i);
              }
              return t;
            }
            function Qi(e) {
              var t = 0, i = 0, n = 0;
              for (n = r[e >> 2]; ; ) {
                if (i = P[n | 0], Ut(i)) {
                  n = n + 1 | 0, r[e >> 2] = n, t >>> 0 <= 214748364 ? (i = i - 48 | 0, t = $0(t, 10), t = (i | 0) > (t ^ 2147483647) ? -1 : i + t | 0) : t = -1;
                  continue;
                }
                break;
              }
              return t;
            }
            function lt(e, t, i, n) {
              var f = 0;
              r[e + 12 >> 2] = 0, r[e + 16 >> 2] = n;
              e: {
                if (t) {
                  if (t >>> 0 >= 1073741824)
                    break e;
                  f = B(t << 2);
                }
                return r[e >> 2] = f, i = (i << 2) + f | 0, r[e + 8 >> 2] = i, r[e + 12 >> 2] = (t << 2) + f, r[e + 4 >> 2] = i, e;
              }
              Fr(), V0();
            }
            function bi(e) {
              var t = 0;
              return t = r[e + 72 >> 2], r[e + 72 >> 2] = t - 1 | t, t = r[e >> 2], t & 8 ? (r[e >> 2] = t | 32, -1) : (r[e + 4 >> 2] = 0, r[e + 8 >> 2] = 0, t = r[e + 44 >> 2], r[e + 28 >> 2] = t, r[e + 20 >> 2] = t, r[e + 16 >> 2] = t + r[e + 48 >> 2], 0);
            }
            function j4(e, t, i, n, f, u) {
              e = e | 0, t = t | 0, i = o(i), n = n | 0, f = o(f), u = u | 0;
              var a = 0;
              a = U - 16 | 0, U = a, t = r[r[t >> 2] + 4 >> 2], e0[r[r[t >> 2] + 8 >> 2]](a, t, i, n, f, u), h[e >> 2] = b0[a >> 3], h[e + 4 >> 2] = b0[a + 8 >> 3], U = a + 16 | 0;
            }
            function J4() {
              var e = 0, t = 0;
              return t = B(4), e = B(28), r[e + 20 >> 2] = 1065353216, r[e + 24 >> 2] = 0, r[e + 12 >> 2] = 0, r[e + 16 >> 2] = 0, r[e >> 2] = 0, P[e + 8 | 0] = 0, r[e + 4 >> 2] = 1, r[1752] = r[1752] + 1, r[t >> 2] = e, t | 0;
            }
            function Q4(e, t) {
              e = e | 0, t = t | 0, t = r[t >> 2], b0[e >> 3] = h[t + 228 >> 2], b0[e + 8 >> 3] = h[t + 236 >> 2], b0[e + 16 >> 3] = h[t + 232 >> 2], b0[e + 24 >> 3] = h[t + 240 >> 2], b0[e + 32 >> 3] = h[t + 244 >> 2], b0[e + 40 >> 3] = h[t + 248 >> 2];
            }
            function b4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0, n = 0;
              return i = U - 48 | 0, U = i, n = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (n = r[n + r[t >> 2] >> 2]), e0[n | 0](i, t), e = T2(B(48), i, 48), U = i + 48 | 0, e | 0;
            }
            function $4(e, t, i, n) {
              e = e | 0, t = t | 0, i = i | 0, n = n | 0;
              var f = 0;
              return f = U - 16 | 0, U = f, e = ln(D1(r[e + 60 >> 2], t | 0, i | 0, n & 255, f + 8 | 0) | 0), U = f + 16 | 0, I2 = e ? -1 : r[f + 12 >> 2], (e ? -1 : r[f + 8 >> 2]) | 0;
            }
            function K4(e, t) {
              e = e | 0, t = t | 0;
              var i = 0, n = 0;
              i = r[e >> 2], e = r[i + 556 >> 2];
              e: {
                if (r[i + 560 >> 2] - e >> 2 >>> 0 <= t >>> 0 || (e = r[e + (t << 2) >> 2], !e))
                  break e;
                n = r[e >> 2];
              }
              return n | 0;
            }
            function q4(e, t, i) {
              if (e = e | 0, t = t | 0, i = i | 0, t >>> 0 < 3) {
                t = 1 << t, e = r[e >> 2], i ? t = t | r[e + 12 >> 2] : t = r[e + 12 >> 2] & (t ^ -1), r[e + 12 >> 2] = t;
                return;
              }
              We(), V0();
            }
            function eo(e, t, i, n, f) {
              e = e | 0, t = t | 0, i = +i, n = +n, f = f | 0;
              var u = 0;
              u = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (u = r[u + r[t >> 2] >> 2]), e0[u | 0](t, i, n, f);
            }
            function to(e, t, i) {
              e = e | 0, t = t | 0, i = i | 0;
              var n = 0;
              return n = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (n = r[n + r[t >> 2] >> 2]), o(o(e0[n | 0](t, i)));
            }
            function $i(e, t, i, n) {
              e = e | 0, t = t | 0, i = i | 0, n = n | 0;
              var f = 0;
              f = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (f = r[f + r[t >> 2] >> 2]), e0[f | 0](t, i, n);
            }
            function Ki(e, t, i) {
              e = e | 0, t = t | 0, i = i | 0;
              var n = 0;
              return n = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (n = r[n + r[t >> 2] >> 2]), e0[n | 0](t, i) | 0;
            }
            function ro(e, t, i, n) {
              e = e | 0, t = t | 0, i = i | 0, n = +n;
              var f = 0;
              f = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (f = r[f + r[t >> 2] >> 2]), e0[f | 0](t, i, n);
            }
            function io(e, t, i) {
              e = e | 0, t = t | 0, i = i | 0;
              var n = 0;
              return n = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (n = r[n + r[t >> 2] >> 2]), +e0[n | 0](t, i);
            }
            function B(e) {
              var t = 0;
              e = e || 1;
              e: {
                for (; ; ) {
                  if (t = Er(e), t)
                    break e;
                  if (t = r[2042], t) {
                    e0[t | 0]();
                    continue;
                  }
                  break;
                }
                We(), V0();
              }
              return t;
            }
            function no(e, t, i) {
              e = e | 0, t = t | 0, i = o(i);
              var n = 0;
              n = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (n = r[n + r[t >> 2] >> 2]), e0[n | 0](t, i);
            }
            function Ze(e, t, i) {
              e = e | 0, t = t | 0, i = i | 0;
              var n = 0;
              n = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (n = r[n + r[t >> 2] >> 2]), e0[n | 0](t, i);
            }
            function He(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              return i = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (i = r[i + r[t >> 2] >> 2]), e0[i | 0](t) | 0;
            }
            function Tr(e, t) {
              return A2(e), (O0(2) & 2147483647) >>> 0 <= 2139095040 ? (A2(t), (O0(2) & 2147483647) >>> 0 > 2139095040 ? e : o(L1(e, t))) : t;
            }
            function d0(e, t) {
              return A2(e), (O0(2) & 2147483647) >>> 0 <= 2139095040 ? (A2(t), (O0(2) & 2147483647) >>> 0 > 2139095040 ? e : o(X1(e, t))) : t;
            }
            function qi(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              return i = U - 16 | 0, U = i, r[i + 8 >> 2] = t, e = e0[e | 0](i + 8 | 0) | 0, ut(r[i + 8 >> 2]), U = i + 16 | 0, e | 0;
            }
            function oo(e, t, i) {
              e = e | 0, t = t | 0, i = +i;
              var n = 0;
              n = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (n = r[n + r[t >> 2] >> 2]), e0[n | 0](t, i);
            }
            function fo(e, t, i, n, f) {
              return i = i | 0, n = n | 0, f = f | 0, i && (i | 0) != 5 ? An(5816, n, f) | 0 : An(5672, n, f) | 0;
            }
            function en(e, t) {
              if (!e)
                return 0;
              e: {
                if (!((t & -128) == 57216 | t >>> 0 <= 127)) {
                  r[1781] = 25, e = -1;
                  break e;
                }
                P[e | 0] = t, e = 1;
              }
              return e;
            }
            function so(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              return i = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (i = r[i + r[t >> 2] >> 2]), +e0[i | 0](t);
            }
            function tn(e, t) {
              var i = 0, n = 0;
              i = B(4), r[i >> 2] = t, n = B(4), r[n >> 2] = t, Pt(7035, e | 0, 7098, 4714, 196, i | 0, 7098, 4718, 197, n | 0);
            }
            function it(e, t) {
              var i = 0, n = 0;
              i = B(4), r[i >> 2] = t, n = B(4), r[n >> 2] = t, Pt(7065, e | 0, 7098, 4714, 194, i | 0, 7098, 4718, 195, n | 0);
            }
            function xr(e, t) {
              var i = 0;
              e: {
                if (P[7044] & 1) {
                  i = r[1760];
                  break e;
                }
                i = gi(1, 4464) | 0, P[7044] = 1, r[1760] = i;
              }
              Y1(i | 0, e | 0, t | 0, 0);
            }
            function uo(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              i = r[e + 8 >> 2], r[e + 8 >> 2] = t, i && e0[r[r[i >> 2] + 4 >> 2]](i), r[r[e >> 2] + 20 >> 2] = 15;
            }
            function ao(e, t, i) {
              e = e | 0, t = t | 0, i = i | 0;
              var n = 0, f = 0;
              n = e, f = Ei((P[t + 11 | 0] < 0 ? r[t >> 2] : t) | 0, 7036, r[i >> 2]) | 0, r[n >> 2] = f;
            }
            function lo(e, t, i) {
              e = e | 0, t = t | 0, i = i | 0;
              var n = 0, f = 0;
              n = e, f = Ei((P[t + 11 | 0] < 0 ? r[t >> 2] : t) | 0, 7059, r[i >> 2]) | 0, r[n >> 2] = f;
            }
            function rn(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              i = r[e >> 2], e = r[e + 4 >> 2], t = (e >> 1) + t | 0, e & 1 && (i = r[i + r[t >> 2] >> 2]), e0[i | 0](t);
            }
            function co(e) {
              e = e | 0;
              var t = o(0);
              return e = r[e >> 2], t = h[e + 36 >> 2], t != t && (t = P[r[e + 568 >> 2] + 8 | 0] & 1 ? o(1) : o(0)), +t;
            }
            function ko(e, t) {
              e = e | 0, t = t | 0;
              var i = 0;
              i = r[e + 4 >> 2], r[e + 4 >> 2] = t, i && e0[r[r[i >> 2] + 4 >> 2]](i), ji(r[e >> 2], 14);
            }
            function ho(e) {
              e = e | 0;
              var t = 0;
              t = r[e + 8 >> 2], r[e + 8 >> 2] = 0, t && e0[r[r[t >> 2] + 4 >> 2]](t), r[r[e >> 2] + 20 >> 2] = 0;
            }
            function Ao(e) {
              e = e | 0;
              var t = 0;
              return t = B(12), P[t + 4 | 0] = 0, r[t + 8 >> 2] = r[e >> 2], r[e >> 2] = 0, r[t >> 2] = 4432, t | 0;
            }
            function po(e) {
              e = e | 0;
              var t = 0;
              return t = B(12), P[t + 4 | 0] = 0, r[t + 8 >> 2] = r[e >> 2], r[e >> 2] = 0, r[t >> 2] = 4552, t | 0;
            }
            function mo() {
              var e = 0;
              if (e = r[1768], e)
                for (; e0[r[e >> 2]](), e = r[e + 4 >> 2], !!e; )
                  ;
            }
            function wo(e) {
              e = e | 0;
              var t = 0;
              t = r[e + 4 >> 2], r[e + 4 >> 2] = 0, t && e0[r[r[t >> 2] + 4 >> 2]](t), ji(r[e >> 2], 0);
            }
            function nn(e) {
              return e = e | 0, r[e >> 2] = 4572, z[e + 4 | 0] && xr(r[e + 8 >> 2], 1759), ut(r[e + 8 >> 2]), e | 0;
            }
            function on(e) {
              return e = e | 0, r[e >> 2] = 4452, z[e + 4 | 0] && xr(r[e + 8 >> 2], 1759), ut(r[e + 8 >> 2]), e | 0;
            }
            function vo() {
              var e = 0;
              return e = B(16), r[e >> 2] = 0, r[e + 4 >> 2] = 0, r[e + 8 >> 2] = 0, r[e + 12 >> 2] = 0, e | 0;
            }
            function fn(e, t, i) {
              return D2(e, t) ? Se(e, t, i) : (i = at(e, t, i), i == i && (i = o(-i)), i);
            }
            function sn(e, t) {
              var i = 0;
              i = U - 16 | 0, U = i, e || (r[i >> 2] = t, Y2(0, i), M2(), V0()), U = i + 16 | 0;
            }
            function un(e) {
              e = e | 0;
              var t = 0;
              e && (t = r[e >> 2], t && m2(t), r[1752] = r[1752] - 1, m2(e));
            }
            function go(e, t) {
              return e = e | 0, t = t | 0, t >>> 0 >= 3 && (We(), V0()), r[r[e >> 2] + 12 >> 2] >>> t & 1;
            }
            function yo(e, t, i, n, f) {
              return e = e | 0, t = t | 0, i = i | 0, n = n | 0, f = f | 0, e0[e | 0](t, i, n, f) | 0;
            }
            function Ro() {
              var e = 0;
              return e = B(16), r[e + 8 >> 2] = 0, r[e + 12 >> 2] = 0, r[e >> 2] = 0, e | 0;
            }
            function Eo(e) {
              e = e | 0;
              var t = o(0);
              return t = h[r[e >> 2] + 224 >> 2], +(t != t ? o(l0) : t);
            }
            function No(e) {
              return e = e | 0, e = r[r[e >> 2] + 552 >> 2], e ? r[e >> 2] : 0;
            }
            function Wo(e) {
              e = e | 0;
              var t = o(0);
              return t = h[r[e >> 2] + 32 >> 2], +(t == t ? t : o(0));
            }
            function an(e) {
              var t = 0;
              return t = Si(B(588), e), sn((e | 0) != 0, 2808), t;
            }
            function Oo(e, t) {
              e = e | 0, t = t | 0, e = r[e >> 2], r[e + 16 >> 2] = r[e + 16 >> 2] & -2 | t;
            }
            function So(e) {
              return e = e | 0, e = r[e >> 2], r[e + 560 >> 2] - r[e + 556 >> 2] >> 2;
            }
            function Zo(e, t) {
              e = e | 0, t = t | 0, e = r[e >> 2], P[e + 8 | 0] = z[e + 8 | 0] & 254 | t;
            }
            function Go(e) {
              e = e | 0, e = r[r[e >> 2] + 8 >> 2], e0[r[r[e >> 2] + 8 >> 2]](e);
            }
            function Io(e, t, i) {
              e = e | 0, t = t | 0, i = +i, Gr(r[e >> 2], t, Q2(o(i)));
            }
            function To(e, t, i) {
              e = e | 0, t = t | 0, i = +i, Gr(r[e >> 2], t, oe(o(i)));
            }
            function xo(e, t, i, n) {
              return I2 = 0, 0;
            }
            function Co(e, t, i) {
              e = e | 0, t = t | 0, i = +i, Yi(r[e >> 2], t, Q2(o(i)));
            }
            function Vo(e, t, i) {
              e = e | 0, t = t | 0, i = +i, Yi(r[e >> 2], t, oe(o(i)));
            }
            function Bo(e, t, i) {
              e = e | 0, t = t | 0, i = +i, Di(r[e >> 2], t, Q2(o(i)));
            }
            function Fo(e, t, i) {
              e = e | 0, t = t | 0, i = +i, Di(r[e >> 2], t, oe(o(i)));
            }
            function Po(e, t, i) {
              e = e | 0, t = t | 0, i = i | 0, r[r[e >> 2] + t >> 2] = i;
            }
            function _o(e, t) {
              e = e | 0, t = t | 0, Gr(r[e >> 2], t, 2141891242);
            }
            function Cr(e, t, i) {
              e = e | 0, t = t | 0, i = +i, b0[r[e >> 2] + t >> 3] = i;
            }
            function Mo(e) {
              return e = e | 0, (z[r[e >> 2] + 4 | 0] & 2) >>> 1 | 0;
            }
            function Lo(e) {
              return e = e | 0, (z[r[e >> 2] + 4 | 0] & 4) >>> 2 | 0;
            }
            function Xo(e, t) {
              e = e | 0, t = t | 0, r[e + 4 >> 2] = 10, r[e >> 2] = t;
            }
            function Ho(e, t) {
              e = e | 0, t = t | 0, r[e + 4 >> 2] = 13, r[e >> 2] = t;
            }
            function zo(e) {
              return e = e | 0, r[r[e >> 2] + 24 >> 2] >>> 10 & 7;
            }
            function Uo(e) {
              return e = e | 0, r[r[e >> 2] + 24 >> 2] >>> 13 & 7;
            }
            function Vr(e, t) {
              return e = e | 0, t = t | 0, +b0[r[e >> 2] + t >> 3];
            }
            function Yo(e) {
              return e = e | 0, r[r[e >> 2] + 24 >> 2] >>> 18 & 3;
            }
            function Do(e) {
              return e = e | 0, r[r[e >> 2] + 24 >> 2] >>> 20 & 3;
            }
            function jo(e) {
              return e = e | 0, r[r[e >> 2] + 24 >> 2] >>> 22 & 1;
            }
            function Jo(e, t) {
              return e = e | 0, t = t | 0, r[r[e >> 2] + t >> 2];
            }
            function Qo(e, t) {
              e = e | 0, t = +t, tt(r[e >> 2], 0, Q2(o(t)));
            }
            function bo(e, t) {
              e = e | 0, t = +t, tt(r[e >> 2], 0, oe(o(t)));
            }
            function $o(e, t) {
              e = e | 0, t = +t, tt(r[e >> 2], 1, Q2(o(t)));
            }
            function Ko(e, t) {
              e = e | 0, t = +t, tt(r[e >> 2], 1, oe(o(t)));
            }
            function qo(e, t) {
              e = e | 0, t = t | 0, r[e + 4 >> 2] = 7, r[e >> 2] = t;
            }
            function ef(e, t) {
              e = e | 0, t = +t, Lt(r[e >> 2], 0, Q2(o(t)));
            }
            function tf(e, t) {
              e = e | 0, t = +t, Lt(r[e >> 2], 0, oe(o(t)));
            }
            function rf(e, t) {
              e = e | 0, t = +t, Lt(r[e >> 2], 1, Q2(o(t)));
            }
            function nf(e, t) {
              e = e | 0, t = +t, Lt(r[e >> 2], 1, oe(o(t)));
            }
            function of(e, t) {
              e = e | 0, t = +t, Xt(r[e >> 2], 0, Q2(o(t)));
            }
            function ff(e, t) {
              e = e | 0, t = +t, Xt(r[e >> 2], 1, Q2(o(t)));
            }
            function sf(e, t) {
              e = e | 0, t = +t, Xt(r[e >> 2], 1, oe(o(t)));
            }
            function uf(e) {
              return e = e | 0, r[r[e >> 2] + 24 >> 2] >>> 7 & 7;
            }
            function af(e) {
              return e = e | 0, r[r[e >> 2] + 24 >> 2] >>> 2 & 3;
            }
            function lf(e) {
              return e = e | 0, r[r[e >> 2] + 24 >> 2] >>> 4 & 7;
            }
            function zt(e) {
              e = e | 0, e && e0[r[r[e >> 2] + 4 >> 2]](e);
            }
            function cf(e, t) {
              e = e | 0, t = +t, Xt(r[e >> 2], 0, oe(o(t)));
            }
            function ln(e) {
              return e ? (r[1781] = e, -1) : 0;
            }
            function kf(e, t) {
              e = e | 0, t = +t, Zr(r[e >> 2], Q2(o(t)));
            }
            function hf(e, t) {
              e = e | 0, t = +t, Zr(r[e >> 2], oe(o(t)));
            }
            function cn(e, t, i) {
              return o(E0(e, t, i) + B0(e, t, i));
            }
            function Af(e, t) {
              return e = e | 0, t = t | 0, e0[e | 0](t) | 0;
            }
            function kn(e, t, i, n) {
              j1(e | 0, t | 0, 8, 0, i | 0, -1, n | 0);
            }
            function pf(e, t) {
              e = e | 0, t = t | 0, r[r[e >> 2] + 16 >> 2] = t;
            }
            function mf(e) {
              return e = e | 0, r[r[e >> 2] + 16 >> 2] & 1;
            }
            function wf(e) {
              return e = e | 0, $e[r[e >> 2] + 26 >> 1] & 3;
            }
            function vf(e) {
              e = e | 0, tt(r[e >> 2], 0, 2141891242);
            }
            function gf(e) {
              e = e | 0, tt(r[e >> 2], 1, 2141891242);
            }
            function yf(e) {
              return e = e | 0, +h[r[e >> 2] + 228 >> 2];
            }
            function df(e) {
              return e = e | 0, +h[r[e >> 2] + 236 >> 2];
            }
            function Rf(e) {
              return e = e | 0, +h[r[e >> 2] + 232 >> 2];
            }
            function Ef(e) {
              return e = e | 0, +h[r[e >> 2] + 240 >> 2];
            }
            function Nf(e) {
              return e = e | 0, +h[r[e >> 2] + 244 >> 2];
            }
            function Wf(e) {
              return e = e | 0, +h[r[e >> 2] + 248 >> 2];
            }
            function Of(e) {
              return e = e | 0, $1(r[e + 60 >> 2]) | 0;
            }
            function Sf(e) {
              return e = e | 0, r[r[e >> 2] + 16 >> 2];
            }
            function Zf(e) {
              return e = e | 0, P[r[e >> 2] + 8 | 0] & 1;
            }
            function Gf(e, t) {
              e = e | 0, t = t | 0, Sr(r[e >> 2], 5, t);
            }
            function If(e, t) {
              e = e | 0, t = t | 0, Sr(r[e >> 2], 6, t);
            }
            function Tf(e, t) {
              e = e | 0, t = t | 0, Sr(r[e >> 2], 7, t);
            }
            function xf(e) {
              e = e | 0, Zr(r[e >> 2], 2141891242);
            }
            function hn(e, t) {
              e = e | 0, t = t | 0, e0[r[e >> 2]](t);
            }
            function Cf(e) {
              return e = e | 0, Hi(B(12), e) | 0;
            }
            function Vf(e) {
              e = e | 0, xr(r[e + 8 >> 2], 3293);
            }
            function An(e, t, i) {
              return Pi(e, t, i, 2, 3);
            }
            function pn(e) {
              return e = e | 0, e0[e | 0]() | 0;
            }
            function mn(e, t) {
              e = e | 0, t = t | 0, e0[e | 0](t);
            }
            function Bf() {
              return x2(B(48), 0, 48) | 0;
            }
            function M2() {
              e0[r[1490]](), Fr(), V0();
            }
            function Ff() {
              return Hi(B(12), 0) | 0;
            }
            function Br(e) {
              e = e | 0, e && m2(e);
            }
            function Ut(e) {
              return e - 48 >>> 0 < 10;
            }
            function Pf(e) {
              return 7032;
            }
            function _f(e) {
              return 7036;
            }
            function Mf(e) {
              return 7056;
            }
            function Lf(e) {
              return 7059;
            }
            function Xf(e) {
              return 7062;
            }
            function Hf(e) {
              return 7067;
            }
            function $2(e) {
              return e = e | 0, e | 0;
            }
            function wn(e) {
              e = e | 0, P[e + 4 | 0] = 1;
            }
            function zf(e) {
              e = e | 0, m2(nn(e));
            }
            function Uf(e) {
              e = e | 0, m2(on(e));
            }
            function Yf(e) {
              return 0;
            }
            function vn(e) {
              V0();
            }
            function gn() {
              Fr(), V0();
            }
            function Fr() {
              We(), V0();
            }
            O = z, K();
            var e0 = W([null, fo, t4, n4, $2, qo, Xo, Ho, $2, $2, $2, $2, $2, $2, j4, Go, Wi, Pf, zt, Z4, _f, $2, $2, zt, wn, hn, qi, Ao, k4, ao, Mf, zt, rn, Lf, $2, $2, zt, wn, hn, qi, po, lo, Xf, un, pn, J4, mn, un, q4, $i, l4, no, Oo, Ze, pf, Ze, Zo, go, Ki, mf, He, Sf, He, Zf, Bf, Br, vo, Br, Ro, Br, Vr, Cr, Jo, Po, Hf, Ci, pn, Ff, Af, Cf, mn, Ci, s4, rn, i4, Ze, B4, Ze, Bo, ro, Fo, Gf, If, Tf, X4, V4, L4, Io, To, _o, x4, C4, P4, oo, kf, hf, xf, _4, M4, Qo, bo, vf, $o, Ko, gf, ef, tf, rf, nf, of, cf, ff, sf, F4, G4, Co, Vo, I4, wf, He, p4, z4, uf, zo, Uo, af, Yo, lf, m4, O4, Y4, Wo, so, co, v4, g4, y4, d4, R4, w4, Eo, T4, io, Do, jo, A4, S4, to, o4, $i, f4, Ze, So, He, No, He, K4, Ki, Mo, He, H4, Ze, ko, Ze, wo, uo, Ze, ho, U4, Lo, He, r4, eo, yf, df, Rf, Ef, Nf, Wf, Q4, b4, E4, N4, W4, Vr, Cr, Vr, Cr, Vi, on, Uf, c4, vn, gn, nn, zf, Vf, vn, Of, u4, $4, Yf, xo, h4, gn]);
            function yn() {
              return G2.byteLength / 65536 | 0;
            }
            function Df(e) {
              e = e | 0;
              var t = yn() | 0, i = t + e | 0;
              if (t < i && i < 65536) {
                var n = new ArrayBuffer($0(i, 65536)), f = new Int8Array(n);
                f.set(P), P = new Int8Array(n), te = new Int16Array(n), r = new Int32Array(n), z = new Uint8Array(n), $e = new Uint16Array(n), wi = new Uint32Array(n), h = new Float32Array(n), b0 = new Float64Array(n), G2 = n, U2.buffer = G2, O = z;
              }
              return t;
            }
            return { E: D4, F: a4, G: mo, H: Er, I: e0, J: m2, K: yo };
          }
          return Ft(g);
        }(c);
      }
      var q0 = Error, j2 = {};
      k0 = [], typeof j2 != "object" && J0("no native wasm support detected");
      var _0, Y0 = !1;
      function R2(c, k, g) {
        g = k + g;
        for (var W = ""; !(k >= g); ) {
          var O = c[k++];
          if (!O)
            break;
          if (O & 128) {
            var M = c[k++] & 63;
            if ((O & 224) == 192)
              W += String.fromCharCode((O & 31) << 6 | M);
            else {
              var Y = c[k++] & 63;
              O = (O & 240) == 224 ? (O & 15) << 12 | M << 6 | Y : (O & 7) << 18 | M << 12 | Y << 6 | c[k++] & 63, 65536 > O ? W += String.fromCharCode(O) : (O -= 65536, W += String.fromCharCode(55296 | O >> 10, 56320 | O & 1023));
            }
          } else
            W += String.fromCharCode(O);
        }
        return W;
      }
      var f2, N0, h0, R0, S0, I0, C0, o2, A0;
      function w0(c) {
        f2 = c, m.HEAP8 = N0 = new Int8Array(c), m.HEAP16 = R0 = new Int16Array(c), m.HEAP32 = I0 = new Int32Array(c), m.HEAPU8 = h0 = new Uint8Array(c), m.HEAPU16 = S0 = new Uint16Array(c), m.HEAPU32 = C0 = new Uint32Array(c), m.HEAPF32 = o2 = new Float32Array(c), m.HEAPF64 = A0 = new Float64Array(c);
      }
      var p0 = m.INITIAL_MEMORY || 16777216;
      m.wasmMemory ? _0 = m.wasmMemory : _0 = new $(), _0 && (f2 = _0.buffer), p0 = f2.byteLength, w0(f2);
      var n0, k2 = [], x0 = [], D0 = [];
      function g2() {
        var c = m.preRun.shift();
        k2.unshift(c);
      }
      var a2 = 0, h2 = null;
      function J0(c) {
        throw m.onAbort && m.onAbort(c), c = "Aborted(" + c + ")", u0(c), Y0 = !0, c = new q0(c + ". Build with -sASSERTIONS for more info."), X(c), c;
      }
      function V2(c) {
        return c.startsWith("data:application/octet-stream;base64,");
      }
      var B2;
      if (B2 = "<<< WASM_BINARY_FILE >>>", !V2(B2)) {
        var H2 = B2;
        B2 = m.locateFile ? m.locateFile(H2, J) : J + H2;
      }
      function Pe(c) {
        var k = B2;
        try {
          try {
            if (k == B2 && k0)
              new Uint8Array(k0);
            else {
              if (V2(k)) {
                try {
                  var g = P1(k.slice(37)), W = new Uint8Array(g.length);
                  for (k = 0; k < g.length; ++k)
                    W[k] = g.charCodeAt(k);
                  var O = W;
                } catch {
                  throw Error("Converting base64 string to bytes failed.");
                }
                var M = O;
              } else
                M = void 0;
              if (!M)
                throw "sync fetching of the wasm failed: you can preload it to Module['wasmBinary'] manually, or emcc.py will do that for you when generating HTML (but not JS)";
            }
          } catch (K) {
            J0(K);
          }
          var Y = new M0(), V = new o0(c);
        } catch (K) {
          throw c = K.toString(), u0("failed to compile wasm module: " + c), (c.includes("imported Memory") || c.includes("memory import")) && u0("Memory size incompatibility issues may be due to changing INITIAL_MEMORY at runtime to something too large. Use ALLOW_MEMORY_GROWTH to allow any size memory (and also make sure not to set INITIAL_MEMORY at runtime to something smaller than it was at compile time)."), K;
        }
        return [V, Y];
      }
      function ee(c) {
        for (; 0 < c.length; )
          c.shift()(m);
      }
      function ot(c) {
        if (c === void 0)
          return "_unknown";
        c = c.replace(/[^a-zA-Z0-9_]/g, "$");
        var k = c.charCodeAt(0);
        return 48 <= k && 57 >= k ? "_" + c : c;
      }
      function De(c, k) {
        return c = ot(c), function() {
          return k.apply(this, arguments);
        };
      }
      var F2 = [{}, { value: void 0 }, { value: null }, { value: !0 }, { value: !1 }], je = [];
      function _e(c) {
        var k = Error, g = De(c, function(W) {
          this.name = c, this.message = W, W = Error(W).stack, W !== void 0 && (this.stack = this.toString() + `
` + W.replace(/^Error(:[^\n]*)?\n/, ""));
        });
        return g.prototype = Object.create(k.prototype), g.prototype.constructor = g, g.prototype.toString = function() {
          return this.message === void 0 ? this.name : this.name + ": " + this.message;
        }, g;
      }
      var ce = void 0;
      function m0(c) {
        throw new ce(c);
      }
      var j0 = (c) => (c || m0("Cannot use deleted val. handle = " + c), F2[c].value), W0 = (c) => {
        switch (c) {
          case void 0:
            return 1;
          case null:
            return 2;
          case !0:
            return 3;
          case !1:
            return 4;
          default:
            var k = je.length ? je.pop() : F2.length;
            return F2[k] = { fa: 1, value: c }, k;
        }
      }, Z2 = void 0, l2 = void 0;
      function Q0(c) {
        for (var k = ""; h0[c]; )
          k += l2[h0[c++]];
        return k;
      }
      var E2 = [];
      function P2() {
        for (; E2.length; ) {
          var c = E2.pop();
          c.L.Z = !1, c.delete();
        }
      }
      var _2 = void 0, z2 = {};
      function ft(c, k) {
        for (k === void 0 && m0("ptr should not be undefined"); c.P; )
          k = c.aa(k), c = c.P;
        return k;
      }
      var ke = {};
      function Ot(c) {
        c = M1(c);
        var k = Q0(c);
        return Ne(c), k;
      }
      function fi(c, k) {
        var g = ke[c];
        return g === void 0 && m0(k + " has unknown type " + Ot(c)), g;
      }
      function St() {
      }
      var lr = !1;
      function si(c) {
        --c.count.value, c.count.value === 0 && (c.S ? c.T.V(c.S) : c.O.M.V(c.N));
      }
      function ui(c, k, g) {
        return k === g ? c : g.P === void 0 ? null : (c = ui(c, k, g.P), c === null ? null : g.ma(c));
      }
      var ai = {};
      function w1(c, k) {
        return k = ft(c, k), z2[k];
      }
      var li = void 0;
      function Zt(c) {
        throw new li(c);
      }
      function Gt(c, k) {
        return k.O && k.N || Zt("makeClassHandle requires ptr and ptrType"), !!k.T != !!k.S && Zt("Both smartPtrType and smartPtr must be specified"), k.count = { value: 1 }, Je(Object.create(c, { L: { value: k } }));
      }
      function Je(c) {
        return typeof FinalizationRegistry > "u" ? (Je = (k) => k, c) : (lr = new FinalizationRegistry((k) => {
          si(k.L);
        }), Je = (k) => {
          var g = k.L;
          return g.S && lr.register(k, { L: g }, k), k;
        }, St = (k) => {
          lr.unregister(k);
        }, Je(c));
      }
      var It = {};
      function cr(c) {
        for (; c.length; ) {
          var k = c.pop();
          c.pop()(k);
        }
      }
      function st(c) {
        return this.fromWireType(I0[c >> 2]);
      }
      var Qe = {}, Tt = {};
      function Re(c, k, g) {
        function W(V) {
          V = g(V), V.length !== c.length && Zt("Mismatched type converter count");
          for (var K = 0; K < c.length; ++K)
            he(c[K], V[K]);
        }
        c.forEach(function(V) {
          Tt[V] = k;
        });
        var O = Array(k.length), M = [], Y = 0;
        k.forEach((V, K) => {
          ke.hasOwnProperty(V) ? O[K] = ke[V] : (M.push(V), Qe.hasOwnProperty(V) || (Qe[V] = []), Qe[V].push(() => {
            O[K] = ke[V], ++Y, Y === M.length && W(O);
          }));
        }), M.length === 0 && W(O);
      }
      function kr(c) {
        switch (c) {
          case 1:
            return 0;
          case 2:
            return 1;
          case 4:
            return 2;
          case 8:
            return 3;
          default:
            throw new TypeError("Unknown type size: " + c);
        }
      }
      function he(c, k, g = {}) {
        if (!("argPackAdvance" in k))
          throw new TypeError("registerType registeredInstance requires argPackAdvance");
        var W = k.name;
        if (c || m0('type "' + W + '" must have a positive integer typeid pointer'), ke.hasOwnProperty(c)) {
          if (g.ta)
            return;
          m0("Cannot register type '" + W + "' twice");
        }
        ke[c] = k, delete Tt[c], Qe.hasOwnProperty(c) && (k = Qe[c], delete Qe[c], k.forEach((O) => O()));
      }
      function hr(c) {
        m0(c.L.O.M.name + " instance already deleted");
      }
      function Ee() {
      }
      function Ar(c, k, g) {
        if (c[k].R === void 0) {
          var W = c[k];
          c[k] = function() {
            return c[k].R.hasOwnProperty(arguments.length) || m0("Function '" + g + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + c[k].R + ")!"), c[k].R[arguments.length].apply(this, arguments);
          }, c[k].R = [], c[k].R[W.Y] = W;
        }
      }
      function v1(c, k) {
        m.hasOwnProperty(c) ? (m0("Cannot register public name '" + c + "' twice"), Ar(m, c, c), m.hasOwnProperty(void 0) && m0("Cannot register multiple overloads of a function with the same number of arguments (undefined)!"), m[c].R[void 0] = k) : m[c] = k;
      }
      function g1(c, k, g, W, O, M, Y, V) {
        this.name = c, this.constructor = k, this.W = g, this.V = W, this.P = O, this.oa = M, this.aa = Y, this.ma = V, this.ia = [];
      }
      function pr(c, k, g) {
        for (; k !== g; )
          k.aa || m0("Expected null or instance of " + g.name + ", got an instance of " + k.name), c = k.aa(c), k = k.P;
        return c;
      }
      function y1(c, k) {
        return k === null ? (this.da && m0("null is not a valid " + this.name), 0) : (k.L || m0('Cannot pass "' + gr(k) + '" as a ' + this.name), k.L.N || m0("Cannot pass deleted object as a pointer of type " + this.name), pr(k.L.N, k.L.O.M, this.M));
      }
      function d1(c, k) {
        if (k === null) {
          if (this.da && m0("null is not a valid " + this.name), this.ca) {
            var g = this.ea();
            return c !== null && c.push(this.V, g), g;
          }
          return 0;
        }
        if (k.L || m0('Cannot pass "' + gr(k) + '" as a ' + this.name), k.L.N || m0("Cannot pass deleted object as a pointer of type " + this.name), !this.ba && k.L.O.ba && m0("Cannot convert argument of type " + (k.L.T ? k.L.T.name : k.L.O.name) + " to parameter type " + this.name), g = pr(k.L.N, k.L.O.M, this.M), this.ca)
          switch (k.L.S === void 0 && m0("Passing raw pointer to smart pointer is illegal"), this.Aa) {
            case 0:
              k.L.T === this ? g = k.L.S : m0("Cannot convert argument of type " + (k.L.T ? k.L.T.name : k.L.O.name) + " to parameter type " + this.name);
              break;
            case 1:
              g = k.L.S;
              break;
            case 2:
              if (k.L.T === this)
                g = k.L.S;
              else {
                var W = k.clone();
                g = this.wa(g, W0(function() {
                  W.delete();
                })), c !== null && c.push(this.V, g);
              }
              break;
            default:
              m0("Unsupporting sharing policy");
          }
        return g;
      }
      function R1(c, k) {
        return k === null ? (this.da && m0("null is not a valid " + this.name), 0) : (k.L || m0('Cannot pass "' + gr(k) + '" as a ' + this.name), k.L.N || m0("Cannot pass deleted object as a pointer of type " + this.name), k.L.O.ba && m0("Cannot convert argument of type " + k.L.O.name + " to parameter type " + this.name), pr(k.L.N, k.L.O.M, this.M));
      }
      function Ae(c, k, g, W) {
        this.name = c, this.M = k, this.da = g, this.ba = W, this.ca = !1, this.V = this.wa = this.ea = this.ja = this.Aa = this.va = void 0, k.P !== void 0 ? this.toWireType = d1 : (this.toWireType = W ? y1 : R1, this.U = null);
      }
      function E1(c, k) {
        m.hasOwnProperty(c) || Zt("Replacing nonexistant public symbol"), m[c] = k, m[c].Y = void 0;
      }
      function N1(c, k) {
        var g = [];
        return function() {
          if (g.length = 0, Object.assign(g, arguments), c.includes("j")) {
            var W = m["dynCall_" + c];
            W = g && g.length ? W.apply(null, [k].concat(g)) : W.call(null, k);
          } else
            W = n0.get(k).apply(null, g);
          return W;
        };
      }
      function b2(c, k) {
        c = Q0(c);
        var g = c.includes("j") ? N1(c, k) : n0.get(k);
        return typeof g != "function" && m0("unknown function pointer with signature " + c + ": " + k), g;
      }
      var ci = void 0;
      function xt(c, k) {
        function g(M) {
          O[M] || ke[M] || (Tt[M] ? Tt[M].forEach(g) : (W.push(M), O[M] = !0));
        }
        var W = [], O = {};
        throw k.forEach(g), new ci(c + ": " + W.map(Ot).join([", "]));
      }
      function mr(c, k, g, W, O) {
        var M = k.length;
        2 > M && m0("argTypes array size mismatch! Must at least get return value and 'this' types!");
        var Y = k[1] !== null && g !== null, V = !1;
        for (g = 1; g < k.length; ++g)
          if (k[g] !== null && k[g].U === void 0) {
            V = !0;
            break;
          }
        var K = k[0].name !== "void", b = M - 2, i0 = Array(b), a0 = [], T0 = [];
        return function() {
          if (arguments.length !== b && m0("function " + c + " called with " + arguments.length + " arguments, expected " + b + " args!"), T0.length = 0, a0.length = Y ? 2 : 1, a0[0] = O, Y) {
            var O0 = k[1].toWireType(T0, this);
            a0[1] = O0;
          }
          for (var j = 0; j < b; ++j)
            i0[j] = k[j + 2].toWireType(T0, arguments[j]), a0.push(i0[j]);
          if (j = W.apply(null, a0), V)
            cr(T0);
          else
            for (var y2 = Y ? 1 : 2; y2 < k.length; y2++) {
              var N2 = y2 === 1 ? O0 : i0[y2 - 2];
              k[y2].U !== null && k[y2].U(N2);
            }
          return O0 = K ? k[0].fromWireType(j) : void 0, O0;
        };
      }
      function wr(c, k) {
        for (var g = [], W = 0; W < c; W++)
          g.push(C0[k + 4 * W >> 2]);
        return g;
      }
      function vr(c) {
        4 < c && --F2[c].fa === 0 && (F2[c] = void 0, je.push(c));
      }
      function gr(c) {
        if (c === null)
          return "null";
        var k = typeof c;
        return k === "object" || k === "array" || k === "function" ? c.toString() : "" + c;
      }
      function W1(c, k) {
        switch (k) {
          case 2:
            return function(g) {
              return this.fromWireType(o2[g >> 2]);
            };
          case 3:
            return function(g) {
              return this.fromWireType(A0[g >> 3]);
            };
          default:
            throw new TypeError("Unknown float type: " + c);
        }
      }
      function O1(c, k, g) {
        switch (k) {
          case 0:
            return g ? function(W) {
              return N0[W];
            } : function(W) {
              return h0[W];
            };
          case 1:
            return g ? function(W) {
              return R0[W >> 1];
            } : function(W) {
              return S0[W >> 1];
            };
          case 2:
            return g ? function(W) {
              return I0[W >> 2];
            } : function(W) {
              return C0[W >> 2];
            };
          default:
            throw new TypeError("Unknown integer type: " + c);
        }
      }
      function S1(c, k) {
        for (var g = "", W = 0; !(W >= k / 2); ++W) {
          var O = R0[c + 2 * W >> 1];
          if (O == 0)
            break;
          g += String.fromCharCode(O);
        }
        return g;
      }
      function Z1(c, k, g) {
        if (g === void 0 && (g = 2147483647), 2 > g)
          return 0;
        g -= 2;
        var W = k;
        g = g < 2 * c.length ? g / 2 : c.length;
        for (var O = 0; O < g; ++O)
          R0[k >> 1] = c.charCodeAt(O), k += 2;
        return R0[k >> 1] = 0, k - W;
      }
      function G1(c) {
        return 2 * c.length;
      }
      function I1(c, k) {
        for (var g = 0, W = ""; !(g >= k / 4); ) {
          var O = I0[c + 4 * g >> 2];
          if (O == 0)
            break;
          ++g, 65536 <= O ? (O -= 65536, W += String.fromCharCode(55296 | O >> 10, 56320 | O & 1023)) : W += String.fromCharCode(O);
        }
        return W;
      }
      function T1(c, k, g) {
        if (g === void 0 && (g = 2147483647), 4 > g)
          return 0;
        var W = k;
        g = W + g - 4;
        for (var O = 0; O < c.length; ++O) {
          var M = c.charCodeAt(O);
          if (55296 <= M && 57343 >= M) {
            var Y = c.charCodeAt(++O);
            M = 65536 + ((M & 1023) << 10) | Y & 1023;
          }
          if (I0[k >> 2] = M, k += 4, k + 4 > g)
            break;
        }
        return I0[k >> 2] = 0, k - W;
      }
      function x1(c) {
        for (var k = 0, g = 0; g < c.length; ++g) {
          var W = c.charCodeAt(g);
          55296 <= W && 57343 >= W && ++g, k += 4;
        }
        return k;
      }
      var C1 = {};
      function ki(c) {
        var k = C1[c];
        return k === void 0 ? Q0(c) : k;
      }
      var Ct = [];
      function V1(c) {
        var k = Ct.length;
        return Ct.push(c), k;
      }
      function B1(c, k) {
        for (var g = Array(c), W = 0; W < c; ++W)
          g[W] = fi(C0[k + 4 * W >> 2], "parameter " + W);
        return g;
      }
      var hi = [], F1 = [null, [], []];
      ce = m.BindingError = _e("BindingError"), m.count_emval_handles = function() {
        for (var c = 0, k = 5; k < F2.length; ++k)
          F2[k] !== void 0 && ++c;
        return c;
      }, m.get_first_emval = function() {
        for (var c = 5; c < F2.length; ++c)
          if (F2[c] !== void 0)
            return F2[c];
        return null;
      }, Z2 = m.PureVirtualError = _e("PureVirtualError");
      for (var Ai = Array(256), Vt = 0; 256 > Vt; ++Vt)
        Ai[Vt] = String.fromCharCode(Vt);
      l2 = Ai, m.getInheritedInstanceCount = function() {
        return Object.keys(z2).length;
      }, m.getLiveInheritedInstances = function() {
        var c = [], k;
        for (k in z2)
          z2.hasOwnProperty(k) && c.push(z2[k]);
        return c;
      }, m.flushPendingDeletes = P2, m.setDelayFunction = function(c) {
        _2 = c, E2.length && _2 && _2(P2);
      }, li = m.InternalError = _e("InternalError"), Ee.prototype.isAliasOf = function(c) {
        if (!(this instanceof Ee && c instanceof Ee))
          return !1;
        var k = this.L.O.M, g = this.L.N, W = c.L.O.M;
        for (c = c.L.N; k.P; )
          g = k.aa(g), k = k.P;
        for (; W.P; )
          c = W.aa(c), W = W.P;
        return k === W && g === c;
      }, Ee.prototype.clone = function() {
        if (this.L.N || hr(this), this.L.$)
          return this.L.count.value += 1, this;
        var c = Je, k = Object, g = k.create, W = Object.getPrototypeOf(this), O = this.L;
        return c = c(g.call(k, W, { L: { value: { count: O.count, Z: O.Z, $: O.$, N: O.N, O: O.O, S: O.S, T: O.T } } })), c.L.count.value += 1, c.L.Z = !1, c;
      }, Ee.prototype.delete = function() {
        this.L.N || hr(this), this.L.Z && !this.L.$ && m0("Object already scheduled for deletion"), St(this), si(this.L), this.L.$ || (this.L.S = void 0, this.L.N = void 0);
      }, Ee.prototype.isDeleted = function() {
        return !this.L.N;
      }, Ee.prototype.deleteLater = function() {
        return this.L.N || hr(this), this.L.Z && !this.L.$ && m0("Object already scheduled for deletion"), E2.push(this), E2.length === 1 && _2 && _2(P2), this.L.Z = !0, this;
      }, Ae.prototype.pa = function(c) {
        return this.ja && (c = this.ja(c)), c;
      }, Ae.prototype.ga = function(c) {
        this.V && this.V(c);
      }, Ae.prototype.argPackAdvance = 8, Ae.prototype.readValueFromPointer = st, Ae.prototype.deleteObject = function(c) {
        c !== null && c.delete();
      }, Ae.prototype.fromWireType = function(c) {
        function k() {
          return this.ca ? Gt(this.M.W, { O: this.va, N: g, T: this, S: c }) : Gt(this.M.W, { O: this, N: c });
        }
        var g = this.pa(c);
        if (!g)
          return this.ga(c), null;
        var W = w1(this.M, g);
        if (W !== void 0)
          return W.L.count.value === 0 ? (W.L.N = g, W.L.S = c, W.clone()) : (W = W.clone(), this.ga(c), W);
        if (W = this.M.oa(g), W = ai[W], !W)
          return k.call(this);
        W = this.ba ? W.ka : W.pointerType;
        var O = ui(g, this.M, W.M);
        return O === null ? k.call(this) : this.ca ? Gt(W.M.W, { O: W, N: O, T: this, S: c }) : Gt(W.M.W, { O: W, N: O });
      }, ci = m.UnboundTypeError = _e("UnboundTypeError");
      var P1 = typeof atob == "function" ? atob : function(c) {
        var k = "", g = 0;
        c = c.replace(/[^A-Za-z0-9\+\/=]/g, "");
        do {
          var W = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(c.charAt(g++)), O = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(c.charAt(g++)), M = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(c.charAt(g++)), Y = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(c.charAt(g++));
          W = W << 2 | O >> 4, O = (O & 15) << 4 | M >> 2;
          var V = (M & 3) << 6 | Y;
          k += String.fromCharCode(W), M !== 64 && (k += String.fromCharCode(O)), Y !== 64 && (k += String.fromCharCode(V));
        } while (g < c.length);
        return k;
      }, _1 = {
        q: function(c, k, g) {
          c = Q0(c), k = fi(k, "wrapper"), g = j0(g);
          var W = [].slice, O = k.M, M = O.W, Y = O.P.W, V = O.P.constructor;
          c = De(c, function() {
            O.P.ia.forEach(function(b) {
              if (this[b] === Y[b])
                throw new Z2("Pure virtual function " + b + " must be implemented in JavaScript");
            }.bind(this)), Object.defineProperty(this, "__parent", { value: M }), this.__construct.apply(this, W.call(arguments));
          }), M.__construct = function() {
            this === M && m0("Pass correct 'this' to __construct");
            var b = V.implement.apply(void 0, [this].concat(W.call(arguments)));
            St(b);
            var i0 = b.L;
            b.notifyOnDestruction(), i0.$ = !0, Object.defineProperties(this, { L: { value: i0 } }), Je(this), b = i0.N, b = ft(O, b), z2.hasOwnProperty(b) ? m0("Tried to register registered instance: " + b) : z2[b] = this;
          }, M.__destruct = function() {
            this === M && m0("Pass correct 'this' to __destruct"), St(this);
            var b = this.L.N;
            b = ft(O, b), z2.hasOwnProperty(b) ? delete z2[b] : m0("Tried to unregister unregistered instance: " + b);
          }, c.prototype = Object.create(M);
          for (var K in g)
            c.prototype[K] = g[K];
          return W0(c);
        },
        k: function(c) {
          var k = It[c];
          delete It[c];
          var g = k.ea, W = k.V, O = k.ha, M = O.map((Y) => Y.sa).concat(O.map((Y) => Y.ya));
          Re([c], M, (Y) => {
            var V = {};
            return O.forEach((K, b) => {
              var i0 = Y[b], a0 = K.qa, T0 = K.ra, O0 = Y[b + O.length], j = K.xa, y2 = K.za;
              V[K.na] = { read: (N2) => i0.fromWireType(a0(T0, N2)), write: (N2, V0) => {
                var A2 = [];
                j(y2, N2, O0.toWireType(A2, V0)), cr(A2);
              } };
            }), [{ name: k.name, fromWireType: function(K) {
              var b = {}, i0;
              for (i0 in V)
                b[i0] = V[i0].read(K);
              return W(K), b;
            }, toWireType: function(K, b) {
              for (var i0 in V)
                if (!(i0 in b))
                  throw new TypeError('Missing field:  "' + i0 + '"');
              var a0 = g();
              for (i0 in V)
                V[i0].write(a0, b[i0]);
              return K !== null && K.push(W, a0), a0;
            }, argPackAdvance: 8, readValueFromPointer: st, U: W }];
          });
        },
        w: function() {
        },
        C: function(c, k, g, W, O) {
          var M = kr(g);
          k = Q0(k), he(c, { name: k, fromWireType: function(Y) {
            return !!Y;
          }, toWireType: function(Y, V) {
            return V ? W : O;
          }, argPackAdvance: 8, readValueFromPointer: function(Y) {
            if (g === 1)
              var V = N0;
            else if (g === 2)
              V = R0;
            else if (g === 4)
              V = I0;
            else
              throw new TypeError("Unknown boolean type size: " + k);
            return this.fromWireType(V[Y >> M]);
          }, U: null });
        },
        g: function(c, k, g, W, O, M, Y, V, K, b, i0, a0, T0) {
          i0 = Q0(i0), M = b2(O, M), V && (V = b2(Y, V)), b && (b = b2(K, b)), T0 = b2(a0, T0);
          var O0 = ot(i0);
          v1(O0, function() {
            xt("Cannot construct " + i0 + " due to unbound types", [W]);
          }), Re([c, k, g], W ? [W] : [], function(j) {
            if (j = j[0], W)
              var y2 = j.M, N2 = y2.W;
            else
              N2 = Ee.prototype;
            j = De(O0, function() {
              if (Object.getPrototypeOf(this) !== V0)
                throw new ce("Use 'new' to construct " + i0);
              if (A2.X === void 0)
                throw new ce(i0 + " has no accessible constructor");
              var Ft = A2.X[arguments.length];
              if (Ft === void 0)
                throw new ce("Tried to invoke ctor of " + i0 + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(A2.X).toString() + ") parameters instead!");
              return Ft.apply(this, arguments);
            });
            var V0 = Object.create(N2, { constructor: { value: j } });
            j.prototype = V0;
            var A2 = new g1(i0, j, V0, T0, y2, M, V, b);
            y2 = new Ae(i0, A2, !0, !1), N2 = new Ae(i0 + "*", A2, !1, !1);
            var f0 = new Ae(i0 + " const*", A2, !1, !0);
            return ai[c] = { pointerType: N2, ka: f0 }, E1(O0, j), [y2, N2, f0];
          });
        },
        d: function(c, k, g, W, O, M, Y) {
          var V = wr(g, W);
          k = Q0(k), M = b2(O, M), Re([], [c], function(K) {
            function b() {
              xt("Cannot call " + i0 + " due to unbound types", V);
            }
            K = K[0];
            var i0 = K.name + "." + k;
            k.startsWith("@@") && (k = Symbol[k.substring(2)]);
            var a0 = K.M.constructor;
            return a0[k] === void 0 ? (b.Y = g - 1, a0[k] = b) : (Ar(a0, k, i0), a0[k].R[g - 1] = b), Re([], V, function(T0) {
              return T0 = mr(i0, [T0[0], null].concat(T0.slice(1)), null, M, Y), a0[k].R === void 0 ? (T0.Y = g - 1, a0[k] = T0) : a0[k].R[g - 1] = T0, [];
            }), [];
          });
        },
        p: function(c, k, g, W, O, M) {
          0 < k || J0();
          var Y = wr(k, g);
          O = b2(W, O), Re([], [c], function(V) {
            V = V[0];
            var K = "constructor " + V.name;
            if (V.M.X === void 0 && (V.M.X = []), V.M.X[k - 1] !== void 0)
              throw new ce("Cannot register multiple constructors with identical number of parameters (" + (k - 1) + ") for class '" + V.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
            return V.M.X[k - 1] = () => {
              xt("Cannot construct " + V.name + " due to unbound types", Y);
            }, Re([], Y, function(b) {
              return b.splice(1, 0, null), V.M.X[k - 1] = mr(K, b, null, O, M), [];
            }), [];
          });
        },
        b: function(c, k, g, W, O, M, Y, V) {
          var K = wr(g, W);
          k = Q0(k), M = b2(O, M), Re([], [c], function(b) {
            function i0() {
              xt("Cannot call " + a0 + " due to unbound types", K);
            }
            b = b[0];
            var a0 = b.name + "." + k;
            k.startsWith("@@") && (k = Symbol[k.substring(2)]), V && b.M.ia.push(k);
            var T0 = b.M.W, O0 = T0[k];
            return O0 === void 0 || O0.R === void 0 && O0.className !== b.name && O0.Y === g - 2 ? (i0.Y = g - 2, i0.className = b.name, T0[k] = i0) : (Ar(T0, k, a0), T0[k].R[g - 2] = i0), Re([], K, function(j) {
              return j = mr(a0, j, b, M, Y), T0[k].R === void 0 ? (j.Y = g - 2, T0[k] = j) : T0[k].R[g - 2] = j, [];
            }), [];
          });
        },
        B: function(c, k) {
          k = Q0(k), he(c, { name: k, fromWireType: function(g) {
            var W = j0(g);
            return vr(g), W;
          }, toWireType: function(g, W) {
            return W0(W);
          }, argPackAdvance: 8, readValueFromPointer: st, U: null });
        },
        n: function(c, k, g) {
          g = kr(g), k = Q0(k), he(c, {
            name: k,
            fromWireType: function(W) {
              return W;
            },
            toWireType: function(W, O) {
              return O;
            },
            argPackAdvance: 8,
            readValueFromPointer: W1(k, g),
            U: null
          });
        },
        e: function(c, k, g, W, O) {
          k = Q0(k), O === -1 && (O = 4294967295), O = kr(g);
          var M = (V) => V;
          if (W === 0) {
            var Y = 32 - 8 * g;
            M = (V) => V << Y >>> Y;
          }
          g = k.includes("unsigned") ? function(V, K) {
            return K >>> 0;
          } : function(V, K) {
            return K;
          }, he(c, { name: k, fromWireType: M, toWireType: g, argPackAdvance: 8, readValueFromPointer: O1(k, O, W !== 0), U: null });
        },
        c: function(c, k, g) {
          function W(M) {
            M >>= 2;
            var Y = C0;
            return new O(f2, Y[M + 1], Y[M]);
          }
          var O = [
            Int8Array,
            Uint8Array,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
          ][k];
          g = Q0(g), he(c, { name: g, fromWireType: W, argPackAdvance: 8, readValueFromPointer: W }, { ta: !0 });
        },
        o: function(c, k) {
          k = Q0(k);
          var g = k === "std::string";
          he(c, { name: k, fromWireType: function(W) {
            var O = C0[W >> 2], M = W + 4;
            if (g)
              for (var Y = M, V = 0; V <= O; ++V) {
                var K = M + V;
                if (V == O || h0[K] == 0) {
                  if (Y = Y ? R2(h0, Y, K - Y) : "", b === void 0)
                    var b = Y;
                  else
                    b += String.fromCharCode(0), b += Y;
                  Y = K + 1;
                }
              }
            else {
              for (b = Array(O), V = 0; V < O; ++V)
                b[V] = String.fromCharCode(h0[M + V]);
              b = b.join("");
            }
            return Ne(W), b;
          }, toWireType: function(W, O) {
            O instanceof ArrayBuffer && (O = new Uint8Array(O));
            var M, Y = typeof O == "string";
            if (Y || O instanceof Uint8Array || O instanceof Uint8ClampedArray || O instanceof Int8Array || m0("Cannot pass non-string to std::string"), g && Y) {
              var V = 0;
              for (M = 0; M < O.length; ++M) {
                var K = O.charCodeAt(M);
                127 >= K ? V++ : 2047 >= K ? V += 2 : 55296 <= K && 57343 >= K ? (V += 4, ++M) : V += 3;
              }
              M = V;
            } else
              M = O.length;
            if (V = pi(4 + M + 1), K = V + 4, C0[V >> 2] = M, g && Y) {
              if (Y = K, K = M + 1, M = h0, 0 < K) {
                K = Y + K - 1;
                for (var b = 0; b < O.length; ++b) {
                  var i0 = O.charCodeAt(b);
                  if (55296 <= i0 && 57343 >= i0) {
                    var a0 = O.charCodeAt(++b);
                    i0 = 65536 + ((i0 & 1023) << 10) | a0 & 1023;
                  }
                  if (127 >= i0) {
                    if (Y >= K)
                      break;
                    M[Y++] = i0;
                  } else {
                    if (2047 >= i0) {
                      if (Y + 1 >= K)
                        break;
                      M[Y++] = 192 | i0 >> 6;
                    } else {
                      if (65535 >= i0) {
                        if (Y + 2 >= K)
                          break;
                        M[Y++] = 224 | i0 >> 12;
                      } else {
                        if (Y + 3 >= K)
                          break;
                        M[Y++] = 240 | i0 >> 18, M[Y++] = 128 | i0 >> 12 & 63;
                      }
                      M[Y++] = 128 | i0 >> 6 & 63;
                    }
                    M[Y++] = 128 | i0 & 63;
                  }
                }
                M[Y] = 0;
              }
            } else if (Y)
              for (Y = 0; Y < M; ++Y)
                b = O.charCodeAt(Y), 255 < b && (Ne(K), m0("String has UTF-16 code units that do not fit in 8 bits")), h0[K + Y] = b;
            else
              for (Y = 0; Y < M; ++Y)
                h0[K + Y] = O[Y];
            return W !== null && W.push(Ne, V), V;
          }, argPackAdvance: 8, readValueFromPointer: st, U: function(W) {
            Ne(W);
          } });
        },
        j: function(c, k, g) {
          if (g = Q0(g), k === 2)
            var W = S1, O = Z1, M = G1, Y = () => S0, V = 1;
          else
            k === 4 && (W = I1, O = T1, M = x1, Y = () => C0, V = 2);
          he(c, {
            name: g,
            fromWireType: function(K) {
              for (var b = C0[K >> 2], i0 = Y(), a0, T0 = K + 4, O0 = 0; O0 <= b; ++O0) {
                var j = K + 4 + O0 * k;
                (O0 == b || i0[j >> V] == 0) && (T0 = W(T0, j - T0), a0 === void 0 ? a0 = T0 : (a0 += String.fromCharCode(0), a0 += T0), T0 = j + k);
              }
              return Ne(K), a0;
            },
            toWireType: function(K, b) {
              typeof b != "string" && m0("Cannot pass non-string to C++ string type " + g);
              var i0 = M(b), a0 = pi(4 + i0 + k);
              return C0[a0 >> 2] = i0 >> V, O(b, a0 + 4, i0 + k), K !== null && K.push(Ne, a0), a0;
            },
            argPackAdvance: 8,
            readValueFromPointer: st,
            U: function(K) {
              Ne(K);
            }
          });
        },
        l: function(c, k, g, W, O, M) {
          It[c] = { name: Q0(k), ea: b2(g, W), V: b2(O, M), ha: [] };
        },
        i: function(c, k, g, W, O, M, Y, V, K, b) {
          It[c].ha.push({ na: Q0(k), sa: g, qa: b2(W, O), ra: M, ya: Y, xa: b2(V, K), za: b });
        },
        D: function(c, k) {
          k = Q0(k), he(c, { ua: !0, name: k, argPackAdvance: 0, fromWireType: function() {
          }, toWireType: function() {
          } });
        },
        t: function(c, k, g, W, O) {
          c = Ct[c], k = j0(k), g = ki(g);
          var M = [];
          return C0[W >> 2] = W0(M), c(k, g, M, O);
        },
        u: function(c, k, g, W) {
          c = Ct[c], k = j0(k), g = ki(g), c(k, g, null, W);
        },
        h: vr,
        m: function(c, k) {
          var g = B1(
            c,
            k
          ), W = g[0];
          k = W.name + "_$" + g.slice(1).map(function(Y) {
            return Y.name;
          }).join("_") + "$";
          var O = hi[k];
          if (O !== void 0)
            return O;
          var M = Array(c - 1);
          return O = V1((Y, V, K, b) => {
            for (var i0 = 0, a0 = 0; a0 < c - 1; ++a0)
              M[a0] = g[a0 + 1].readValueFromPointer(b + i0), i0 += g[a0 + 1].argPackAdvance;
            for (Y = Y[V].apply(Y, M), a0 = 0; a0 < c - 1; ++a0)
              g[a0 + 1].la && g[a0 + 1].la(M[a0]);
            if (!W.ua)
              return W.toWireType(K, Y);
          }), hi[k] = O;
        },
        r: function(c) {
          4 < c && (F2[c].fa += 1);
        },
        s: function(c) {
          var k = j0(c);
          cr(k), vr(c);
        },
        f: function() {
          J0("");
        },
        y: function(c, k, g) {
          h0.copyWithin(c, k, k + g);
        },
        x: function(c) {
          var k = h0.length;
          if (c >>>= 0, 2147483648 < c)
            return !1;
          for (var g = 1; 4 >= g; g *= 2) {
            var W = k * (1 + 0.2 / g);
            W = Math.min(W, c + 100663296);
            var O = Math;
            W = Math.max(c, W), O = O.min.call(O, 2147483648, W + (65536 - W % 65536) % 65536);
            e: {
              try {
                _0.grow(O - f2.byteLength + 65535 >>> 16), w0(_0.buffer);
                var M = 1;
                break e;
              } catch {
              }
              M = void 0;
            }
            if (M)
              return !0;
          }
          return !1;
        },
        A: function() {
          return 52;
        },
        v: function() {
          return 70;
        },
        z: function(c, k, g, W) {
          for (var O = 0, M = 0; M < g; M++) {
            var Y = C0[k >> 2], V = C0[k + 4 >> 2];
            k += 8;
            for (var K = 0; K < V; K++) {
              var b = h0[Y + K], i0 = F1[c];
              b === 0 || b === 10 ? ((c === 1 ? q : u0)(R2(i0, 0)), i0.length = 0) : i0.push(b);
            }
            O += V;
          }
          return C0[W >> 2] = O, 0;
        },
        a: _0
      }, be = function() {
        function c(g) {
          m.asm = g.exports, n0 = m.asm.I, x0.unshift(m.asm.E), a2--, m.monitorRunDependencies && m.monitorRunDependencies(a2), a2 == 0 && h2 && (g = h2, h2 = null, g());
        }
        var k = { a: _1 };
        if (a2++, m.monitorRunDependencies && m.monitorRunDependencies(a2), m.instantiateWasm)
          try {
            return m.instantiateWasm(k, c);
          } catch (g) {
            u0("Module.instantiateWasm callback failed with error: " + g), X(g);
          }
        return k = Pe(k), c(k[0]), m.asm;
      }();
      m.___wasm_call_ctors = be.E;
      var M1 = m.___getTypeName = be.F;
      m.__embind_initialize_bindings = be.G;
      var pi = m._malloc = be.H, Ne = m._free = be.J;
      m.dynCall_jiji = be.K;
      var Bt;
      h2 = function c() {
        Bt || mi(), Bt || (h2 = c);
      };
      function mi() {
        function c() {
          if (!Bt && (Bt = !0, m.calledRun = !0, !Y0)) {
            if (ee(x0), G(m), m.onRuntimeInitialized && m.onRuntimeInitialized(), m.postRun)
              for (typeof m.postRun == "function" && (m.postRun = [m.postRun]); m.postRun.length; ) {
                var k = m.postRun.shift();
                D0.unshift(k);
              }
            ee(D0);
          }
        }
        if (!(0 < a2)) {
          if (m.preRun)
            for (typeof m.preRun == "function" && (m.preRun = [m.preRun]); m.preRun.length; )
              g2();
          ee(k2), 0 < a2 || (m.setStatus ? (m.setStatus("Running..."), setTimeout(function() {
            setTimeout(function() {
              m.setStatus("");
            }, 1), c();
          }, 1)) : c());
        }
      }
      if (m.preInit)
        for (typeof m.preInit == "function" && (m.preInit = [m.preInit]); 0 < m.preInit.length; )
          m.preInit.pop()();
      return mi(), d;
    };
  })();
  s.exports = w;
})(Hn);
var ms = Hn.exports;
(function(s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  });
  var A = {};
  s.default = void 0;
  var w = d(ei), y = g0;
  Object.keys(y).forEach(function(L) {
    L === "default" || L === "__esModule" || Object.prototype.hasOwnProperty.call(A, L) || L in s && s[L] === y[L] || Object.defineProperty(s, L, {
      enumerable: !0,
      get: function() {
        return y[L];
      }
    });
  });
  function d(L) {
    return L && L.__esModule ? L : { default: L };
  }
  const m = ms;
  var X = (0, w.default)(m());
  s.default = X;
})(P0);
const zn = /* @__PURE__ */ cs(P0);
function ws(s, A) {
  return typeof s == "number" ? {
    top: s * A,
    right: s * A,
    bottom: s * A,
    left: s * A
  } : {
    top: typeof s.top == "number" ? s.top * A : s.top,
    right: typeof s.right == "number" ? s.right * A : s.right,
    bottom: typeof s.bottom == "number" ? s.bottom * A : s.bottom,
    left: typeof s.left == "number" ? s.left * A : s.left
  };
}
function xn(s, A) {
  return typeof s == "number" ? {
    top: s * A,
    right: s * A,
    bottom: s * A,
    left: s * A
  } : {
    top: (typeof s.top == "number" ? s.top * A : s.top) ?? 0,
    right: (typeof s.right == "number" ? s.right * A : s.right) ?? 0,
    bottom: (typeof s.bottom == "number" ? s.bottom * A : s.bottom) ?? 0,
    left: (typeof s.left == "number" ? s.left * A : s.left) ?? 0
  };
}
function Un(s, { layout: A, scale: w = 1 }) {
  const {
    position: y = "static",
    inset: d,
    width: m,
    height: G,
    minWidth: X,
    minHeight: L,
    maxWidth: J,
    maxHeight: q,
    flex: u0,
    gap: k0,
    margin: $,
    padding: M0,
    // Not technically CSS defaults but I prefer column as default
    direction: o0 = "column",
    align: q0 = "start",
    alignSelf: j2,
    justify: _0 = "start"
  } = A, Y0 = {
    static: P0.PositionType.Static,
    relative: P0.PositionType.Relative,
    absolute: P0.PositionType.Absolute
  };
  if (s.setPositionType(Y0[y]), d) {
    const { top: h0, right: R0, bottom: S0, left: I0 } = ws(d, w);
    h0 && s.setPosition(P0.Edge.Top, h0), R0 && s.setPosition(P0.Edge.Right, R0), S0 && s.setPosition(P0.Edge.Bottom, S0), I0 && s.setPosition(P0.Edge.Left, I0);
  }
  const R2 = {
    row: P0.FlexDirection.Row,
    column: P0.FlexDirection.Column,
    "row-reverse": P0.FlexDirection.RowReverse,
    "column-reverse": P0.FlexDirection.ColumnReverse
  };
  s.setFlexDirection(R2[o0]);
  const f2 = {
    start: P0.Align.FlexStart,
    end: P0.Align.FlexEnd,
    center: P0.Align.Center,
    stretch: P0.Align.Stretch
  };
  s.setAlignItems(f2[q0]), j2 && s.setAlignSelf(f2[j2]);
  const N0 = {
    start: P0.Justify.FlexStart,
    end: P0.Justify.FlexEnd,
    center: P0.Justify.Center,
    "space-between": P0.Justify.SpaceBetween,
    "space-around": P0.Justify.SpaceAround,
    "space-evenly": P0.Justify.SpaceEvenly
  };
  if (s.setJustifyContent(N0[_0]), $) {
    const { top: h0, right: R0, bottom: S0, left: I0 } = xn($, w);
    s.setMargin(P0.Edge.Top, h0), s.setMargin(P0.Edge.Right, R0), s.setMargin(P0.Edge.Bottom, S0), s.setMargin(P0.Edge.Left, I0);
  }
  if (M0) {
    const { top: h0, right: R0, bottom: S0, left: I0 } = xn(M0, w);
    s.setPadding(P0.Edge.Top, h0), s.setPadding(P0.Edge.Right, R0), s.setPadding(P0.Edge.Bottom, S0), s.setPadding(P0.Edge.Left, I0);
  }
  u0 && s.setFlex(u0), s.setGap(P0.Gutter.All, (k0 ?? 0) * w), m && s.setWidth(typeof m == "number" ? m * w : m), G && (typeof G == "function" ? s.setHeight("100%") : s.setHeight(typeof G == "number" ? G * w : G)), X && s.setMinWidth(typeof X == "number" ? X * w : X), L && s.setMinHeight(typeof L == "number" ? L * w : L), J && s.setMaxWidth(typeof J == "number" ? J * w : J), q && s.setMaxHeight(typeof q == "number" ? q * w : q);
}
function Yn({ canvas: s, debug: A = !1, scale: w = 1, position: y = [] }) {
  y.forEach(({ x: d, y: m, width: G, height: X, childNodes: L, element: J }) => {
    const q = s.getContext("2d", { alpha: !1 });
    if (q) {
      const { draw: u0 } = J;
      u0 && (q.save(), u0({ scale: w, dx: d, dy: m, dw: G, dh: X }), A && (q.strokeStyle = "red", q.strokeRect(d, m, G, X))), Yn({
        canvas: s,
        debug: A,
        scale: w,
        position: L
      }), q.restore();
    }
  });
}
function Dn(s, A, w) {
  const y = A.map((d, m) => {
    const G = zn.Node.create(), { radius: X, elements: L = [], draw: J, ...q } = d;
    return Un(G, { layout: q, scale: w }), s.insertChild(G, m), {
      node: G,
      element: d,
      childNodes: Dn(G, L, w)
    };
  });
  return s.calculateLayout(), y;
}
function jn(s, A, w = 0, y = 0) {
  const { top: d, left: m } = s.getComputedLayout();
  return A.map(({ node: G, element: X, childNodes: L }) => {
    const { top: J, left: q, width: u0, height: k0 } = G.getComputedLayout(), $ = w + q, M0 = y + J;
    return {
      x: m + $,
      y: d + M0,
      width: u0,
      height: k0,
      element: X,
      childNodes: jn(s, L, $, M0)
    };
  });
}
function Jn(s, A) {
  s.forEach(({ node: w, element: y, childNodes: d }) => {
    const { height: m } = y;
    if (m && typeof m == "function") {
      const G = w.getComputedWidth(), X = w.getComputedHeight(), L = m({ width: G, maxHeight: X, scale: A });
      w.setHeight(L);
    }
    Jn(d, A);
  });
}
function vs({ canvas: s, origin: A, elements: w, ...y }) {
  const d = { inset: { top: 0, left: 0 }, width: s.width, height: s.height, ...A }, m = zn.Node.create();
  Un(m, { layout: d }), m.calculateLayout();
  const { width: G, height: X } = m.getComputedLayout(), L = Math.min(G, X) / 1080, J = Dn(m, w, L);
  Jn(J, L), m.calculateLayout();
  const q = jn(m, J);
  return Yn({ ...y, scale: L, canvas: s, position: q });
}
var Qn = function() {
}, Nt = function() {
};
process.env.NODE_ENV !== "production" && (Qn = function(s, A) {
  !s && typeof console < "u" && console.warn(A);
}, Nt = function(s, A) {
  if (!s)
    throw new Error(A);
});
const gs = (s, A, w) => Math.min(Math.max(w, s), A), bn = (s, A, w) => {
  const y = A - s;
  return y === 0 ? 1 : (w - s) / y;
}, ti = (s, A, w) => -w * s + w * A + s, $n = (s, A) => (w) => Math.max(Math.min(w, A), s), Rt = (s) => s % 1 ? Number(s.toFixed(5)) : s, ir = /(-)?([\d]*\.?[\d])+/g, Jr = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, ys = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function Wt(s) {
  return typeof s == "string";
}
const sr = {
  test: (s) => typeof s == "number",
  parse: parseFloat,
  transform: (s) => s
}, Kn = Object.assign(Object.assign({}, sr), { transform: $n(0, 1) });
Object.assign(Object.assign({}, sr), { default: 1 });
const ds = (s) => ({
  test: (A) => Wt(A) && A.endsWith(s) && A.split(" ").length === 1,
  parse: parseFloat,
  transform: (A) => `${A}${s}`
}), Et = ds("%");
Object.assign(Object.assign({}, Et), { parse: (s) => Et.parse(s) / 100, transform: (s) => Et.transform(s * 100) });
const ri = (s, A) => (w) => !!(Wt(w) && ys.test(w) && w.startsWith(s) || A && Object.prototype.hasOwnProperty.call(w, A)), qn = (s, A, w) => (y) => {
  if (!Wt(y))
    return y;
  const [d, m, G, X] = y.match(ir);
  return {
    [s]: parseFloat(d),
    [A]: parseFloat(m),
    [w]: parseFloat(G),
    alpha: X !== void 0 ? parseFloat(X) : 1
  };
}, Ye = {
  test: ri("hsl", "hue"),
  parse: qn("hue", "saturation", "lightness"),
  transform: ({ hue: s, saturation: A, lightness: w, alpha: y = 1 }) => "hsla(" + Math.round(s) + ", " + Et.transform(Rt(A)) + ", " + Et.transform(Rt(w)) + ", " + Rt(Kn.transform(y)) + ")"
}, Rs = $n(0, 255), zr = Object.assign(Object.assign({}, sr), { transform: (s) => Math.round(Rs(s)) }), Fe = {
  test: ri("rgb", "red"),
  parse: qn("red", "green", "blue"),
  transform: ({ red: s, green: A, blue: w, alpha: y = 1 }) => "rgba(" + zr.transform(s) + ", " + zr.transform(A) + ", " + zr.transform(w) + ", " + Rt(Kn.transform(y)) + ")"
};
function Es(s) {
  let A = "", w = "", y = "", d = "";
  return s.length > 5 ? (A = s.substr(1, 2), w = s.substr(3, 2), y = s.substr(5, 2), d = s.substr(7, 2)) : (A = s.substr(1, 1), w = s.substr(2, 1), y = s.substr(3, 1), d = s.substr(4, 1), A += A, w += w, y += y, d += d), {
    red: parseInt(A, 16),
    green: parseInt(w, 16),
    blue: parseInt(y, 16),
    alpha: d ? parseInt(d, 16) / 255 : 1
  };
}
const Qr = {
  test: ri("#"),
  parse: Es,
  transform: Fe.transform
}, ur = {
  test: (s) => Fe.test(s) || Qr.test(s) || Ye.test(s),
  parse: (s) => Fe.test(s) ? Fe.parse(s) : Ye.test(s) ? Ye.parse(s) : Qr.parse(s),
  transform: (s) => Wt(s) ? s : s.hasOwnProperty("red") ? Fe.transform(s) : Ye.transform(s)
}, e1 = "${c}", t1 = "${n}";
function Ns(s) {
  var A, w, y, d;
  return isNaN(s) && Wt(s) && ((w = (A = s.match(ir)) === null || A === void 0 ? void 0 : A.length) !== null && w !== void 0 ? w : 0) + ((d = (y = s.match(Jr)) === null || y === void 0 ? void 0 : y.length) !== null && d !== void 0 ? d : 0) > 0;
}
function r1(s) {
  typeof s == "number" && (s = `${s}`);
  const A = [];
  let w = 0;
  const y = s.match(Jr);
  y && (w = y.length, s = s.replace(Jr, e1), A.push(...y.map(ur.parse)));
  const d = s.match(ir);
  return d && (s = s.replace(ir, t1), A.push(...d.map(sr.parse))), { values: A, numColors: w, tokenised: s };
}
function i1(s) {
  return r1(s).values;
}
function n1(s) {
  const { values: A, numColors: w, tokenised: y } = r1(s), d = A.length;
  return (m) => {
    let G = y;
    for (let X = 0; X < d; X++)
      G = G.replace(X < w ? e1 : t1, X < w ? ur.transform(m[X]) : Rt(m[X]));
    return G;
  };
}
const Ws = (s) => typeof s == "number" ? 0 : s;
function Os(s) {
  const A = i1(s);
  return n1(s)(A.map(Ws));
}
const o1 = { test: Ns, parse: i1, createTransformer: n1, getAnimatableNone: Os };
function Ur(s, A, w) {
  return w < 0 && (w += 1), w > 1 && (w -= 1), w < 1 / 6 ? s + (A - s) * 6 * w : w < 1 / 2 ? A : w < 2 / 3 ? s + (A - s) * (2 / 3 - w) * 6 : s;
}
function Cn({ hue: s, saturation: A, lightness: w, alpha: y }) {
  s /= 360, A /= 100, w /= 100;
  let d = 0, m = 0, G = 0;
  if (!A)
    d = m = G = w;
  else {
    const X = w < 0.5 ? w * (1 + A) : w + A - w * A, L = 2 * w - X;
    d = Ur(L, X, s + 1 / 3), m = Ur(L, X, s), G = Ur(L, X, s - 1 / 3);
  }
  return {
    red: Math.round(d * 255),
    green: Math.round(m * 255),
    blue: Math.round(G * 255),
    alpha: y
  };
}
const Ss = (s, A, w) => {
  const y = s * s, d = A * A;
  return Math.sqrt(Math.max(0, w * (d - y) + y));
}, Zs = [Qr, Fe, Ye], Vn = (s) => Zs.find((A) => A.test(s)), Bn = (s) => `'${s}' is not an animatable color. Use the equivalent color code instead.`, f1 = (s, A) => {
  let w = Vn(s), y = Vn(A);
  Nt(!!w, Bn(s)), Nt(!!y, Bn(A));
  let d = w.parse(s), m = y.parse(A);
  w === Ye && (d = Cn(d), w = Fe), y === Ye && (m = Cn(m), y = Fe);
  const G = Object.assign({}, d);
  return (X) => {
    for (const L in G)
      L !== "alpha" && (G[L] = Ss(d[L], m[L], X));
    return G.alpha = ti(d.alpha, m.alpha, X), w.transform(G);
  };
}, Gs = (s) => typeof s == "number", Is = (s, A) => (w) => A(s(w)), s1 = (...s) => s.reduce(Is);
function u1(s, A) {
  return Gs(s) ? (w) => ti(s, A, w) : ur.test(s) ? f1(s, A) : l1(s, A);
}
const a1 = (s, A) => {
  const w = [...s], y = w.length, d = s.map((m, G) => u1(m, A[G]));
  return (m) => {
    for (let G = 0; G < y; G++)
      w[G] = d[G](m);
    return w;
  };
}, Ts = (s, A) => {
  const w = Object.assign(Object.assign({}, s), A), y = {};
  for (const d in w)
    s[d] !== void 0 && A[d] !== void 0 && (y[d] = u1(s[d], A[d]));
  return (d) => {
    for (const m in y)
      w[m] = y[m](d);
    return w;
  };
};
function Fn(s) {
  const A = o1.parse(s), w = A.length;
  let y = 0, d = 0, m = 0;
  for (let G = 0; G < w; G++)
    y || typeof A[G] == "number" ? y++ : A[G].hue !== void 0 ? m++ : d++;
  return { parsed: A, numNumbers: y, numRGB: d, numHSL: m };
}
const l1 = (s, A) => {
  const w = o1.createTransformer(A), y = Fn(s), d = Fn(A);
  return y.numHSL === d.numHSL && y.numRGB === d.numRGB && y.numNumbers >= d.numNumbers ? s1(a1(y.parsed, d.parsed), w) : (Qn(!0, `Complex values '${s}' and '${A}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), (G) => `${G > 0 ? A : s}`);
}, xs = (s, A) => (w) => ti(s, A, w);
function Cs(s) {
  if (typeof s == "number")
    return xs;
  if (typeof s == "string")
    return ur.test(s) ? f1 : l1;
  if (Array.isArray(s))
    return a1;
  if (typeof s == "object")
    return Ts;
}
function Vs(s, A, w) {
  const y = [], d = w || Cs(s[0]), m = s.length - 1;
  for (let G = 0; G < m; G++) {
    let X = d(s[G], s[G + 1]);
    if (A) {
      const L = Array.isArray(A) ? A[G] : A;
      X = s1(L, X);
    }
    y.push(X);
  }
  return y;
}
function Bs([s, A], [w]) {
  return (y) => w(bn(s, A, y));
}
function Fs(s, A) {
  const w = s.length, y = w - 1;
  return (d) => {
    let m = 0, G = !1;
    if (d <= s[0] ? G = !0 : d >= s[y] && (m = y - 1, G = !0), !G) {
      let L = 1;
      for (; L < w && !(s[L] > d || L === y); L++)
        ;
      m = L - 1;
    }
    const X = bn(s[m], s[m + 1], d);
    return A[m](X);
  };
}
function Ps(s, A, { clamp: w = !0, ease: y, mixer: d } = {}) {
  const m = s.length;
  Nt(m === A.length, "Both input and output ranges must be the same length"), Nt(!y || !Array.isArray(y) || y.length === m - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), s[0] > s[m - 1] && (s = [].concat(s), A = [].concat(A), s.reverse(), A.reverse());
  const G = Vs(A, y, d), X = m === 2 ? Bs(s, G) : Fs(s, G);
  return w ? (L) => X(gs(s[0], s[m - 1], L)) : X;
}
const ar = (s) => (A) => 1 - s(1 - A), ii = (s) => (A) => A <= 0.5 ? s(2 * A) / 2 : (2 - s(2 * (1 - A))) / 2, _s = (s) => (A) => Math.pow(A, s), c1 = (s) => (A) => A * A * ((s + 1) * A - s), Ms = (s) => {
  const A = c1(s);
  return (w) => (w *= 2) < 1 ? 0.5 * A(w) : 0.5 * (2 - Math.pow(2, -10 * (w - 1)));
}, k1 = 1.525, Ls = 4 / 11, Xs = 8 / 11, Hs = 9 / 10, zs = (s) => s, ni = _s(2), Us = ar(ni), Ys = ii(ni), h1 = (s) => 1 - Math.sin(Math.acos(s)), A1 = ar(h1), Ds = ii(A1), oi = c1(k1), js = ar(oi), Js = ii(oi), Qs = Ms(k1), bs = 4356 / 361, $s = 35442 / 1805, Ks = 16061 / 1805, nr = (s) => {
  if (s === 1 || s === 0)
    return s;
  const A = s * s;
  return s < Ls ? 7.5625 * A : s < Xs ? 9.075 * A - 9.9 * s + 3.4 : s < Hs ? bs * A - $s * s + Ks : 10.8 * s * s - 20.52 * s + 10.72;
}, qs = ar(nr), eu = (s) => s < 0.5 ? 0.5 * (1 - nr(1 - s * 2)) : 0.5 * nr(s * 2 - 1) + 0.5, tu = {
  linear: zs,
  easeIn: ni,
  easeInOut: Ys,
  easeOut: Us,
  circIn: h1,
  circInOut: Ds,
  circOut: A1,
  backIn: oi,
  backInOut: Js,
  backOut: js,
  anticipate: Qs,
  bounceIn: qs,
  bounceInOut: eu,
  bounceOut: nr
}, Dt = qr(
  (s, A, { clamp: w = !0, ease: y = "easeIn", ...d } = {}) => Ps(s, A, { ...d, clamp: w, ease: tu[y] }),
  {
    cacheKey: ([s, A, w]) => JSON.stringify({ from: s, to: A, options: w })
  }
), ru = [
  {
    family: "Noto Arabic",
    regex: /\p{Script=Arabic}/u,
    url: "https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/NotoSansArabic-VariableFont_wdth%2Cwght.woff2",
    style: "normal"
  },
  {
    family: "Noto Chinese",
    regex: /\p{Script=Han}/u,
    url: "https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/NotoSansSC-VariableFont_wght.woff2",
    style: "normal"
  },
  {
    family: "Noto Hebrew",
    regex: /\p{Script=Hebrew}/u,
    url: "https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/NotoSansHebrew-VariableFont_wdth%2Cwght.woff2",
    style: "normal"
  },
  {
    family: "Noto Hindi",
    regex: /\p{Script=Devanagari}/u,
    url: "https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/NotoSansDevanagari-VariableFont_wdth%2Cwght.woff2",
    style: "normal"
  },
  {
    family: "Noto Japanese",
    regex: /\p{Script=Han}|\p{Script=Katakana}|\p{Script=Hiragana}/u,
    url: "https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/NotoSansJP-VariableFont_wght.woff2",
    style: "normal"
  },
  {
    family: "Noto Korean",
    regex: /\p{Script=Hangul}/u,
    url: "https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/NotoSansKR-VariableFont_wght.woff2",
    style: "normal"
  },
  {
    family: "Noto Color Emoji",
    regex: /\p{Extended_Pictographic}/u,
    url: "https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/NotoColorEmoji-Regular.woff2",
    style: "normal"
  }
];
function br({ text: s, font: A }) {
  let w = A;
  return ru.forEach(({ family: y, regex: d }) => {
    d.exec(s) && (w += `, ${y}`);
  }), w;
}
const ye = 1.8, or = /(?<value>\d+\.?\d*)(?=px)/;
function iu(s, A = 1) {
  return typeof s == "number" ? {
    topLeft: s * A,
    topRight: s * A,
    bottomRight: s * A,
    bottomLeft: s * A
  } : {
    topLeft: ((s == null ? void 0 : s.topLeft) ?? 0) * A,
    topRight: ((s == null ? void 0 : s.topRight) ?? 0) * A,
    bottomRight: ((s == null ? void 0 : s.bottomRight) ?? 0) * A,
    bottomLeft: ((s == null ? void 0 : s.bottomLeft) ?? 0) * A
  };
}
function p1(s) {
  const { visible: A, node: w } = s, y = [...(w == null ? void 0 : w.elements) ?? [], ...(s == null ? void 0 : s.elements) ?? []];
  return (
    // If we're explicitly visible or invisible return this value
    A ?? // Otherwise only show the node if the node has a value that's not undefined
    (w && w.type !== "box" && w.type !== "gradient" ? !!w.value : y == null ? void 0 : y.some((d) => p1(d)))
  );
}
function m1({
  debug: s = !1,
  canvas: A,
  cropCanvas: w,
  posterCanvas: y,
  letterboxCanvas: d,
  elements: m = [],
  currentTime: G,
  contentTime: X,
  sceneTime: L,
  totalDuration: J,
  contentDuration: q,
  sceneDuration: u0
}) {
  return m.map((k0) => {
    var Y0, R2, f2, N0, h0, R0, S0, I0;
    const { node: $, transient: M0 = [{ from: 0, duration: 1 / 0 }] } = k0, o0 = A.getContext("2d"), q0 = {
      total: G,
      content: X,
      scene: L
    }, j2 = {
      total: J,
      content: q,
      scene: u0
    }, _0 = M0.reduce(
      (C0, { type: o2 = "scene", from: A0, duration: w0, animation: p0 }) => {
        const n0 = A0 < 0 ? j2[o2] + A0 : A0;
        return q0[o2] >= n0 && q0[o2] <= n0 + w0 && (C0 = {
          type: o2,
          animation: p0,
          duration: w0,
          from: n0
        }), C0;
      },
      null
    );
    if (o0 && _0 && p1(k0)) {
      let C0 = k0.width, o2 = k0.height;
      if (($ == null ? void 0 : $.type) === "text" && $.value) {
        const A0 = br({ text: $.value, font: $.font });
        o0.save(), $.wrap ? o2 = ({ width: w0, maxHeight: p0, scale: n0 }) => {
          var D0, g2;
          const k2 = Tn({
            font: A0,
            scale: n0,
            context: o0,
            maxW: w0,
            maxH: p0,
            text: $.value ?? "",
            minSize: (D0 = $.fill) == null ? void 0 : D0.minSize,
            maxSize: (g2 = $.fill) == null ? void 0 : g2.maxSize
          });
          return fr({ context: o0, font: A0, fontSize: k2, text: $.value ?? "", maxW: w0 }).length * k2;
        } : (o0.font = A0, C0 = o0.measureText($.value).width, o2 = parseFloat(((R2 = (Y0 = A0.match(or)) == null ? void 0 : Y0.groups) == null ? void 0 : R2.value) ?? "0")), o0.restore();
      }
      if (($ == null ? void 0 : $.type) === "image" && $.image && $.size) {
        const A0 = ((f2 = $.image) == null ? void 0 : f2.naturalWidth) ?? ((N0 = $.image) == null ? void 0 : N0.width), w0 = ((h0 = $.image) == null ? void 0 : h0.naturalHeight) ?? ((R0 = $.image) == null ? void 0 : R0.height), p0 = A0 / w0, n0 = (S0 = $.size) == null ? void 0 : S0.width, k2 = (I0 = $.size) == null ? void 0 : I0.height;
        C0 = n0 ?? (p0 >= 1 ? (k2 ?? 0) * p0 : (k2 ?? 0) / p0), o2 = k2 ?? (p0 < 1 ? (n0 ?? 0) * p0 : (n0 ?? 0) / p0);
      }
      return {
        ...k0,
        width: C0,
        height: o2,
        elements: m1({
          debug: s,
          canvas: A,
          cropCanvas: w,
          posterCanvas: y,
          letterboxCanvas: d,
          elements: k0.elements,
          currentTime: G,
          contentTime: X,
          sceneTime: L,
          totalDuration: J,
          contentDuration: q,
          sceneDuration: u0
        }),
        draw: ({ dx: A0, dy: w0, dw: p0, dh: n0, scale: k2 }) => {
          var h2, J0, V2, B2, H2, Pe, ee, ot, De, F2, je, _e, ce;
          const {
            type: x0 = "scene",
            from: D0,
            duration: g2,
            animation: a2 = { type: "fade", duration: 1 / 3, easing: { in: "easeOut", out: "easeOut" } }
          } = _0;
          if (a2) {
            const {
              type: m0,
              duration: j0,
              easing: { in: W0 = "easeOut", out: Z2 = "easeOut" } = {}
            } = a2;
            if (D0 > 0 && q0[x0] <= D0 + j0)
              switch (m0) {
                case "fade": {
                  const l2 = Dt([D0, D0 + j0], [0, 1], {
                    ease: W0
                  });
                  o0.globalAlpha = l2(q0[x0]);
                  break;
                }
                case "slide": {
                  const { options: l2 } = a2, Q0 = {
                    up: [
                      { x: 0, y: n0 },
                      { x: 0, y: 0 }
                    ],
                    right: [
                      { x: p0, y: 0 },
                      { x: 0, y: 0 }
                    ],
                    down: [
                      { x: 0, y: -n0 },
                      { x: 0, y: 0 }
                    ],
                    left: [
                      { x: -p0, y: 0 },
                      { x: 0, y: 0 }
                    ]
                  }, E2 = Dt(
                    [D0, D0 + j0],
                    Q0[l2.direction.in],
                    { ease: W0 }
                  ), { x: P2, y: _2 } = E2(q0[x0]);
                  o0.translate(P2, _2);
                  break;
                }
              }
            if (
              // Don't fade out if we hit the end of the video as the fade ends
              D0 + g2 < j2[x0] && D0 + g2 - j0 <= q0[x0]
            )
              switch (m0) {
                case "fade": {
                  const l2 = Dt([D0 + g2 - j0, D0 + g2], [1, 0], {
                    ease: Z2
                  });
                  o0.globalAlpha = l2(q0[x0]);
                  break;
                }
                case "slide": {
                  const { options: l2 } = a2, Q0 = {
                    up: [
                      { x: 0, y: 0 },
                      { x: 0, y: -n0 }
                    ],
                    right: [
                      { x: 0, y: 0 },
                      { x: p0, y: 0 }
                    ],
                    down: [
                      { x: 0, y: 0 },
                      { x: 0, y: n0 }
                    ],
                    left: [
                      { x: 0, y: 0 },
                      { x: -p0, y: 0 }
                    ]
                  }, E2 = Dt(
                    [D0 + g2 - j0, D0 + g2],
                    Q0[l2.direction.out],
                    { ease: Z2 }
                  ), { x: P2, y: _2 } = E2(q0[x0]);
                  o0.translate(P2, _2);
                  break;
                }
              }
          }
          if ($) {
            const { type: m0 } = $;
            if (k0.radius) {
              const { topLeft: j0, topRight: W0, bottomRight: Z2, bottomLeft: l2 } = iu(k0.radius, k2);
              o0.beginPath(), o0.moveTo(A0 + Math.min(n0 / ye, j0), w0), o0.lineTo(A0 + p0 - Math.min(n0 / ye, W0), w0), o0.quadraticCurveTo(A0 + p0, w0, A0 + p0, w0 + Math.min(n0 / ye, W0)), o0.lineTo(A0 + p0, w0 + n0 - Math.min(n0 / ye, Z2)), o0.quadraticCurveTo(
                A0 + p0,
                w0 + n0,
                A0 + p0 - Math.min(n0 / ye, Z2),
                w0 + n0
              ), o0.lineTo(A0 + Math.min(n0 / ye, l2), w0 + n0), o0.quadraticCurveTo(A0, w0 + n0, A0, w0 + n0 - Math.min(n0 / ye, l2)), o0.lineTo(A0, w0 + Math.min(n0 / ye, j0)), o0.quadraticCurveTo(A0, w0, A0 + Math.min(n0 / ye, j0), w0), o0.closePath(), s && (o0.strokeStyle = "blue", o0.stroke()), o0.clip();
            }
            if (m0 === "box" && (o0.fillStyle = $.background, o0.fillRect(A0, w0, p0, n0)), m0 === "text" && $.value) {
              const { align: j0 = "left" } = $, W0 = br({ text: $.value, font: $.font }), Z2 = Tn({
                font: W0,
                scale: k2,
                context: o0,
                maxW: p0,
                maxH: n0,
                text: $.value ?? "",
                minSize: (h2 = $.fill) == null ? void 0 : h2.minSize,
                maxSize: (J0 = $.fill) == null ? void 0 : J0.maxSize
              });
              o0.font = W0.replace(or, Z2.toString()), o0.textBaseline = "top", o0.fillStyle = $.color, o0.textAlign = j0;
              const l2 = {
                left: A0,
                center: A0 + p0 / 2,
                right: A0 + p0
              };
              $.wrap ? fr({ context: o0, font: W0, fontSize: Z2, text: $.value, maxW: p0 }).forEach((E2, P2) => {
                o0.fillText(E2.text, l2[j0], w0 + Z2 * P2);
              }) : o0.fillText($.value, l2[j0], w0);
            }
            if (m0 === "image" && $.image && o0.drawImage($.image, A0, w0, p0, n0), m0 === "video" && ((V2 = $.video) != null && V2.node || (B2 = $.video) != null && B2.getSource)) {
              const j0 = $.format ?? "letterbox", W0 = ((Pe = (H2 = $.video) == null ? void 0 : H2.getSource) == null ? void 0 : Pe.call(H2, L)) ?? $.video.node, Z2 = (W0 == null ? void 0 : W0.videoWidth) ?? (W0 == null ? void 0 : W0.naturalWidth) ?? (W0 == null ? void 0 : W0.width), l2 = (W0 == null ? void 0 : W0.videoHeight) ?? (W0 == null ? void 0 : W0.naturalHeight) ?? (W0 == null ? void 0 : W0.height);
              if (Z2 && l2) {
                const {
                  dx: E2,
                  dy: P2,
                  dw: _2,
                  dh: z2
                } = Zn({
                  context: o0,
                  cropCanvas: w,
                  letterboxCanvas: d,
                  source: W0,
                  format: j0,
                  crop: (ee = $ == null ? void 0 : $.value) == null ? void 0 : ee.crop,
                  sourceWidth: Z2,
                  sourceHeight: l2,
                  posX: A0,
                  posY: w0,
                  drawAreaWidth: p0,
                  drawAreaHeight: n0
                });
                $.elements && $r({
                  debug: s,
                  canvas: A,
                  cropCanvas: w,
                  posterCanvas: y,
                  letterboxCanvas: d,
                  elements: $.elements,
                  currentTime: G,
                  contentTime: X,
                  sceneTime: L,
                  totalDuration: J,
                  contentDuration: q,
                  sceneDuration: u0,
                  origin: {
                    inset: {
                      top: Math.max(w0, w0 + P2),
                      left: Math.max(A0, A0 + E2)
                    },
                    width: Math.min(p0, _2),
                    height: Math.min(n0, z2)
                  }
                });
              }
              const Q0 = 1 / 3;
              if ($.poster && G >= 0 && G <= Q0) {
                o0.save(), o0.globalAlpha = 1 - G / Q0;
                const E2 = ((ot = $.poster) == null ? void 0 : ot.naturalWidth) ?? ((De = $.poster) == null ? void 0 : De.width), P2 = ((F2 = $.poster) == null ? void 0 : F2.naturalHeight) ?? ((je = $.poster) == null ? void 0 : je.height);
                y.width = y.height = 0, y.width = p0, y.height = n0;
                const _2 = y.getContext("2d");
                if (_2 && E2 && P2) {
                  const {
                    dx: z2,
                    dy: ft,
                    dw: ke,
                    dh: Ot
                  } = Zn({
                    context: _2,
                    cropCanvas: w,
                    letterboxCanvas: d,
                    source: $.poster,
                    format: j0,
                    crop: (_e = $ == null ? void 0 : $.value) == null ? void 0 : _e.crop,
                    sourceWidth: E2,
                    sourceHeight: P2,
                    posX: 0,
                    posY: 0,
                    drawAreaWidth: p0,
                    drawAreaHeight: n0
                  });
                  $.elements && $r({
                    debug: s,
                    canvas: y,
                    cropCanvas: w,
                    posterCanvas: y,
                    letterboxCanvas: d,
                    elements: $.elements,
                    currentTime: G,
                    contentTime: X,
                    sceneTime: L,
                    totalDuration: J,
                    contentDuration: q,
                    sceneDuration: u0,
                    origin: {
                      inset: {
                        top: Math.max(0, ft),
                        left: Math.max(0, z2)
                      },
                      width: Math.min(p0, ke),
                      height: Math.min(n0, Ot)
                    }
                  }), o0.drawImage(y, A0, w0, p0, n0), o0.restore();
                }
              }
            }
            if (m0 === "gradient" && $.value) {
              const j0 = o0.createLinearGradient(A0 + p0, w0, A0 + p0, w0 + n0);
              (ce = $.value) == null || ce.forEach((W0) => {
                j0.addColorStop(W0.percent, W0.color);
              }), o0.fillStyle = j0, o0.fillRect(A0, w0, p0, n0);
            }
          }
        }
      };
    }
  }).filter(Boolean);
}
function $r({
  debug: s,
  canvas: A,
  cropCanvas: w,
  posterCanvas: y,
  letterboxCanvas: d,
  elements: m,
  currentTime: G,
  contentTime: X,
  sceneTime: L,
  totalDuration: J,
  contentDuration: q,
  sceneDuration: u0,
  ...k0
}) {
  return vs({
    ...k0,
    debug: s,
    canvas: A,
    elements: m1({
      debug: s,
      canvas: A,
      cropCanvas: w,
      posterCanvas: y,
      letterboxCanvas: d,
      elements: m,
      currentTime: G,
      contentTime: X,
      sceneTime: L,
      totalDuration: J,
      contentDuration: q,
      sceneDuration: u0
    })
  });
}
const fr = qr(
  ({ context: s, font: A, fontSize: w, text: y, maxW: d = 1 / 0 }) => {
    try {
      return s.save(), s.font = A.replace(or, w.toString()), y.split(`
`).flatMap((G) => {
        const X = G.split(" ").filter(Boolean);
        return X.length ? X.slice(1).reduce((L, J) => {
          const u0 = `${L[L.length - 1].text} ${J}`.trim(), k0 = s.measureText(u0);
          return k0.width > d ? L = [...L, ...In({ context: s, word: J, maxW: d })] : L[L.length - 1] = {
            text: u0,
            metrics: k0
          }, L;
        }, In({ context: s, word: X[0], maxW: d })) : { text: "", metrics: s.measureText("") };
      });
    } finally {
      s.restore();
    }
  },
  {
    cacheKey: ([{ font: s, fontSize: A, text: w, maxW: y }]) => `${s}_${A}_${w}_${y}`
  }
), nu = /\d{0,2}:?\d{2}:\d{2}\.\d{3}\s-->\s\d{0,2}:?\d{2}:\d{2}\.\d{3}\s{1,2}.*/g, ou = /\d{0,2}:?\d{2}:\d{2}\.\d{3}/g;
function fu(s) {
  if (!s)
    return [];
  const A = s.match(nu);
  return A ? A == null ? void 0 : A.map((w) => {
    const [y, d] = w.replace(`\r
`, `
`).split(`
`), [m, G] = y.match(ou) || [];
    return { start: m, end: G, text: d };
  }) : [];
}
function Pn(s) {
  const [A, w, y] = s.split(":");
  return y ? parseInt(A) * 60 * 60 + parseInt(w) * 60 + parseFloat(y) : parseInt(A) * 60 + parseInt(w);
}
function su({ canvas: s, dx: A, dy: w, dw: y, dh: d, sceneTime: m, vttCaptions: G }) {
  if (G) {
    const L = fu(G).find(({ start: J, end: q }) => J && q && m >= Pn(J) && m < Pn(q));
    if (L) {
      const J = s.getContext("2d");
      if (J) {
        const q = Math.min(y, d), u0 = q * 0.04, k0 = br({
          text: G,
          font: `400 ${u0}px Roobert Captions`
        });
        J.font = k0, J.textBaseline = "middle";
        const $ = y * 0.9, M0 = fr({ context: J, font: k0, fontSize: u0, text: L.text, maxW: $ });
        M0.forEach(({ text: o0, metrics: q0 }, j2) => {
          const _0 = A + (y - q0.width) / 2, Y0 = w + (d * 0.85 - (u0 + q * 0.03) * (M0.length - 1 - j2)), R2 = u0 * 0.8, f2 = u0 / 1.5, N0 = A + (y - q0.width - f2) / 2, h0 = Y0 - R2, R0 = q0.width + f2, S0 = R2 * 2, I0 = J.globalAlpha;
          J.save(), J.globalAlpha = 0.8 * I0, J.fillStyle = "#000000", J.beginPath(), J.roundRect(N0, h0, R0, S0, q * 0.01), J.fill(), J.closePath(), J.globalAlpha = I0, J.fillStyle = "#FFFFFF", J.fillText(o0, _0, Y0), J.restore();
        });
      }
    }
  }
}
const uu = {
  id: "046f363c-960a-449c-ae5e-984ac6ab58c2",
  version: "2",
  name: "None",
  entityId: "none",
  templateId: "a95e537e-fb4d-4d2f-9c72-86c0925c7176",
  layouts: [
    {
      name: "none",
      tree: `[
        {
          "width": "100%",
          "height": "100%",
          "node": {
            "type": "video",
            "format": {{ it.videoFormat }},
            "value": {
              "id": {{ it.id }},
              "key": {{ it.key }},
              "src": {{@async resolve-source({ sources: [it.mp4, it.input] }) /}},
              "playlist": {{@async resolve-source({ sources: [it.playlist] }) /}},
              "poster": {{ it.poster }},
              "captions": {{ it.captions }},
              "duration": {{ it.duration }},
              "startOffset": {{ it.startOffset }},
              "endOffset": {{ it.endOffset }},
              "crop": {
                "x": {{ it.crop?.x }},
                "y": {{ it.crop?.y }},
                "width": {{ it.crop?.width }},
                "height": {{ it.crop?.height }}
              }
            }
          }
        }
      ]`
    }
  ],
  content: [
    {
      scenes: [
        {
          layout: "none",
          data: `{
            "id": {{ it.root?.answer?.id }},
            "key": {{ it.root?.answer?.id + '-intro' }},
            "mp4": {{ it.root?.answer?.media?.video }},
            "input": {{ it.root?.answer?.media?.input }},
            "playlist": {{ it.root?.answer?.media?.playlist }},
            "poster": {{ it.root?.answer?.media?.thumbnail }},
            "captions": {{ it.root?.answer?.captions?.current }},
            "duration": {{ it.root?.answer?.metadata?.duration }},
            "startOffset": {{ it.root?.answer?.settings?.startOffset }},
            "endOffset": {{ it.root?.answer?.settings?.endOffset }},
            "crop": {
              "x": {{ it.root?.answer?.settings?.crop?.x }},
              "y": {{ it.root?.answer?.settings?.crop?.y }},
              "width": {{ it.root?.answer?.settings?.crop?.width }},
              "height": {{ it.root?.answer?.settings?.crop?.height }}
            }
          }`
        }
      ],
      root: "{{ it.intro?.questions?.items }}"
    },
    {
      scenes: [
        {
          layout: "none",
          data: `{
            "id": {{ it.root?.answer?.id }},
            "key": {{ it.root?.answer?.id + '-' + it.index }},
            "mp4": {{ it.root?.answer?.media?.video }},
            "input": {{ it.root?.answer?.media?.input }},
            "playlist": {{ it.root?.answer?.media?.playlist }},
            "poster": {{ it.root?.answer?.media?.thumbnail }},
            "captions": {{ it.root?.answer?.captions?.current }},
            "duration": {{ it.root?.answer?.metadata?.duration }},
            "startOffset": {{ it.root?.answer?.settings?.startOffset }},
            "endOffset": {{ it.root?.answer?.settings?.endOffset }},
            "crop": {
              "x": {{ it.root?.answer?.settings?.crop?.x }},
              "y": {{ it.root?.answer?.settings?.crop?.y }},
              "width": {{ it.root?.answer?.settings?.crop?.width }},
              "height": {{ it.root?.answer?.settings?.crop?.height }}
            }
          }`
        }
      ],
      root: "{{ it.questions?.items }}"
    },
    {
      scenes: [
        {
          layout: "none",
          data: `{
            "id": {{ it.root?.answer?.id }},
            "key": {{ it.root?.answer?.id + '-outro' }},
            "mp4": {{ it.root?.answer?.media?.video }},
            "input": {{ it.root?.answer?.media?.input }},
            "playlist": {{ it.root?.answer?.media?.playlist }},
            "poster": {{ it.root?.answer?.media?.thumbnail }},
            "captions": {{ it.root?.answer?.captions?.current }},
            "duration": {{ it.root?.answer?.metadata?.duration }},
            "startOffset": {{ it.root?.answer?.settings?.startOffset }},
            "endOffset": {{ it.root?.answer?.settings?.endOffset }},
            "crop": {
              "x": {{ it.root?.answer?.settings?.crop?.x }},
              "y": {{ it.root?.answer?.settings?.crop?.y }},
              "width": {{ it.root?.answer?.settings?.crop?.width }},
              "height": {{ it.root?.answer?.settings?.crop?.height }}
            }
          }`
        }
      ],
      root: "{{ it.outro?.questions?.items }}"
    }
  ],
  system: !0,
  createdAt: (/* @__PURE__ */ new Date()).toISOString(),
  updatedAt: (/* @__PURE__ */ new Date()).toISOString()
}, au = {
  id: "073977ec-6384-4329-b7c5-8275fb513e74",
  name: "None",
  entityId: "none",
  templateId: "a95e537e-fb4d-4d2f-9c72-86c0925c7176",
  templates: [uu],
  meta: {
    frameRate: 30,
    resolution: 720,
    transitionDuration: 1 / 3
  },
  system: !0,
  default: 0,
  createdAt: (/* @__PURE__ */ new Date()).toISOString(),
  updatedAt: (/* @__PURE__ */ new Date()).toISOString()
};
async function lu() {
  if (typeof window > "u") {
    const s = await import("skia-canvas");
    return new s.Image();
  }
  return new Image();
}
const _n = Ln(async function(A) {
  return A ? new Promise((w, y) => {
    lu().then((d) => {
      d.onload = () => {
        w(d);
      }, d.onerror = (m) => {
        y(m);
      }, d.src = A;
    });
  }) : null;
});
async function Kr({ element: s, meta: A }, w, y) {
  var G, X, L;
  let d = { ...s };
  const { node: m } = s;
  if ((m == null ? void 0 : m.type) === "video" && ((G = m == null ? void 0 : m.value) != null && G.src || (X = m == null ? void 0 : m.value) != null && X.playlist)) {
    const J = await w(m.value, A);
    let q;
    try {
      q = await _n(m.value.poster);
    } catch {
      q = null;
    }
    d = {
      ...d,
      node: {
        ...m,
        video: J,
        poster: q,
        meta: await y(m.value, J.node, A)
      }
    };
  }
  if ((m == null ? void 0 : m.type) === "image" && m.value) {
    let J;
    try {
      J = await _n(m.value);
    } catch {
      J = null;
    }
    d = {
      ...d,
      node: {
        ...m,
        image: J
      }
    };
  }
  return d.node && ((L = s.node) != null && L.elements) && (d.node.elements = await Promise.all(
    s.node.elements.map((J) => Kr({ element: J, meta: A }, w, y))
  )), s.elements && (d.elements = await Promise.all(
    s.elements.map((J) => Kr({ element: J, meta: A }, w, y))
  )), d;
}
async function jt() {
  if (typeof window > "u") {
    const s = await import("skia-canvas"), A = new s.Canvas();
    return A.gpu = !1, A;
  }
  return document.createElement("canvas");
}
async function cu(s) {
  var A;
  try {
    if ((A = await $f(s, { method: "HEAD" })) != null && A.ok)
      return s;
  } catch {
    return;
  }
}
async function ku({ sources: s }) {
  let A = null;
  if (s) {
    const w = s.filter(Boolean).map((y) => cu(y));
    A = (await Promise.all(w)).find(Boolean);
  }
  return A;
}
function dt(s = []) {
  var A;
  for (const w of s) {
    if (((A = w == null ? void 0 : w.node) == null ? void 0 : A.type) === "video")
      return w.node;
    const y = dt(w == null ? void 0 : w.elements);
    if (y)
      return y;
  }
}
function hu(s, A) {
  return s.reduce((w, y, d) => [
    ...w,
    y.map(({ duration: m }, G) => d === s.length - 1 && G === y.length - 1 ? m : m - A)
  ], []);
}
function Au(s) {
  if (s === null || typeof s != "object")
    return !1;
  if (Object.getPrototypeOf(s) === null)
    return !0;
  let A = s;
  for (; Object.getPrototypeOf(A) !== null; )
    A = Object.getPrototypeOf(A);
  return Object.getPrototypeOf(s) === A;
}
function pu(s) {
  return s.replace(/\\/g, "\\\\").replace(/\//g, "\\/").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\f/g, "\\f").replace(/"/g, '\\"');
}
function Jt(s) {
  return s.flatMap((A) => A).reduce((A, w) => A + w, 0);
}
jf.define("parse", (s) => typeof s > "u" ? null : typeof s == "string" ? `"${pu(s)}"` : Au(s) || Array.isArray(s) ? JSON.stringify(s) : s);
Jf.define(
  "resolve-source",
  Ln(
    async (s) => {
      const { sources: A } = s.params[0] ?? {}, w = A == null ? void 0 : A.filter(Boolean), y = w == null ? void 0 : w.find((G) => G.includes("blob:")), d = w == null ? void 0 : w.find((G) => !G.includes("http")), m = y ?? d ?? await ku({ sources: A });
      return m ? `"${m}"` : "null";
    },
    {
      cacheKey: ([s]) => JSON.stringify(s.params[0] ?? {})
    }
  )
);
const wt = (s, A, w) => Qf(
  s,
  A,
  bf({
    autoEscape: !1,
    defaultFilter: "parse",
    async: !0,
    asyncHelpers: ["resolve-source"],
    ...w
  })
);
async function yu({ data: s, template: A, burnCaptions: w = !1, debug: y = !1 }, d, m) {
  var _0, Y0, R2, f2;
  const G = A ?? au;
  if (!((_0 = G.templates) != null && _0.length))
    throw new Error(`No templates found for template instance: ${G.id}`);
  let X = G.templates.find(({ version: N0 }) => N0 === Mn);
  if (!X) {
    const N0 = G.templates.map(({ version: h0 }) => `"${h0}"`).join(", ");
    console.warn(`Template renderer expects template version "${Mn}" but got ${N0}`), X = G.templates[G.templates.length - 1];
  }
  const L = await Promise.all(
    X.content.map(async ({ scenes: N0, root: h0 }) => {
      const R0 = {
        ...G.options,
        ...s,
        intro: G.intro,
        outro: G.outro
      };
      async function S0(I0, C0) {
        return Promise.all(
          N0.map(async ({ layout: o2, duration: A0, data: w0, options: p0 }) => {
            var B2, H2, Pe;
            const n0 = { ...R0, index: C0, root: I0 }, k2 = w0 ? JSON.parse(await wt(w0, n0)) : {}, x0 = p0 ? JSON.parse(await wt(p0, n0)) : {}, D0 = A0 ? parseFloat(await wt(A0, n0)) : NaN, g2 = (B2 = X.layouts.find((ee) => ee.name === o2)) == null ? void 0 : B2.tree;
            if (!g2)
              throw new Error(`Layout tree "${o2}" not found in template "${X.id}" layouts.`);
            const a2 = JSON.parse(
              await wt(g2, {
                ...k2,
                ...x0
              })
            ), h2 = await Promise.all(
              a2.flatMap(
                (ee) => Kr({ element: ee, meta: G.meta }, d, m)
              )
            ), J0 = dt(h2);
            return {
              duration: (isNaN(D0) ? null : D0) ?? ((H2 = J0 == null ? void 0 : J0.meta) == null ? void 0 : H2.duration) ?? 0,
              captions: (Pe = J0 == null ? void 0 : J0.meta) == null ? void 0 : Pe.captions,
              elements: h2
            };
          })
        );
      }
      if (h0) {
        const I0 = JSON.parse(await wt(h0, R0));
        return Array.isArray(I0) ? (await Promise.all(I0.map(async (C0, o2) => S0(C0, o2)))).flatMap((C0) => C0) : S0(I0, null);
      }
      return S0(s, null);
    })
  );
  if (L.every((N0) => N0.every((h0) => {
    const R0 = dt(h0.elements);
    return !(R0 != null && R0.value.src) && !(R0 != null && R0.value.playlist);
  }))) {
    const N0 = L.flatMap(
      (h0) => h0.map((R0) => {
        const S0 = dt(R0.elements);
        return !(S0 != null && S0.value.src) && !(S0 != null && S0.value.playlist) && (S0 == null ? void 0 : S0.value.id);
      }).filter(Boolean)
    ).join(", ");
    throw new Error(`Video(s) with ID ${N0} failed to load, video can not be processed`);
  }
  if (L.every((N0) => N0.every((h0) => h0.duration <= 0)))
    throw new Error("No scenes have any duration, video can not be processed");
  const u0 = L.reduce((N0, h0) => {
    const R0 = h0.filter((S0) => S0.duration > 0);
    return R0.length > 0 && (N0 = [...N0, R0]), N0;
  }, []), k0 = ((Y0 = G.meta) == null ? void 0 : Y0.frameRate) ?? 30, $ = ((R2 = G.meta) == null ? void 0 : R2.resolution) ?? 720, M0 = ((f2 = G.meta) == null ? void 0 : f2.transitionDuration) ?? 1 / 3, o0 = hu(u0, M0), q0 = Jt(o0);
  return {
    scenes: (await Promise.all(
      u0.map((N0, h0) => {
        const R0 = Jt(o0[h0]), S0 = Jt(o0.slice(0, h0));
        return Promise.all(
          N0.map(async ({ duration: I0, captions: C0, elements: o2 }, A0) => {
            var a2, h2;
            const w0 = await jt(), p0 = await jt(), n0 = await jt(), k2 = await jt(), x0 = dt(o2), D0 = Jt([...o0.slice(0, h0), ...o0[h0].slice(0, A0)]);
            return {
              draw: ({ canvas: J0, currentTime: V2 }) => {
                const B2 = Math.max(0, V2 - S0), H2 = Math.max(0, V2 - D0);
                $r({
                  debug: y,
                  canvas: J0,
                  cropCanvas: w0,
                  posterCanvas: k2,
                  letterboxCanvas: p0,
                  elements: o2,
                  currentTime: V2,
                  contentTime: B2,
                  sceneTime: H2,
                  totalDuration: q0,
                  contentDuration: R0,
                  sceneDuration: I0
                }), C0 && w && su({
                  canvas: J0,
                  dx: 0,
                  dy: 0,
                  dw: J0.width,
                  dh: J0.height,
                  vttCaptions: C0,
                  sceneTime: H2 + ((x0 == null ? void 0 : x0.meta.start) ?? 0)
                });
              },
              duration: I0,
              transitionCanvas: n0,
              start: D0,
              video: x0 == null ? void 0 : x0.video,
              videoMeta: x0 == null ? void 0 : x0.meta,
              audio: {
                duration: I0,
                src: (a2 = x0 == null ? void 0 : x0.value) == null ? void 0 : a2.src,
                start: (h2 = x0 == null ? void 0 : x0.meta) == null ? void 0 : h2.start
              }
            };
          })
        );
      })
    )).flatMap((N0) => N0),
    frameRate: k0,
    resolution: $,
    transitionDuration: M0,
    fonts: X.fonts ?? [],
    duration: q0
  };
}
const Mn = "2";
export {
  Mn as TEMPLATE_VERSION,
  br as appendFontFamilies,
  gu as crossFade,
  su as drawCaptions,
  $r as drawElements,
  Zn as drawVideoFormat,
  es as getSizeDetails,
  qf as normaliseAspectRatio,
  Kf as normaliseResolution,
  Pn as parseTimestamp,
  ru as supportedFonts,
  yu as templateToScenes,
  fu as vttToLines
};
//# sourceMappingURL=canvas-video.js.map
